export default {
  'pages.app.analysisType.cpChecklist.title': '前提条件チェックリスト',
  'pages.app.analysisType.cpChecklist.description':
    '選択した文書から前提条件のチェックリストを作成します。',
  'pages.app.analysisType.companyOverview.title': '会社概要',
  'pages.app.analysisType.companyOverview.description': '選択した文書から会社概要を作成します。',
  'pages.chat.promptLibrary.purposeRequired': 'このプロンプトの目的を入力してください。',
  'pages.chat.promptLibrary.metadataUnavailable':
    '一部のプロンプト設定を利用できません。保存するには、業務分野を少なくとも1つ選択する必要があります。',
  'pages.chat.promptLibrary.retryOptions': '再試行',
  'pages.chat.promptLibrary.tags': 'タグ',
  'pages.chat.promptLibrary.tagsRequired': 'タグを少なくとも1つ追加してください。',
  'pages.chat.promptLibrary.tagsPlaceholder': 'タグを選択または作成',
  'pages.chat.promptLibrary.practiceAreas': '業務分野',
  'pages.chat.promptLibrary.practiceAreasRequired': '業務分野を少なくとも1つ選択してください。',
  'pages.chat.promptLibrary.practiceAreasPlaceholder': '業務分野を選択',
  'pages.chat.promptLibrary.exampleTemplate':
    'タスク：[このプロンプトで実行するタスクを説明してください。]\n\n入力：[提供する文書や情報を指定してください。]\n\n要件：[構成、文体、制約、詳細の程度を説明してください。]\n\n以下を望ましい出力の例として使用してください。例の事実を繰り返すのではなく、新しい入力に合わせて調整してください：\n\n',
  'pages.chat.promptLibrary.discardTitle': 'このプロンプトの下書きを破棄しますか？',
  'pages.chat.promptLibrary.discardDescription': '編集内容はまだライブラリに保存されていません。',
  'pages.chat.promptLibrary.discard': '破棄',
  'pages.chat.promptLibrary.keepEditing': '編集を続ける',
  'pages.chat.promptLibrary.saved': 'プロンプトを個人ライブラリに保存しました。',
  'pages.chat.promptLibrary.viewLibrary': 'ライブラリを表示',
  'pages.chat.promptLibrary.saveFailed':
    'プロンプトを保存できませんでした。下書きは保持されています。再試行してください。',
  'pages.chat.promptLibrary.create': '再利用可能なプロンプトを作成',
  'pages.chat.promptLibrary.cancel': 'キャンセル',
  'pages.chat.promptLibrary.save': 'マイライブラリに保存',
  'pages.chat.promptLibrary.reviewTitle': '新しい会話でも使える内容にする',
  'pages.chat.promptLibrary.reviewDescription':
    '再利用可能な指示を残すか、有用な回答を例として使用してください。名前や案件固有の事実は、[契約書]などのプレースホルダーに置き換えてください。「上記」などの参照先を明確にしてください。チャット履歴と添付ファイルは含まれません。',
  'pages.chat.promptLibrary.original': '元のチャットテキスト',
  'pages.chat.promptLibrary.keepWording': '選択した文言を維持',
  'pages.chat.promptLibrary.useExample': '出力例として使用',
  'pages.chat.promptLibrary.exampleHelp':
    '同様の結果を得る方法を説明するため、以下のタスク、入力、要件を記入してください。',
  'pages.chat.promptLibrary.name': '名前',
  'pages.chat.promptLibrary.nameRequired': 'このプロンプトの名前を入力してください。',
  'pages.chat.promptLibrary.purpose': '目的',
  'pages.chat.promptLibrary.content': 'プロンプト',
  'pages.chat.promptLibrary.contentRequired': '保存する指示を入力してください。',
  'pages.adminManagement.groupName': 'グループ名',
  'pages.adminManagement.personalTag': '個人',
  'pages.adminManagement.owner': 'オーナー',
  'pages.adminManagement.deletedUserTag': '削除済みユーザー',
  'pages.adminManagement.members': 'メンバー',
  'pages.adminManagement.options': 'オプション',
  'pages.adminManagement.manageGroupTooltip': 'グループを管理',
  'pages.adminManagement.manageFilesTooltip': 'ファイルを管理',
  'pages.adminManagement.removeGroupTooltip': 'グループを削除',
  'pages.adminManagement.stats.totalUsers': '総ユーザー数',
  'pages.adminManagement.stats.totalGroups': '総グループ数',
  'pages.adminManagement.stats.personalGroups': '個人グループ',
  'pages.adminManagement.stats.sharedGroups': '共有グループ',
  'pages.adminManagement.stats.totalFiles': '総ファイル数',
  'pages.adminManagement.stats.totalFolders': '総フォルダ数',
  'pages.adminManagement.sharedTag': '共有',
  'pages.adminManagement.moveAll': 'すべて移動',
  'pages.adminManagement.fileDescription': '{username}・{action} {date}',
  'pages.adminManagement.fileAction.uploaded': 'アップロード',
  'pages.adminManagement.fileAction.created': '作成',
  'pages.adminManagement.createGroupButton': 'グループを作成',
  'pages.adminManagement.modifyUserGroupTitle': 'ユーザーグループを変更',
  'pages.adminManagement.createUserGroupTitle': 'ユーザーグループを作成',
  'pages.adminManagement.updateSubmitText': '更新',
  'pages.adminManagement.userGroupUpdatedSuccess': 'ユーザーグループを更新しました',
  'pages.adminManagement.userGroupCreatedSuccess': 'ユーザーグループを作成しました',
  'pages.adminManagement.groupNameRequiredMessage': 'グループ名を入力してください',
  'pages.adminManagement.ownerRequiredMessage': 'グループのオーナーを選択してください',
  'pages.adminManagement.membersRequiredMessage': 'グループのメンバーを選択してください',
  'pages.adminManagement.moveFolderTitle': 'フォルダを移動',
  'pages.adminManagement.moveFileTitle': 'ファイルを移動',
  'pages.adminManagement.allMovedSuccess': 'すべて移動しました',
  'pages.adminManagement.folderMovedSuccess': 'フォルダを移動しました',
  'pages.adminManagement.fileMovedSuccess': 'ファイルを移動しました',
  'pages.adminManagement.destinationGroupLabel': '移動先グループ',
  'pages.adminManagement.destinationGroupRequiredMessage': '移動先のグループを選択してください',
  'pages.adminManagement.destinationFolderPlaceholder': '移動先のフォルダを選択',
  'pages.adminManagement.renameOptionalLabel': '名前を変更（任意）',
  'pages.adminManagement.loadFolderDataError': 'フォルダデータの読み込みに失敗しました',
  'pages.adminManagement.ownerCannotBeRemovedWarning':
    'グループのオーナーをメンバーから外すことはできません',
  'pages.aISetting.promptCopied': 'プロンプトをコピーしました',
  'pages.aISetting.failedToCopyPrompt': 'プロンプトのコピーに失敗しました',
  'pages.aISetting.updatedByMeta': '{user} が {date} に更新',
  'pages.aISetting.updateButton': '更新',
  'pages.aISetting.systemPromptLabel': 'システムプロンプト',
  'pages.aISetting.additionalPromptLabel': '追加プロンプト',
  'pages.aISetting.temperatureLabel': 'Temperature',
  'pages.aISetting.updatedBadge': '更新しました',
  'pages.aISetting.requiredParamsMissing': '必須パラメーターが不足しています：{params}',
  'pages.angelInsider.micrositeFrameTitle': 'A&GEL Insider',
  'pages.angelInsider.nav.basics': '基本',
  'pages.angelInsider.nav.learnMore': '詳しく見る',
  'pages.angelInsider.nav.whatsNew': '新着情報',
  'pages.angelInsider.nav.futureStuff': '今後の予定',
  'pages.angelInsider.nav.logoAlt': 'A&GEL Insider',
  'pages.angelInsider.landing.tiles.basics.title': '基本',
  'pages.angelInsider.landing.tiles.basics.subtitle':
    'ここから始めましょう。初日から必要なものがすべて揃っています。',
  'pages.angelInsider.landing.tiles.learnMore.title': '詳しく見る',
  'pages.angelInsider.landing.tiles.learnMore.subtitle': 'さらに使いこなしたい方向けの強力な機能。',
  'pages.angelInsider.landing.tiles.whatsNew.title': '新着情報',
  'pages.angelInsider.landing.tiles.whatsNew.subtitle': '最近リリースされた機能と更新情報。',
  'pages.angelInsider.landing.tiles.comingUp.title': '今後の予定',
  'pages.angelInsider.landing.tiles.comingUp.subtitle': 'チームが次に開発しているもの。',
  'pages.angelInsider.landing.pills.all': 'すべて',
  'pages.angelInsider.landing.pills.chatAndContext': 'チャットとコンテキスト',
  'pages.angelInsider.landing.pills.filesAndVault': 'ファイルとボールト',
  'pages.angelInsider.landing.pills.promptLibrary': 'プロンプトライブラリ',
  'pages.angelInsider.landing.pills.quickInfo': 'クイック情報',
  'pages.angelInsider.landing.pills.scribe': 'スクライブ',
  'pages.angelInsider.landing.pills.disputeResolution': '紛争解決',
  'pages.angelInsider.landing.pills.sideBySide': '並べて比較',
  'pages.angelInsider.landing.pills.multiStepPrompt': 'マルチステッププロンプト',
  'pages.angelInsider.landing.pills.timeline': 'タイムライン',
  'pages.angelInsider.landing.pills.workstudio': 'ワークスタジオ',
  'pages.angelInsider.landing.pills.deepResearch': 'ディープリサーチ',
  'pages.angelInsider.landing.pills.scopeSummary': '業務範囲サマリー',
  'pages.angelInsider.landing.pills.review': 'レビュー',
  'pages.angelInsider.landing.pills.whatsNew': '新着情報',
  'pages.angelInsider.landing.pills.futureStuff': '今後の予定',
  'pages.angelInsider.landing.preferOneFeature': '一つずつ機能を学びたい方はこちら',
  'pages.angelInsider.landing.scrollFeatureList': '機能一覧をスクロール',
  'pages.angelInsider.basics.habits.habit1.num': '習慣 01',
  'pages.angelInsider.basics.habits.habit1.title': 'A&GEL に材料を与える',
  'pages.angelInsider.basics.habits.habit1.intro':
    '新しいユーザーが最もよく陥る誤りは、AI ツールに出発点として十分な情報を与えることの重要性を過小評価してしまうことです。',
  'pages.angelInsider.basics.habits.habit2.num': '習慣 02',
  'pages.angelInsider.basics.habits.habit2.title':
    'LLM は知識エンジンではなく「テキストプロセッサ」として使う',
  'pages.angelInsider.basics.habits.habit2.intro':
    '大規模言語モデル（LLM）が実際にどのようなものかを理解することが重要です。LLM は真実のデータベースでも、人間の判断の代替でもありません。むしろ、言語処理や基本的な認知タスクのための高速な CPU、つまりプロセッサだと考えてください。',
  'pages.angelInsider.basics.habits.habit3.num': '習慣 03',
  'pages.angelInsider.basics.habits.habit3.title': 'チャットだけで終わらせず、ほかの機能も試す',
  'pages.angelInsider.basics.heading': '基本',
  'pages.angelInsider.basics.welcome.intro':
    'ご参加いただきありがとうございます。A&GEL を使い始めるにあたり、よいスタートを切るためのいくつかの考え方をお伝えします。',
  'pages.angelInsider.basics.welcome.timeHeading':
    '新しいツールに慣れるには時間がかかります — それで構いません',
  'pages.angelInsider.basics.welcome.supportParagraph':
    '新しいテクノロジーに慣れるまで、最初は難しく感じられることは承知しています。私たちはあらゆる段階でみなさまをサポートします。ご質問がある場合、どこかでつまずいた場合、あるいは単に手順を一緒に確認してほしい場合も、遠慮なくお声がけください。',
  'pages.angelInsider.basics.welcome.differentParagraph':
    'A&GEL のような AI ツールは、これまでのツールとは<strong>異なります</strong>。<strong>あなた自身</strong>に直接力を与えるからです。手元に大勢のアシスタントがいるようなものだと考えてください。人間の判断に取って代わるわけではありませんが、多くの面で、一人では到底及ばないところまであなたの能力を引き上げてくれます。',
  'pages.angelInsider.basics.welcome.bestWayParagraph':
    '<strong>学び始める最良の方法は、A&GEL を実際に使ってみることです。</strong>ぜひ自由に触ってみてください。いろいろ試し、（安全な範囲で）失敗し、自分に合った使い方を見つけましょう。',
  'pages.angelInsider.basics.welcome.pacingHeading': '自分のペースで進めましょう',
  'pages.angelInsider.basics.welcome.staircaseParagraph':
    'スキルを身につけることは、階段を上るようなものだと考えてください。まずは基本から始め、自信がついてくれば、次の段階へ進むのはずっと自然に感じられるはずです。急ぐ必要はありません。これは競争ではないのですから、しっかりとした土台を築くために必要な時間をかけてください。',
  'pages.angelInsider.basics.welcome.togetherHeading': 'ともに進めば、もっと遠くへ',
  'pages.angelInsider.basics.welcome.togetherParagraph':
    'チームや事務所全体で A&GEL を活用すると、その効果は全員にとって相乗的に高まります。知識を共有し、ユーザーのコミュニティ全体で協力することが、波紋のように広がり、みんなを引き上げていきます。',
  'pages.angelInsider.basics.welcome.welcomeAboardParagraph':
    'ようこそ。A&GEL でどんなことが実現できるのか、私たちも楽しみにしています。',
  'pages.angelInsider.basics.welcome.signatureName': 'Kok Leong',
  'pages.angelInsider.basics.welcome.signatureTeam': 'A&GEL 開発チーム',
  'pages.angelInsider.basics.welcome.ctaLetsBegin': '始めましょう →',
  'pages.angelInsider.basics.habitsSection.title': '旅の指針となる 3 つの習慣',
  'pages.angelInsider.basics.habitsSection.intro':
    'A&GEL を使い始めるということは、チャットに質問を打ち込んで Enter を押すだけではありません。A&GEL のような AI ツールの力を本当に引き出すには、AI との関わり方についての考え方を変える必要があります。',
  'pages.angelInsider.basics.habitsSection.lockHint':
    'パネルをクリックすると表示領域を広げて固定できます。もう一度クリックすると解除されます。',
  'pages.angelInsider.reader.back': '← 戻る',
  'pages.angelInsider.reader.label': 'A&GEL INSIDER',
  'pages.angelInsider.reader.contents': '目次',
  'pages.angelInsider.reader.issueNumber': '第 {number} 号',
  'pages.angelInsider.reader.featureGuide': '機能ガイド',
  'pages.angelInsider.reader.minRead': '読了時間 {minutes} 分',
  'pages.angelInsider.reader.atAGlance': '概要',
  'pages.angelInsider.blockRenderer.supportedAlt': '対応',
  'pages.angelInsider.typewriterExample.badLabel': 'これでも構いません：',
  'pages.angelInsider.typewriterExample.goodLabel': 'ただし、こちらのほうが優れています：',
  'pages.angelInsider.basics.habits.labels.takeaways': '要点',
  'pages.angelInsider.basics.habits.labels.examples': '例',
  'pages.angelInsider.basics.habits.labels.benefits': 'メリット',
  'pages.angelInsider.basics.habits.habit1.tile.patternMatchers':
    'A&GEL のような AI ツールは人の心を読む存在ではなく、<strong>パターンを照合する存在</strong>です。漠然とした質問をすれば、返ってくるのは当たり障りのない答えです。豊かで具体的なコンテキストを与えれば、的確で実行に移せる結果が得られる可能性がぐっと高まります。',
  'pages.angelInsider.basics.habits.habit1.tile.callItContext':
    'この出発点を<strong>「コンテキスト」</strong>と呼ぶことにしましょう。',
  'pages.angelInsider.basics.habits.habit1.tile.rawMaterial':
    'コンテキストとは、A&GEL が扱う原材料だと考えてください。リーガルメモを起案するとき、「この判例を要約して」とだけ伝えるのではなく、判決文をアップロードし、気になる主要な事実上・法律上の論点を示し、想定読者が誰なのかを AI に伝えましょう（プロンプトライブラリにある、要約用に当社が用意した既成のプロンプトを使うこともできます）。一般に、与えるコンテキストが多いほど、A&GEL の性能は高まります。',
  'pages.angelInsider.basics.habits.habit1.tile.promptLibraryLink':
    'プロンプトライブラリについて詳しく見る',
  'pages.angelInsider.basics.habits.habit1.tile.empowerYou':
    'A&GEL のような AI ツールは<em>あなた自身</em>に直接力を与えます。あなたの能力を増幅してくれますが、それはあなたが方向性を示した場合に限られます。コンテキストがなければ、AI は事実関係の説明を受けていない優秀な弁護士、あるいは仕事に必要な背景情報を持たない有能な同僚のようなものです。',
  'pages.angelInsider.basics.habits.habit1.tile.vault.title':
    'ボールトは A&GEL 上のあなたの頭脳です',
  'pages.angelInsider.basics.habits.habit1.tile.vault.body':
    'ボールトは A&GEL にとって主要なコンテキストの供給源であり、信頼できる厳選されたナレッジベースに出力を根拠づけます。A&GEL はインターネットを検索せず、あなたがアップロードしたものの範囲内でのみ動作します。疲れを知らない同僚のようなものだと考えてください。無関係なファイルが散乱した机を渡せば仕事の質は落ち、関連する先例を 1 件渡せば仕事は鋭くなります。ファイルは論理的なサブフォルダに整理し、アップロードするものを厳選し、参照ファイル重みとセッションファイル重みを使って A&GEL が優先する対象を微調整してください。ボールトはゴミ捨て場ではなく、厳選された図書館のように扱いましょう。',
  'pages.angelInsider.basics.habits.habit1.tile.vault.link': 'ボールトについて詳しく見る',
  'pages.angelInsider.basics.habits.habit1.tile.documents.title':
    'プロンプトを送る前に A&GEL に特定のドキュメントを渡す',
  'pages.angelInsider.basics.habits.habit1.tile.documents.body':
    'ファイルをチャットにドラッグ＆ドロップしたり、ファイルを選択してチャットしたりすると、A&GEL の短期記憶にそのドキュメントの内容だけを読み込ませることになります。当社のワークショップに参加された方の多くは、私たちがそのファイルを「昨夜見たばかりの韓国ドラマの 1 話」（<em>今日はそれについてしか話したくない状態</em>）にたとえるのをお聞きになったことでしょう。これにより A&GEL は視野を絞り込み、正確な出力へと導くことができます。',
  'pages.angelInsider.basics.habits.habit1.tile.documents.link': 'コンテキストについて詳しく見る',
  'pages.angelInsider.basics.habits.habit1.tile.colleague.title':
    'A&GEL と働くことは、同僚と働くことと大きく変わりません',
  'pages.angelInsider.basics.habits.habit1.tile.colleague.body':
    'チームメンバーが仕事を進められるように情報を渡すのと同じことを、A&GEL に対しても行えばよいのです。',
  'pages.angelInsider.basics.habits.habit1.tile.query.title':
    'プロンプトそのものに含まれる問いや指示はどうでしょうか。それも「A&GEL に何かを与えること」に含まれますか？',
  'pages.angelInsider.basics.habits.habit1.tile.query.body':
    'はい。A&GEL のような AI ツールにとって、プロンプトは単なる語の連なりとして取り込まれ処理されます。つまり、プロンプト全体が AI ツール、すなわち A&GEL にとっての「コンテキスト」なのです。プロンプトで質問をしているのであれば、よりよい問いを立てれば、よりよい答えが返ってきます。',
  'pages.angelInsider.basics.habits.habit1.tile.query.link': 'プロンプトの書き方について詳しく見る',
  'pages.angelInsider.basics.habits.habit1.tile.benefitsIntro':
    'A&GEL に豊かなコンテキストを与えることで、次の効果が得られます：',
  'pages.angelInsider.basics.habits.habit1.tile.benefit1':
    '<strong>よりよい出力：</strong>具体的なコンテキストは具体的な結果を生みます。十分な説明を受けた A&GEL は、ゼロから始める同僚ではなく、すでに案件の事実関係を把握している同僚のように振る舞います。',
  'pages.angelInsider.basics.habits.habit1.tile.benefit2':
    '<strong>やり直しの削減：</strong>出発点が正確であるほど、プロンプトの再入力や修正に費やす時間は減ります。工程の早い段階で正しく仕上げましょう。',
  'pages.angelInsider.basics.habits.habit1.tile.benefit3':
    '<strong>よい意味での視野の絞り込み：</strong>プロンプトの前に特定のドキュメントをアップロードすると、A&GEL の焦点が固定されます。そのコンテキストの範囲内だけで動作するため、精度が高まり、出力のノイズが減ります。',
  'pages.angelInsider.basics.habits.habit1.examples.oneOff.bad':
    'A&GEL とのチャットを毎回使い捨てのものとして扱い、常にゼロから始めてしまう',
  'pages.angelInsider.basics.habits.habit1.examples.oneOff.good':
    'チームに加わった新しい同僚のように A&GEL を巻き込みましょう。作業を依頼する前に、案件、当事者、達成したいことについて手短に説明します。',
  'pages.angelInsider.basics.habits.habit1.examples.clause.bad':
    'A&GEL に「この条項をレビューして」と依頼する',
  'pages.angelInsider.basics.habits.habit1.examples.clause.good':
    '「［顧客］のために、［…］の観点からこの条項をレビューしてください」と伝え、レビューで注目すべき点（例：「報酬や金銭に関する問題点」）を明示します。',
  'pages.angelInsider.basics.habits.habit2.tile.intro':
    'LLM は情報の構造化、パターンの発見、文章の起案、複雑なデータの整理に長けています。それは<em>処理</em>のためのツールであり、<em>判断</em>のためのツールではありません。判断者であり、戦略家であり、最終的な権限を持つのは、依然としてあなたです。言い換え、要約、条項の抽出といった言語処理の重労働は AI が担い、あなたは専門知識を用いてその出力を検証します。この区別は極めて重要です。処理は AI に任せてよいのですが、判断を外注してはなりません。ガイドが述べているとおり、AI ツールは「人間の判断に取って代わるものではないかもしれませんが、多くの面であなたの能力を増幅します」。',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.title':
    '分解する（特に長いプロンプトの場合）',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.body':
    '多くのユーザーは A&GEL を単純なチャットボットのように扱い、長いプロンプトを 1 つ打ち込んでうまくいくことを期待します。これは A&GEL のような AI ツールの最適な使い方ではありません。上級者は複雑なタスクをより小さく扱いやすい単位に分解します。つまり、1 つの大きなプロンプトではなく、複数のサブプロンプトを使うのです。<em>分解</em>と呼ばれるこの手法は、多くの場合より質の高い結果につながります。',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.imageAlt': '1 つの長いプロンプト',
  'pages.angelInsider.basics.habits.habit2.tile.oneGoExample':
    '大規模で複雑な複合プロンプトを一度に実行する例：「ドキュメント 1 とドキュメント 2 から私の懸念点をすべて拾ったレポートを作成し、そのレポートを要約してエグゼクティブサマリーを作り、その後レポート全文とエグゼクティブサマリーを 1 つのドキュメントにまとめてください」。',
  'pages.angelInsider.basics.habits.habit2.tile.breakTaskIntro':
    'タスクをより小さな連続したステップに分解し、アプリのマルチステッププロンプトで実行しましょう。',
  'pages.angelInsider.basics.habits.habit2.tile.step1.title': 'ステップ 1：抽出',
  'pages.angelInsider.basics.habits.habit2.tile.step1.context':
    '入力コンテキスト：[<em>ドキュメント 1 とドキュメント 2 の本文を挿入</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step1.prompt':
    'プロンプト 1：「両方のドキュメントに記載されている懸念、論点、リスクをすべて網羅した箇条書きリストを作成してください。」',
  'pages.angelInsider.basics.habits.habit2.tile.step2.title': 'ステップ 2：レポート全文の起案',
  'pages.angelInsider.basics.habits.habit2.tile.step2.context':
    '入力コンテキスト：[<em>ステップ 1 の出力を挿入</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step2.prompt':
    'プロンプト 2：「この箇条書きリストを用いて、詳細かつ正式なレポートを作成してください。類似する懸念は関連する見出しの下にまとめてください。序文やエグゼクティブサマリーは含めないでください。」',
  'pages.angelInsider.basics.habits.habit2.tile.step3.title':
    'ステップ 3：エグゼクティブサマリーと最終的な統合',
  'pages.angelInsider.basics.habits.habit2.tile.step3.context':
    '入力コンテキスト：[<em>ステップ 2 の出力を挿入</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step3.prompt':
    'プロンプト 3：「まず、この正式なレポートについて 1 段落の簡潔なエグゼクティブサマリーを書いてください。次に、そのエグゼクティブサマリーを出力し、区切り線を入れ、その下に正式なレポートをそのまま出力して、1 つの統合ドキュメントを作成してください。」',
  'pages.angelInsider.basics.habits.habit2.tile.multiStepLink':
    'マルチステッププロンプトの完全な実例を見る',
  'pages.angelInsider.basics.habits.habit2.tile.reshape.title':
    'A&GEL を使って既存の文章を再構成・整形・発展させる',
  'pages.angelInsider.basics.habits.habit2.tile.reshape.body':
    '参考資料なしに複雑な法務文書をゼロから起案させるのではなく、必ず参考資料を与えたうえで、(i) A&GEL の言語処理能力を使って自分のドラフトのトーン・構成・書式を変えたり、複数のドラフトを統合したりする、あるいは (ii) 意図、方向性、含意といった二次的な性質を引き出す（例：複数の段落やドキュメントにまたがる調査結果からレビュー用チェックリストを作成する）ようにしましょう。',
  'pages.angelInsider.basics.habits.habit2.tile.benefitsIntro':
    'A&GEL をテキストプロセッサとして扱い、タスクを分解することで、次の効果が得られます：',
  'pages.angelInsider.basics.habits.habit2.tile.benefit1':
    '<strong>より質の高い出力：</strong>複雑なタスクをサブプロンプトに分解すると、A&GEL は一度に 1 つのことに集中できます。詰め込みすぎた 1 つのプロンプトの重みで破綻することなく、各ステップが前のステップの上に整然と積み上がります。',
  'pages.angelInsider.basics.habits.habit2.tile.benefit2':
    '<strong>より予測しやすい結果：</strong>各ステップを制御できれば、出力も制御できます。大きなプロンプト 1 つがうまく着地することを祈るのではなく、先へ進む前に検証できます。',
  'pages.angelInsider.basics.habits.habit2.tile.benefit3':
    '<strong>専門性のより有効な活用：</strong>言い換え、構造化、抽出といった言語処理の重労働は A&GEL が担います。あなたはレビュアー兼戦略家という、判断力が最も活きる役割に専念できます。',
  'pages.angelInsider.basics.habits.habit2.examples.nda.bad':
    'A&GEL に「ソフトウェアプロジェクト用の NDA を起案して」と依頼する',
  'pages.angelInsider.basics.habits.habit2.examples.nda.good':
    '「これが当社の標準 NDA テンプレートです［貼り付け］。秘密保持期間を 5 年に変更し、規制対応上の開示に関する適用除外を追加し、シンガポール法への言及をすべて香港法に置き換えてください。」',
  'pages.angelInsider.basics.habits.habit3.tile.intro':
    'ドキュメントのアップロード、特定のアプリや専門機能の利用、ステップによる機能の連結など、単純なチャットを超えた機能を試すことで、出力をきめ細かく制御できるようになります。',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.title': '試してみることが大切です',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.body':
    'ぜひ自由にほかの機能も試し、実験してみてください。専門モードにある機能の多くは、より高い精度と網羅性を重視して調整されています。自分のワークフローに最も合う機能を見つけ、失敗を恐れないでください。スキルを身につけることは階段を上るようなものです。まず基本から始めれば、自信がつくにつれて自然とより高度な手法へ進んでいけます。',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.closing':
    'コンテキストを使いこなし、テキストプロセッサとしての AI の役割（そして専門家としてのあなた自身の役割）を尊重し、複雑なタスクを分解することで、A&GEL は目新しい道具から、日々の業務に欠かせない存在へと変わります。',
  'pages.angelInsider.basics.habits.habit3.tile.swissArmy.title':
    'A&GEL はチャットボットというより、むしろ十徳ナイフです',
  'pages.angelInsider.basics.habits.habit3.tile.swissArmy.body':
    'すべての機能を 1 つのチャットウィンドウに詰め込むのではなく、複雑さを的確に切り分けるために設計された多彩なナレッジツール群を用意する。これは当初から私たちが選んだ設計方針です。チャットはブレインストーミングや簡単な質問には最適ですが、本当に大きなドキュメント（たとえば 2 万語を超えるもの）や、複雑な多段階・多部構成のタスクには向いていません。こうした強力なツールをチャットの中に隠すのではなく、左側のサイドバーの目立つ位置に配置しました。私たちの目標は、みなさまの具体的な業務目的と、適切な機能（またはその組み合わせ）とを結びつけるお手伝いをすることです。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.title':
    'チャット以外の機能も試してみましょう',
  'pages.angelInsider.basics.habits.habit3.tile.explore.review':
    'レビュー：構造化された質問リストを使った複数ドキュメントの分析、デューデリジェンス、複雑なファイルの読み解きに最適です。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.reviewLink': 'レビューについて詳しく見る',
  'pages.angelInsider.basics.habits.habit3.tile.explore.workStudio':
    'ワークスタジオ：自社の標準的な立場を自動的に反映させ、契約書の起案を標準化します。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.workStudioLink':
    'ワークスタジオについて詳しく見る',
  'pages.angelInsider.basics.habits.habit3.tile.explore.scribe':
    'スクライブ：音声ファイルを正確なテキストに書き起こします。ライブ文字起こしや、国際電話会議向けの同時翻訳にも対応しています。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.scribeLink': 'スクライブについて詳しく見る',
  'pages.angelInsider.basics.habits.habit3.tile.explore.quickInfo':
    'クイック情報／ガイド付き要約：任意の 1 つのドキュメントを、出典付きで素早く読み解きます。全体像をつかみたいときはクイック情報を、焦点を自分で定めたいときはガイド付き要約をお使いください。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.quickInfoLink':
    'クイック情報とガイド付き要約について詳しく見る',
  'pages.angelInsider.basics.habits.habit3.tile.explore.translation':
    '翻訳：法務・ビジネス文書向けに、段落単位で正確な専用の翻訳を提供します。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.apps':
    'アプリ：特定のタスクにおいて、より高い精度と網羅性を重視して調整されています。たとえばマルチステッププロンプトは、特定の論点についてドキュメントを分解するさまざまな分析ツールを備えており、チャットの能力を超える長く複雑な作業に必要な精度を提供します。',
  'pages.angelInsider.basics.habits.habit3.tile.benefitsIntro':
    'タスクを個々の機能に対応づけることで、次の効果が得られます：',
  'pages.angelInsider.basics.habits.habit3.tile.benefit1':
    '<strong>より高い制御性：</strong>単一のチャットインターフェースに頼るのではなく、目的に合ったツールを選ぶことで精度が高まります。',
  'pages.angelInsider.basics.habits.habit3.tile.benefit2':
    '<strong>スキルの向上：</strong>試してみることが何より大切です。さまざまな機能や組み合わせを試すうちに、A&GEL に何ができるのかという感覚が身についていきます。これは階段を上るようなものです。まずはチャットでの簡単な問い合わせから始め、スキルが伸びるにつれてアプリやレビューでの複雑な多段階分析へと進んでいきます。',
  'pages.angelInsider.basics.habits.habit3.tile.benefit3':
    '<strong>効率の向上：</strong>どのツールを使うべきか分かっていれば時間を節約できます。文字起こしならスクライブ、正確な言語変換なら翻訳といった専用機能に任せたほうがよい作業で、チャットのプロンプトに悪戦苦闘する必要がなくなります。',
  'pages.angelInsider.basics.habits.habit3.examples.chatOnly.bad':
    '90 ページの契約書や多段階の分析でさえ、チャットしか使わない',
  'pages.angelInsider.basics.habits.habit3.examples.chatOnly.good':
    '長い契約書にはレビューを、複数の段階があるタスクにはマルチステッププロンプトを試し、その作業ではどちらの機能がより速く、より正確に感じられたかを記録しておきましょう。',
  'pages.angelInsider.basics.habits.habit3.examples.paste.bad':
    '90 ページの契約書をチャットに貼り付けて「リスクは何ですか？」と尋ねる',
  'pages.angelInsider.basics.habits.habit3.examples.paste.good':
    '構造化された質問リストとともに「レビュー」にかけるか、アプリの「マルチステップ」を使い、ドキュメントをセクションごとに読み解いて、探しているものを正確に突き止めましょう。',
  'pages.angelInsider.seeMore': 'もっと見る',
  'pages.angelInsider.learnMore.heading': '詳しく見る',
  'pages.angelInsider.learnMore.intro':
    'チャット以外にも、A&GEL のアプリモードには目的特化のタスクが揃っています：ディープリサーチ、ガイド付き要約、クイック情報、タイムライン、期限の抽出。これらの機能は、正確さと事前準備に応えてくれます。',
  'pages.angelInsider.learnMore.featuredBadge': '注目',
  'pages.angelInsider.learnMore.cards.usingFiles.title': 'A&GEL でのファイルの使い方',
  'pages.angelInsider.learnMore.cards.usingFiles.body':
    'スキャンした紙資料は、A&GEL が読み取れるようにテキストレイヤーを付ける必要があります。Kofax で PDF を検索可能にしてからアップロードしてください。',
  'pages.angelInsider.learnMore.cards.workStudio.title': 'ワークスタジオ',
  'pages.angelInsider.learnMore.cards.workStudio.body':
    'チームの標準的な立場を一度登録しておけば、A&GEL が変更履歴付きの Word 文書を返します。',
  'pages.angelInsider.learnMore.cards.workStudio.imageAlt': 'ワークスタジオ',
  'pages.angelInsider.learnMore.cards.review.title': 'レビュー',
  'pages.angelInsider.learnMore.cards.review.body':
    '複数のドキュメントに対して複数の質問を一度に投げかけると、結果が引用付きの表として表示されます。ページを離れることなく、ミニチャットで追加の質問ができます。',
  'pages.angelInsider.learnMore.cards.review.imageAlt': 'レビューモード',
  'pages.angelInsider.learnMore.cards.dispute.title': '紛争解決',
  'pages.angelInsider.learnMore.cards.dispute.body':
    'ドキュメント一式を通じた、事件の要約、訴状の分析、答弁書の起案、訴答書面の追跡。',
  'pages.angelInsider.learnMore.cards.dispute.imageAlt': '訴答書面トラッカー',
  'pages.angelInsider.learnMore.cards.sideBySide.title': '並べて比較と比較',
  'pages.angelInsider.learnMore.cards.sideBySide.body':
    '出典段落まで検証できる、条項ごとのレビュー。比較機能は変更履歴や修正にも対応します。',
  'pages.angelInsider.learnMore.cards.sideBySide.imageAlt': '並べて比較の分析',
  'pages.angelInsider.learnMore.cards.multiStep.title': 'マルチステッププロンプト',
  'pages.angelInsider.learnMore.cards.multiStep.body':
    '複雑な法務タスクを連続したステップに分解し、各ステップを前の結果の上に積み上げます。',
  'pages.angelInsider.learnMore.cards.multiStep.imageAlt': 'アプリモード',
  'pages.angelInsider.learnMore.cards.timeline.title': 'タイムライン',
  'pages.angelInsider.learnMore.cards.timeline.body':
    '最大 100 件のドキュメントにまたがる時系列を、出典検証済みの 1 つのタイムラインにまとめます。',
  'pages.angelInsider.learnMore.cards.timeline.imageAlt': 'タイムライン',
  'pages.angelInsider.learnMore.cards.deepResearch.title': 'ディープリサーチ',
  'pages.angelInsider.learnMore.cards.deepResearch.body':
    '構造化されたリサーチプロンプトのもとで、ドキュメント横断の深い分析を実行します。すべての発見事項は、クリックできる引用を通じて出典段落にさかのぼれます。',
  'pages.angelInsider.learnMore.cards.deepResearch.imageAlt': 'ディープリサーチ',
  'pages.angelInsider.learnMore.cards.scopeSummary.title': '業務範囲サマリー',
  'pages.angelInsider.learnMore.cards.scopeSummary.body':
    '指定した重点領域に絞った構造化サマリーを作成します。抽出された各項目にはクリックできる引用が付き、出典と照合して確認できます。',
  'pages.angelInsider.learnMore.faq.heading': 'よくあるご質問',
  'pages.angelInsider.learnMore.faq.group1.kicker': '基本的な考え方',
  'pages.angelInsider.learnMore.faq.experts.question':
    '「専門家には常に専門家であってもらう」とはどういう意味ですか？',
  'pages.angelInsider.learnMore.faq.experts.answer':
    '専門家としてのあなたの判断、洞察、誠実さは、仕事の中心であり続けるべきです。A&GEL はあなたの専門性に取って代わるものではなく、より多くの材料でより多くを成し遂げるための支援を目的としています。',
  'pages.angelInsider.learnMore.faq.unfamiliar.question':
    'A&GEL に尋ねようとしている分野について、まったく知識がない場合はどうすればよいですか？',
  'pages.angelInsider.learnMore.faq.unfamiliar.answer':
    'その場合でも A&GEL は使えますが、より慎重になり、出力の確認をより丁寧に行ってください。チームに蓄積されたノウハウへの入り口として A&GEL を使い、必要なときに知見を得ることで、ご自身の学習と成長に役立てるのもよいでしょう。',
  'pages.angelInsider.learnMore.faq.group2.kicker': 'ファイル管理',
  'pages.angelInsider.learnMore.faq.referenceMaterial.question':
    'どのような参考資料を A&GEL にアップロードすべきですか？',
  'pages.angelInsider.learnMore.faq.referenceMaterial.answer':
    '信頼でき、確かで、正確な資料のみをアップロードしてください。一次法令資料（制定法、判例）や、信頼できる社内資料（社内ノウハウ、実績のある文書）などです。明確な命名規則を維持しましょう。',
  'pages.angelInsider.learnMore.faq.thirdParty.question':
    '第三者の文書をアップロードしてもよいですか？',
  'pages.angelInsider.learnMore.faq.thirdParty.answer':
    'はい。相手方代理人からの文書も含めて可能です。信頼できる先例と区別できるよう、明確にラベル付けしたフォルダにアップロードしてください。AI の利用や第三者コンテンツに関する社内規程があれば、それに従ってください。',
  'pages.angelInsider.learnMore.faq.processingTime.question':
    'アップロードしたファイルの処理に時間がかかるのはなぜですか？',
  'pages.angelInsider.learnMore.faq.processingTime.answer':
    'ドキュメントは A&GEL が扱える「エンベディング」に変換する必要があり、これはアップロード時に一度だけ行われます。チャットでは、コンテキストボタンから選択することで、アップロード済みのドキュメントを新しいセッションで再利用できます。',
  'pages.angelInsider.learnMore.faq.bulkUpload.question':
    'ドキュメントを一括でアップロードするにはどうすればよいですか？',
  'pages.angelInsider.learnMore.faq.bulkUpload.answer':
    'ファイルモードで右上のアップロードボタンをクリックし、ファイルを選択して「開く」を押してください。アップロード中も A&GEL を続けて使用できます。',
  'pages.angelInsider.learnMore.faq.sorting.question':
    '参考資料はどのように分類・管理すべきですか？',
  'pages.angelInsider.learnMore.faq.sorting.answer':
    'すべてを 1 つのフォルダにアップロードしないでください。(i) 主題と (ii) ワークフローでドキュメントをグループ分けしましょう。例：<code>ホーム / IP ライセンス / ライセンサー</code>。これにより A&GEL が適切なコンテキストを取得しやすくなり、出力の検証も容易になります。',
  'pages.angelInsider.learnMore.faq.group3.kicker': 'プロンプトの書き方',
  'pages.angelInsider.learnMore.faq.promptTypes.question':
    'どのような種類のプロンプトが使えますか？',
  'pages.angelInsider.learnMore.faq.promptTypes.answer':
    '情報収集型（質問形式、説明、調査）、タスク志向型（指示、多段階、テンプレート型）、分析型（データ分析、問題解決、比較）、分類型（分類、並べ替え、タグ付け）、変換型（翻訳、形式変換、文体変更）など、さまざまなプロンプトが使えます。',
  'pages.angelInsider.learnMore.faq.effectivePrompts.question':
    '効果的なプロンプトはどのように書けばよいですか？',
  'pages.angelInsider.learnMore.faq.effectivePrompts.answer':
    '最も効果的なプロンプトは 4 つの要素で構成されます。<strong>(a) ペルソナ</strong> — A&GEL に演じてほしい役割、<strong>(b) タスク</strong> — 具体的な指示、<strong>(c) コンテキスト</strong> — 背景情報と参考資料、<strong>(d) 形式</strong> — 出力をどのように構成してほしいか。',
  'pages.angelInsider.learnMore.faq.rag.question':
    'RAG とは何ですか。A&GEL はどのようなときに RAG を使いますか？',
  'pages.angelInsider.learnMore.faq.rag.answer':
    'RAG（検索拡張生成）は A&GEL のチャットにおける既定のモードです。ボールト内の参考資料を取り込み、プロンプトとともにモデルに渡すことで、出力の精度と信頼性を高めます。',
  'pages.angelInsider.learnMore.faq.allMaterials.question':
    'すべてのプロンプトで、アップロードした資料をすべて A&GEL に参照させないほうがよいのはなぜですか？',
  'pages.angelInsider.learnMore.faq.allMaterials.answer':
    '無関係なコンテキストを与えると、速度・精度・信頼性が低下します。A&GEL は確率的に動作するため、現在のタスクに適さない資料を参照してしまう可能性があります。コンテキストはプロンプトに関連するドキュメントだけに絞ってください。',
  'pages.angelInsider.learnMore.faq.selectMaterials.question':
    'プロンプトごとに関連する参考資料を選ぶにはどうすればよいですか？',
  'pages.angelInsider.learnMore.faq.selectMaterials.answer':
    'チャットモードで「コンテキスト」に移動し、選択アイコンをクリックして、関連するドキュメントまたはフォルダのみを選択してください。',
  'pages.angelInsider.learnMore.faq.group4.kicker': '出力の使い方',
  'pages.angelInsider.learnMore.faq.outputAsIs.question':
    'A&GEL の出力をそのまま使ってもよいですか？',
  'pages.angelInsider.learnMore.faq.outputAsIs.answer':
    'いいえ。A&GEL の出力は使用前に必ず確認してください。出発点として扱い、アップロードした参考資料を含め、信頼できる情報源と照合してください。',
  'pages.angelInsider.learnMore.faq.accuracy.question':
    '出力の正確性と信頼性はどのように確認すべきですか？',
  'pages.angelInsider.learnMore.faq.accuracy.answer':
    'チャットモードでは、出力に A&GEL が参照した出典ドキュメントへのリンクが含まれます。各参照をクリックして原典と照合してください。A&GEL はノウハウへの入り口であるべきで、ノウハウそのものの源ではありません。参照が付かない出力はハルシネーションが起きやすいため、十分なコンテキストを与えたうえでの純粋な執筆・整形・文章編集のためのプロンプトでない限り、使用しないでください。',
  'pages.angelInsider.learnMore.faq.group5.kicker': '用語集',
  'pages.angelInsider.learnMore.glossary.favouriteFileWeight.term': 'お気に入りファイル重み',
  'pages.angelInsider.learnMore.glossary.favouriteFileWeight.definition':
    '回答を生成する際に、ボールトで「お気に入り」に指定したドキュメントを A&GEL がどの程度優先するかを調整します。',
  'pages.angelInsider.learnMore.glossary.reRanking.term': '再ランキング',
  'pages.angelInsider.learnMore.glossary.reRanking.definition':
    '回答が生成される前に、最初の検索結果を見直して、最も関連性の高い条項やテキスト断片を優先する二次的な並べ替え処理です。',
  'pages.angelInsider.learnMore.glossary.searchRatio.term': '検索比率',
  'pages.angelInsider.learnMore.glossary.searchRatio.definition':
    'A&GEL がボールトをどれだけ広く検索するかを制御します。比率が高いほど広いコンテキストを、低いほど完全一致を重視します。',
  'pages.angelInsider.learnMore.glossary.systemPrompt.term': 'システムプロンプト',
  'pages.angelInsider.learnMore.glossary.systemPrompt.definition':
    'すべてのセッションにおいて A&GEL の役割、トーン、境界を定める基本指示です。',
  'pages.angelInsider.learnMore.glossary.thinking.term': '「思考」／「推論」',
  'pages.angelInsider.learnMore.glossary.thinking.definition':
    '最終的な回答を生成する前に A&GEL が内部で行う段階的な検討で、複雑な分析における誤りを減らすことを目的としています。',
  'pages.angelInsider.learnMore.issues.heading': '各号を読む',
  'pages.angelInsider.learnMore.issues.issue1.title': 'コンテキストが（ほぼ）すべて',
  'pages.angelInsider.learnMore.issues.issue1.description':
    '基本 • プロンプトの要点 • 2026 年 2 月 17 日',
  'pages.angelInsider.learnMore.issues.issue2.title': '紛争解決のユースケース',
  'pages.angelInsider.learnMore.issues.issue2.description':
    '事件の要約 • 訴答書面トラッカー • プロンプトのコツ • 2026 年 3 月 19 日',
  'pages.angelInsider.learnMore.issues.issue3.title':
    '新しいタイムラインとマルチステッププロンプトのアプリ',
  'pages.angelInsider.learnMore.issues.issue3.description':
    'メールのアップロード • スクライブの更新 • タイムラインの刷新 • 2026 年 3 月 19 日',
  'pages.angelInsider.learnMore.issues.issue4.title': 'スクライブのライブ翻訳とワークスタジオ',
  'pages.angelInsider.learnMore.issues.issue4.description':
    'ライブ翻訳 • ワークスタジオの新機能 • 2026 年 4 月 1 日',
  'pages.angelInsider.learnMore.issues.issue5.title': 'インライン参照、ミニチャットほか',
  'pages.angelInsider.learnMore.issues.issue5.description':
    'ピンサイト引用 • 移動できるミニチャット • スクライブのタイムスタンプ • 2026 年 4 月 10 日',
  'pages.angelInsider.learnMore.issues.pill': '第 {number} 号',
  'pages.angelInsider.whatsNew.heading': '新着情報',
  'pages.angelInsider.whatsNew.cards.msgUpload.title': '.msg メールのアップロード',
  'pages.angelInsider.whatsNew.cards.msgUpload.body':
    '.msg 形式のメールファイルを直接アップロードでき、添付ファイルもすべて読み取ります。',
  'pages.angelInsider.whatsNew.cards.inlineReferencing.title': 'インライン参照',
  'pages.angelInsider.whatsNew.cards.inlineReferencing.body':
    'ディープリサーチ、タイムライン、業務範囲サマリー、レビューに、クリックできるピンサイト引用が付きました。ページを離れずに、任意の出力を出典と照合できます。',
  'pages.angelInsider.comingUp.heading': '今後の予定',
  'pages.angelInsider.comingUp.intro':
    '次号の A&GEL Insider では、ワークスタジオをさらに掘り下げます。マルチステッププロンプトをゼロから組み立て、それを活用してチームの標準的な立場を反映した変更履歴付きのドラフトを生成する方法をご紹介します。どうぞご期待ください。',
  'pages.angelInsider.comingUp.cards.workstudioV2.title': 'ワークスタジオ V2',
  'pages.angelInsider.comingUp.cards.workstudioV2.body':
    'より高度なワークスタジオの作成ツールと、拡張された変更履歴出力。詳細は第 5 号で。',
  'pages.angelInsider.comingUp.cards.workstudioV2.badge': '近日公開',
  'pages.angelInsider.comingUp.cards.moreToCome.title': 'まだまだ続きます',
  'pages.angelInsider.comingUp.cards.moreToCome.body':
    'A&GEL チームは継続的に機能を提供しています。次号の Insider をお楽しみに。',
  'pages.angelInsider.comingUp.cards.moreToCome.badge': '開発中',
  'pages.angelInsider.issues.basics-intro.title': 'A&GEL へようこそ',
  'pages.angelInsider.issues.basics-intro.subtitle': 'よいスタートを切るためのいくつかの考え方。',
  'pages.angelInsider.issues.basics-intro.glance.0':
    '新しいツールに慣れるには時間がかかります。あらゆる段階で私たちがサポートします。',
  'pages.angelInsider.issues.basics-intro.glance.1':
    'A&GEL のツールは、一人では到底及ばないところまで<strong>あなたの能力を増幅します</strong>。',
  'pages.angelInsider.issues.basics-intro.glance.2':
    '学ぶ最良の方法は<strong>A&GEL を使い始めること</strong>です。自由に試し、失敗しましょう。',
  'pages.angelInsider.issues.basics-intro.glance.3':
    'チームがともに A&GEL を活用すれば、その効果は全員にとって相乗的に高まります。',
  'pages.angelInsider.issues.basics-intro.sections.0.kicker': '01 — はじめに',
  'pages.angelInsider.issues.basics-intro.sections.0.heading':
    '新しいツールに慣れるには時間がかかります — それで構いません',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.0.p':
    'ご参加いただきありがとうございます。A&GEL を使い始めるにあたり、よいスタートを切るためのいくつかの考え方をお伝えします。',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.1.p':
    '新しいテクノロジーに慣れるまで、最初は難しく感じられることは承知しています。私たちはあらゆる段階でみなさまをサポートします。ご質問がある場合、どこかでつまずいた場合、あるいは単に手順を一緒に確認してほしい場合も、遠慮なくお声がけください。',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.3.p':
    'A&GEL のような AI ツールは、これまでのツールとは<strong>異なります</strong>。<strong>あなた自身</strong>に直接力を与えるからです。手元に大勢のアシスタントがいるようなものだと考えてください。人間の判断に取って代わるわけではありませんが、多くの面で、一人では到底及ばないところまであなたの能力を引き上げてくれます。',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.4.p':
    '<strong>学び始める最良の方法は、A&GEL を実際に使ってみることです。</strong>ぜひ自由に触ってみてください。いろいろ試し、（安全な範囲で）失敗し、自分に合った使い方を見つけましょう。',
  'pages.angelInsider.issues.basics-intro.sections.1.kicker': '02 — スキルの習得',
  'pages.angelInsider.issues.basics-intro.sections.1.heading': '自分のペースで進めましょう',
  'pages.angelInsider.issues.basics-intro.sections.1.blocks.0.p':
    'スキルを身につけることは、階段を上るようなものだと考えてください。まずは基本から始め、自信がついてくれば、次の段階へ進むのはずっと自然に感じられるはずです。急ぐ必要はありません。これは競争ではないのですから、しっかりとした土台を築くために必要な時間をかけてください。',
  'pages.angelInsider.issues.basics-intro.sections.2.kicker': '03 — コミュニティ',
  'pages.angelInsider.issues.basics-intro.sections.2.heading': 'ともに進めば、もっと遠くへ',
  'pages.angelInsider.issues.basics-intro.sections.2.blocks.0.p':
    'チームや事務所全体で A&GEL を活用すると、その効果は全員にとって相乗的に高まります。知識を共有し、ユーザーのコミュニティ全体で協力することが、波紋のように広がり、みんなを引き上げていきます。',
  'pages.angelInsider.issues.basics-intro.signoff.line':
    'ようこそ。A&GEL でどんなことが実現できるのか、私たちも楽しみにしています。',
  'pages.angelInsider.issues.basics-intro.signoff.name': 'Kok Leong<br>A&GEL 開発チーム',
  'pages.angelInsider.issues.issue-1.title': 'コンテキストが（ほぼ）すべて',
  'pages.angelInsider.issues.issue-1.subtitle':
    'プロンプトの要点 — コンテキストの選び方が A&GEL の返すものすべてを左右します。',
  'pages.angelInsider.issues.issue-1.date': '2026 年 1 月 15 日',
  'pages.angelInsider.issues.issue-1.glance.0':
    'チャットに専用の<strong>コンテキスト</strong>ボタンと<strong>「コンテキスト %」</strong>インジケーターが追加されました。',
  'pages.angelInsider.issues.issue-1.glance.1':
    '検索パラメーターの既定値が<strong>コンテキストなし</strong>になりました。処理が速く、校正や軽微な編集に最適です。',
  'pages.angelInsider.issues.issue-1.glance.2':
    '日常業務向けに、ボールトから<strong>既定のコンテキストプリセット</strong>を作成しましょう。',
  'pages.angelInsider.issues.issue-1.glance.3':
    'コンテキストのないプロンプトは単なる当て推量です。あなたしか持っていない背景情報を必ず与えてください。',
  'pages.angelInsider.issues.issue-1.sections.0.kicker': '01 — チャット',
  'pages.angelInsider.issues.issue-1.sections.0.heading':
    'チャットのコンテキスト：専用ボタンと「コンテキスト %」インジケーター',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.0.p':
    'A&GEL のチャット機能は、カスタマイズされた<strong>検索拡張生成（RAG）</strong>パイプラインを使用します。ボールト内のノウハウや参考資料を取り込み、それをモデルに渡して出力を生成します。RAG の品質を左右する最も重要な要素は<em>コンテキストの選択</em>、つまり回答をボールトのどれだけの範囲から引き出すかです。',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.1.p':
    'これを可視化するため、<strong>「コンテキスト %」</strong>インジケーターを追加しました。現在のチャットセッションでボールトのどれだけが対象になっているかを、おおまかにではあれ一目で把握できる指標です。コンテキストボタンをクリックすると、どのフォルダやファイルを対象にするかを正確に選択できます。',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.2.callout.title':
    '新しい既定値：コンテキストなし',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.2.callout.body':
    '検索パラメーターの既定値が「コンテキストなし」になりました（チャットウィンドウの右上）。この設定ではチャットが高速になり、学習済みの一般知識のみから生成するため、校正や編集上の修正といった単純な問い合わせに最適です。コンテキストなしの設定であれば、A&GEL は数秒以内に応答するはずです。',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.3.h':
    '日常業務向けに既定のコンテキストを設定する',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.4.p':
    'A&GEL は<em>あなた自身の</em>ノウハウから回答するため、既定のコンテキストプリセットを作成できます。コンテキストボタンをクリックしてフォルダを選択し、プラス（+）ボタンを押します。プリセットに名前を付け、必要に応じて<strong>「デフォルトに設定」</strong>にチェックを入れて OK をクリックしてください。',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.5.p':
    '<strong>すべての</strong>フォルダを選択する（コンテキスト 100%）と、A&GEL はすべてのドキュメントを検索するため動作が遅くなります。範囲が広ければよいというものではありません。個々の問い合わせに合わせてコンテキストを調整してください。アクセスできるファイル数や問い合わせの複雑さによっては、応答に最大 1 分ほどかかることがあります。',
  'pages.angelInsider.issues.issue-1.sections.1.kicker': '02 — プロンプト',
  'pages.angelInsider.issues.issue-1.sections.1.heading':
    'プロンプトには必ず自分のコンテキストを添える',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.0.quote':
    'コンテキストのないプロンプトは単なる当て推量、いわば「プロンプト・ルーレット」です。',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.1.p':
    'プロンプトを効果的にするには、適切な情報を与える必要があります。専門性の高い領域ではなおさらです。A&GEL は全体像を必要とする有能なアシスタントだと考えてください。あなたしか知らない背景、すなわち主要な目標、成功の指標、さらには「よい」回答と「よくない」回答の例までも提供しましょう。',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.2.h':
    'より豊かなプロンプトのためのシンプルな枠組み',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.3.p':
    '十分なコンテキストを与えられているか、常に自問し続けてください。ここがあなたの専門知識を発揮する場であり、基本的なプロンプトとの結果の差が歴然と表れるところです。',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.4.callout.title': '訴訟業務での例',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.4.callout.body':
    '訴訟実務家は、プロンプトを複製して角括弧の部分を案件に合わせて編集することで、はるかに鋭い出力を得ています。法的コンテキスト（適用される法の簡潔な要約）と商業的コンテキスト（周辺事実）を多く与えるほど、そのプロンプトは分析ツールとしてよく機能します。',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.5.p':
    '自分のコンテキストを最もよく知っているのはあなたです。プロンプト、質問リスト、カスタム指示の効果を引き出すコンテキストを、常に具体的に添えてください。',
  'pages.angelInsider.issues.issue-1.sections.2.kicker': '03 — はじめましょう',
  'pages.angelInsider.issues.issue-1.sections.2.heading': 'お困りですか？',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.title':
    '問題が起きたら、3 点をお知らせください',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.body':
    'A&GEL 開発担当までメッセージまたはメールでご連絡ください。以下の内容で十分です：',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.0':
    '<strong>日時</strong> — 例：「今日の 16 時 31 分に開始したチャット」',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.1':
    '<strong>問題が起きた機能</strong> — 例：「分析 → ディープリサーチでファイルをアップロードしようとしたが、読み込まれなかった」',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.2':
    '<strong>簡単な説明</strong>またはスクリーンショット',
  'pages.angelInsider.issues.issue-1.signoff.line':
    'それでは。コンテキストを第一に、をお忘れなく。',
  'pages.angelInsider.issues.issue-1.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.issue-2.title': '紛争解決のユースケース',
  'pages.angelInsider.issues.issue-2.subtitle':
    '要約や初稿の作成、訴答書面の分析と追跡、さらにプロンプトのコツをご紹介します。',
  'pages.angelInsider.issues.issue-2.date': '2026 年 2 月 12 日',
  'pages.angelInsider.issues.issue-2.glance.0':
    '2 種類の<strong>判例要約</strong>プロンプト（簡潔版と詳細版）。複雑な判決では詳細版が力を発揮します。',
  'pages.angelInsider.issues.issue-2.glance.1':
    '<strong>答弁書</strong>やクライアント向け<strong>法務アップデート</strong>を起案するプロンプト。',
  'pages.angelInsider.issues.issue-2.glance.2':
    '<strong>訴答書面を分析する</strong>一連のプロンプト — 訴状、答弁書、記載の十分性。',
  'pages.angelInsider.issues.issue-2.glance.3':
    '<strong>レビューモード</strong>を、複数ドキュメントにまたがる訴答書面トラッカーとして活用。',
  'pages.angelInsider.issues.issue-2.sections.0.kicker': '01 — 要約',
  'pages.angelInsider.issues.issue-2.sections.0.heading': '判例の要約を作成する',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.0.p':
    '判例を要約するためのプロンプトを 2 種類用意しました。1 つは簡潔な概観向け、もう 1 つはより詳細な分析向けです。いずれも SAL が公開したプロンプトを基に、生成 AI を使って（A&GEL 自身に出力を批評させることも含めて）改良したものです。',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.1.p':
    '私たちの経験では、<strong>詳細版</strong>の判例要約のほうが総じて優れており、特に複雑な判決で効果を発揮します。A&GEL は元の判決文<em>のみ</em>に依拠するよう指示されていますが、<em>ratio decidendi</em>（判決理由）と<em>obiter dicta</em>（傍論）の区別は苦手な場合がある点にご留意ください。',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.2.callout.title': '万能薬ではありません',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.2.callout.body':
    '出力は従来どおりレビューと検証が必要で、正確性と網羅性を十分に確認しなければなりません。これらのプロンプトが提供するのは効率的な出発点であって、完成した成果物ではありません。',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.3.p':
    'これらは（アプリ内の）<strong>ガイド付き要約</strong>機能と組み合わせてお使いください。この機能は、プロンプトに沿って 1 つのドキュメントを要約します。シンガポールの裁判所の判決をアップロードし、判例要約（詳細版）のプロンプトを選び、気になる論点を追記してください。',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.4.figure.caption':
    'プロンプトライブラリ内の判例要約（簡潔版）v1.1 と判例要約（詳細版）v1.1。',
  'pages.angelInsider.issues.issue-2.sections.1.kicker': '02 — 起案',
  'pages.angelInsider.issues.issue-2.sections.1.heading': '初稿を作成する',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.0.p':
    '（SAL が公開したプロンプトを基にした）あるプロンプトは、訴状に対する<strong>答弁書</strong>の初稿を生成します。複製して自分用に調整し、十分なコンテキストを必ず盛り込んでください。',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.1.p':
    'もう 1 つのプロンプトは、判例要約からクライアント向けの<strong>法務アップデート</strong>を作成します。ナレッジマネジメントの短いサンプル記事が、文体・構成・トーンの指針となります。',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.2.gallery.0.caption':
    '訴状に対する答弁書を起案する。',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.2.gallery.1.caption':
    '参照記事の文体とトーンに合わせて起案する v1.2。',
  'pages.angelInsider.issues.issue-2.sections.2.kicker': '03 — 訴答書面',
  'pages.angelInsider.issues.issue-2.sections.2.heading': '訴答書面を分析する',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.0.p':
    '訴答書面の分析用プロンプトをいくつか用意しました。これらの検証はまだ限定的です。ぜひ試し、複製して改良し、ほかのユーザーと共有してください。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.0':
    '<strong>訴状の分析</strong> — エグゼクティブサマリー、時系列、2021 年民事訴訟規則に照らした記載の十分性、主要な論点と予備的抗弁、直ちに取るべき対応と次のステップ。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.1':
    '<strong>答弁書の分析</strong> — 防御戦略を抽出し、訴状の主張に具体的に応答していない箇所を洗い出します。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.2':
    '<strong>訴答記載の十分性</strong> — もともと答弁書を評価するために作られたものです。レビュー対象の書面に合わせて複製・調整してください。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.0.caption':
    '訴状の分析と時系列 v1.5。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.1.caption':
    '訴状に対する答弁書の分析 v1.0。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.2.caption':
    '答弁書における訴答記載の十分性 v1.0。',
  'pages.angelInsider.issues.issue-2.sections.3.kicker': '04 — レビューモード',
  'pages.angelInsider.issues.issue-2.sections.3.heading': 'レビューを訴答書面トラッカーとして使う',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.0.p':
    '紛争の全期間を通じた各当事者の主張を一目で把握できます。<strong>レビューモード</strong>では、訴状の各請求原因を指針となる質問として扱い、訴答書面や陳述書で展開された主張を体系的に検討・吟味しましょう。',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.1.h':
    'ステップ 1 — チャットで質問リストを作成する',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.2.p':
    '訴状をファイルに、または直接チャットにアップロードし、請求原因を抽出するプロンプトを実行します：',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.3.prompt.label': '質問リスト生成プロンプト',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.3.prompt.text':
    'あなたは 20 年の経験を持つ訴訟弁護士です。深呼吸をして集中してください。\n\nアップロードされたドキュメントは訴状です。あなたの任務は、箇条書きの要約を作成することです。各項目には、(a) 1 つの請求原因、(b) その相手方となる被告、(c) 依拠している事実上の主張、(d) 求められている救済を含めてください。各項目の下位要素はすべて同じ箇条内に記載し、下位レベルの箇条書きは使わないでください。ドキュメントからすべての内容を抽出してください。被告が複数いる場合は、第 1 被告に対するすべての請求原因を扱ってから第 2 被告に進み、以下同様に続けてください。\n\n網羅的かつ簡潔に：各請求原因に直接関係する内容はすべて要約し、参照してください。正確に：曖昧な表現を避け、ドキュメントの文言を用いてください。',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.4.h':
    'ステップ 2 — レビューでそのリストを訴答書面に対して実行する',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.5.p':
    '生成されたリストをコピーし、<strong>レビュー</strong>に切り替えて<strong>クイック質問</strong>をクリックします。<em>質問を追加</em>にリストを貼り付け、<em>追加 +</em> をクリックし、訴状を添付して送信を押してください。',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.6.gallery.0.caption':
    'レビューモード — 質問リストをクイック質問のマトリックスとして追加する。',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.7.callout.title': '訴答書面にとどまらず',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.7.callout.body':
    '多数のドキュメントに多数の質問を投げかけられるレビューの特性は、ほかのドキュメント集約的な業務にも適しています。証拠開示、文書レビュー、膨大な陳述書の検討などです。',
  'pages.angelInsider.issues.issue-2.sections.4.kicker': '05 — 作り込み',
  'pages.angelInsider.issues.issue-2.sections.4.heading': 'プロンプトのコツ：検証と改善',
  'pages.angelInsider.issues.issue-2.sections.4.blocks.0.p':
    '<strong>プロンプトを検証する。</strong>A&GEL の出力を、あらかじめ用意しておいた模範解答と比べてプロンプトを評価しましょう。近い内容であれば、そのプロンプトはよくできていると考えられます。そうでなければ、足りない点を特定してコンテキストを追加してください。',
  'pages.angelInsider.issues.issue-2.sections.4.blocks.1.p':
    '<strong>プロンプトを改善する。</strong>プロンプトライブラリにある <em>Improve My Prompt v1.0</em> ツールを使って、さらに磨きをかけましょう。',
  'pages.angelInsider.issues.issue-2.signoff.line':
    '複製し、調整し、うまくいったものを共有しましょう。',
  'pages.angelInsider.issues.issue-2.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-scribe.title': 'スクライブ',
  'pages.angelInsider.issues.feature-scribe.subtitle':
    '会議の録音、文字起こし、リアルタイム翻訳、編集をひとつの場所で。',
  'pages.angelInsider.issues.feature-scribe.glance.0':
    '<strong>ライブ編集</strong> — スクライブが録音している最中に文字起こしを編集できます。編集箇所には下線が付きます。',
  'pages.angelInsider.issues.feature-scribe.glance.1':
    '<strong>音声再生</strong> — 文字起こしの任意の部分をクリックすると、その箇所から録音を再生できます。',
  'pages.angelInsider.issues.feature-scribe.glance.2':
    '<strong>ライブ翻訳</strong> — 選んだ言語にリアルタイムで翻訳します。',
  'pages.angelInsider.issues.feature-scribe.glance.3':
    '<strong>タイムスタンプ付きダウンロード</strong> — 書き出した Word の文字起こしにはタイムスタンプが入り、目的の箇所を探しやすくなります。',
  'pages.angelInsider.issues.feature-scribe.sections.0.kicker': 'スクライブ',
  'pages.angelInsider.issues.feature-scribe.sections.0.heading': 'ライブ編集と音声再生',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.0.p':
    '<strong>ライブ編集</strong> — 改良されたスクライブでは文字起こしを編集でき、編集箇所には参照しやすいよう下線が付きます。<strong>音声再生</strong> — 文字起こしを保存した後、元の文字起こしを開いて任意の部分をクリックすると、その箇所から録音を再生できます。',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.1.gallery.0.caption':
    '録音中のスクライブと、リアルタイムの文字起こし。',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.1.gallery.1.caption':
    '元の文字起こし — 任意の部分をクリックすると音声が再生されます。',
  'pages.angelInsider.issues.feature-scribe.sections.1.kicker': 'スクライブ',
  'pages.angelInsider.issues.feature-scribe.sections.1.heading': 'ライブ翻訳がスクライブに登場',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.0.p':
    '通話や会議を、選んだ言語で理解できます。<strong>ライブ翻訳</strong>のチェックボックスをオンにして言語を選ぶと、A&GEL が元の文字起こしの下に翻訳をその場で表示します。',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.1.figure.caption':
    'ライブ翻訳を有効にして、ドロップダウンから言語を選択する。',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.2.p':
    'A&GEL が文字起こしと翻訳を行っている間も、メモを入力したり文字起こしを直接修正したりできます。あなたの編集は A&GEL のテキストと区別できるよう<strong>黄色</strong>で表示されます。保存された文字起こしには、翻訳とあなたの編集の両方が残ります。',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.3.gallery.0.caption':
    '元の文字起こしの下に表示されるライブ翻訳と、黄色で示された編集可能なメモ。',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.3.gallery.1.caption':
    '元の文字起こしの左側にタイムスタンプが並びます。',
  'pages.angelInsider.issues.feature-scribe.sections.2.kicker': 'スクライブ',
  'pages.angelInsider.issues.feature-scribe.sections.2.heading':
    'ダウンロードできる文字起こしに、タイムスタンプが追加',
  'pages.angelInsider.issues.feature-scribe.sections.2.blocks.0.p':
    'スクライブの文字起こしには、ダウンロードした Word 文書内に<strong>タイムスタンプ</strong>が含まれるようになりました。録音された会話や会議の特定の場面にたどり着きやすくなる目印です。',
  'pages.angelInsider.issues.feature-scribe.sections.2.blocks.1.figure.caption':
    'タイムスタンプと翻訳が保持された、ダウンロード済みのスクライブ文字起こし。',
  'pages.angelInsider.issues.feature-scribe.signoff.line': '録音し、見直し、再生する。',
  'pages.angelInsider.issues.feature-scribe.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-prompt-library.title': 'プロンプトライブラリ',
  'pages.angelInsider.issues.feature-prompt-library.subtitle':
    'コミュニティが作ったプロンプトを見つけ、複製し、調整する。付属ツールでさらに磨きをかけましょう。',
  'pages.angelInsider.issues.feature-prompt-library.glance.0':
    'プロンプトライブラリでコミュニティ製のプロンプトを閲覧・複製し、自分の案件に合わせて調整できます。',
  'pages.angelInsider.issues.feature-prompt-library.glance.1':
    '<strong>プロンプトを検証する</strong> — A&GEL の出力を、あらかじめ用意した模範解答と比べましょう。',
  'pages.angelInsider.issues.feature-prompt-library.glance.2':
    '期待どおりに機能しないプロンプトは、プロンプトライブラリの <strong>Improve My Prompt v1.0</strong> でさらに改善しましょう。',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.kicker': '作り込み',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.heading':
    'プロンプトのコツ：検証と改善',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.0.p':
    '<strong>プロンプトを検証する。</strong>プロンプトの有効性を測るよい方法は、A&GEL の出力を、あらかじめ用意した「模範解答」や参照用の出力と比べることです。',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.1.p':
    'たとえば、判例を要約するプロンプトを開発しているなら、以前自分で作成した、内容をよく分かっている判例要約を基準として参照しましょう。要約プロンプトを実行し、A&GEL の出力をその過去の成果物と比較します。出力が基準に近ければ、そのプロンプトはよくできていると考えられます。そうでなければ、具体的に何が足りないのかを特定し、たとえばコンテキストを追加するなどしてプロンプトを改良してください。',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.2.p':
    '<strong>プロンプトを改善する。</strong>プロンプトライブラリにある <em>Improve My Prompt v1.0</em> ツールを使って、さらに磨きをかけることをご検討ください。',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.3.figure.caption':
    'Improve My Prompt v1.0 — ライブラリ内の既存プロンプトを改良する。',
  'pages.angelInsider.issues.feature-prompt-library.signoff.line':
    '複製し、調整し、うまくいったものを共有しましょう。',
  'pages.angelInsider.issues.feature-prompt-library.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-prompting.title': 'プロンプトの書き方',
  'pages.angelInsider.issues.feature-prompting.subtitle':
    'コンテキストのないプロンプトは当て推量です。それを変える枠組みをご紹介します。',
  'pages.angelInsider.issues.feature-prompting.glance.0':
    '効果的なプロンプトには必ず 4 つの要素があります：<strong>ペルソナ、タスク、コンテキスト、形式</strong>。',
  'pages.angelInsider.issues.feature-prompting.glance.1':
    'コンテキストは<em>あなた</em>にしか提供できない部分であり、専門性が差を生むところです。',
  'pages.angelInsider.issues.feature-prompting.glance.2':
    'コンテキストのないプロンプトは「プロンプト・ルーレット」です。形式上は成り立っていても、有用な出力にはつながりにくいものです。',
  'pages.angelInsider.issues.feature-prompting.glance.3':
    'ライブラリからプロンプトを複製し、案件固有の事実や法的枠組みに合わせて調整しましょう。',
  'pages.angelInsider.issues.feature-prompting.sections.0.kicker': '01 — 枠組み',
  'pages.angelInsider.issues.feature-prompting.sections.0.heading':
    'ペルソナ、タスク、コンテキスト、形式',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.0.p':
    '効果的なプロンプトには必ず 4 つの要素があります。チェックリストとして考えてください：',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.1.p':
    '<strong>ペルソナ</strong> — A&GEL にどのような役割を担ってほしいかを伝えます。<em>「あなたは 20 年の経験を持つ訴訟弁護士です。」</em>これが出力のトーン、深さ、具体性を形づくります。',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.2.p':
    '<strong>タスク</strong> — 何をしてほしいのかを、明確かつ具体的に記述します。',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.3.p':
    '<strong>コンテキスト</strong> — あなたにしか提供できない部分です。具体的な法的枠組み、商業上の事実、案件を取り巻く状況など。コンテキストのないプロンプトは単なる当て推量であり、私たちはこれを「プロンプト・ルーレット」と呼んでいます。A&GEL の出力の質は、あなたが与えるコンテキストの質に正比例します。',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.4.p':
    '<strong>形式</strong> — 出力をどのように構成してほしいかを指定します。番号付きリストでしょうか。表でしょうか。条項のドラフトでしょうか。簡潔な段落でしょうか。指定しなければ、A&GEL は既定の一般的な形式を使うため、あなたのワークフローに合わないかもしれません。',
  'pages.angelInsider.issues.feature-prompting.sections.1.kicker': '02 — 実践でのコンテキスト',
  'pages.angelInsider.issues.feature-prompting.sections.1.heading': 'コンテキストがもたらす違い',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.0.p':
    'A&GEL は、最良の仕事をするために全体像を必要とする有能なアシスタントだと考えてください。単純な質問をするのではなく、あなたしか知らない具体的な背景 — 主要な目標、案件の事実、「よい」回答と「よくない」回答の姿 — を提供しましょう。',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.1.p':
    '法的内容（例：適用される法分野の簡潔な要約）や商業的コンテキスト（例：取引や紛争を取り巻く事実）を多く提供するほど、出力は有用になります。そうしたコンテキストが与えられると、基本的なプロンプトと比べて結果の質は歴然と変わります。',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.2.callout.title': '判例要約での例',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.2.callout.body':
    '判例要約のプロンプトを使うときは、関心のある法的論点の概要 — たとえば ratio decidendi と obiter dicta の区別など — を書き添えてください。ライブラリからプロンプトを複製し、自分の着眼点に合わせて編集すれば、そのまま使うよりはるかに的を絞った出力が得られます。',
  'pages.angelInsider.issues.feature-prompting.sections.2.kicker': '03 — 検証と改善',
  'pages.angelInsider.issues.feature-prompting.sections.2.heading': '基準と比べ、そして磨く',
  'pages.angelInsider.issues.feature-prompting.sections.2.blocks.0.p':
    'すでに手元にある「模範解答」— 自分で作成した判例要約や、以前起案した条項など — と比べてプロンプトを検証しましょう。プロンプトを実行し、その出力を基準と比較します。一致していれば、そのプロンプトはよくできています。そうでなければ、具体的に何が足りないのかを特定し、それに応じてコンテキストを追加してください。',
  'pages.angelInsider.issues.feature-prompting.sections.2.blocks.1.p':
    '期待どおりに機能しないプロンプトは、プロンプトライブラリの <strong>Improve My Prompt v1.0</strong> ツールでさらに磨きをかけましょう。',
  'pages.angelInsider.issues.feature-prompting.signoff.line':
    '自分のコンテキストを最もよく知っているのはあなたです。それをプロンプトに込めてください。',
  'pages.angelInsider.issues.feature-prompting.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-prompting.altCta.label':
    'プロンプトライブラリについて詳しく &rarr;',
  'pages.angelInsider.issues.feature-guided-summary.title': 'クイック情報とガイド付き要約',
  'pages.angelInsider.issues.feature-guided-summary.subtitle':
    '任意の 1 つのドキュメントを、出典付きで素早く読み解く — 全体像をつかむか、焦点を定めるか。',
  'pages.angelInsider.issues.feature-guided-summary.glance.0':
    'どんなドキュメントでも、すぐに全体像をつかみたいときは<strong>クイック情報</strong>を。',
  'pages.angelInsider.issues.feature-guided-summary.glance.1':
    '<strong>ガイド付き要約</strong>（アプリ内）なら焦点を自分で定められます。ライブラリのプロンプトと組み合わせましょう。',
  'pages.angelInsider.issues.feature-guided-summary.glance.2':
    'ドキュメントをアップロードし、プロンプトを選び、扱ってほしい論点を書き添えてください。',
  'pages.angelInsider.issues.feature-guided-summary.glance.3':
    '処理が高速化され、生成中に<strong>途中経過とインライン参照</strong>が表示されるようになりました。',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.kicker': '01 — ガイド付き要約',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.heading':
    'プロンプトで焦点を定めた、出典付きのドキュメント要約',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.0.p':
    'プロンプトライブラリには、ドキュメントを要約するためのプロンプトが 2 種類あります。1 つは簡潔な概観向け、もう 1 つはより詳細な分析向けです。いずれも SAL が公開したプロンプトを基に、生成 AI を使って改良したものです。',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.1.p':
    '私たちの経験では、<strong>詳細版</strong>の要約のほうが総じて優れており、特に複雑なドキュメントで効果を発揮します。A&GEL は出典<em>のみ</em>に依拠するよう指示されていますが、判例においては <em>ratio decidendi</em> と <em>obiter dicta</em> の区別が苦手な場合があります。',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.2.callout.title':
    '万能薬ではありません',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.2.callout.body':
    '出力は従来どおりレビューと検証が必要で、正確性と網羅性を十分に確認しなければなりません。これらのプロンプトが提供するのは効率的な出発点であって、完成した成果物ではありません。',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.3.p':
    '任意のプロンプトを 1 つのドキュメントに対して実行するには、（アプリ内の）<strong>ガイド付き要約</strong>機能をお使いください。ファイルをアップロードし、ライブラリからプロンプトを選び、気になる論点を書き添えます。',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.4.figure.caption':
    'プロンプトライブラリ内の判例要約（簡潔版）v1.1 と判例要約（詳細版）v1.1。',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.kicker': '02 — 速度と更新',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.heading':
    '途中経過つきの、より速い生成',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.blocks.0.p':
    'ガイド付き要約では、生成中に<strong>インライン参照つきの途中経過</strong>が表示されるようになりました。セクションが順次届くのを確認でき、出力が完了する前から引用の照合を始められます。',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.blocks.1.p':
    '全体の出力速度も向上しています。なお、単純なドキュメントでは要約の読み込みが速すぎて、途中経過が一切表示されないことがあります。',
  'pages.angelInsider.issues.feature-guided-summary.signoff.line':
    '全体像をつかむならクイック情報、焦点を定めたいならガイド付き要約。',
  'pages.angelInsider.issues.feature-guided-summary.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-vault.title': 'ボールト',
  'pages.angelInsider.issues.feature-vault.subtitle':
    'ボールトは A&GEL 上のあなたの頭脳です。よく整えるほど、AI の出力も鋭くなります。',
  'pages.angelInsider.issues.feature-vault.glance.0':
    'A&GEL はインターネットを検索<strong>しません</strong>。あなたのボールトの範囲内でのみ動作します。',
  'pages.angelInsider.issues.feature-vault.glance.1':
    '<strong>コンテキストがすべて</strong>：的確で厳選されたアップロードが、的確で信頼できる出力を生みます。',
  'pages.angelInsider.issues.feature-vault.glance.2':
    'フォルダ構成はメタデータです。AI を適切な視点へと導きます。',
  'pages.angelInsider.issues.feature-vault.glance.3':
    '<strong>参照ファイル重み</strong>と<strong>セッションファイル重み</strong>で、A&GEL が優先する対象を微調整しましょう。',
  'pages.angelInsider.issues.feature-vault.sections.0.kicker': '01 — 頭脳',
  'pages.angelInsider.issues.feature-vault.sections.0.heading':
    'ボールトは A&GEL 上のあなたの頭脳です',
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.0.p':
    'ボールトは A&GEL にとって主要なコンテキストの供給源となるよう設計されており、AI の確率的な出力を、信頼できる厳選されたナレッジベースに根拠づけます。',
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.1.p':
    '<strong>A&GEL は回答のためにインターネットを検索しますか。</strong>いいえ。A&GEL はボールトの範囲内で厳密に動作し、あなたがアップロードし整理したドキュメントのみに依拠します。これは意図的な設計上の選択であり、出力の正確性の確保、セキュリティの維持、独自のナレッジベースの完全性の保持という 3 つの目的を果たしています。',
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.2.p':
    '検証されていない情報をウェブから取り込むのではなく、A&GEL は唯一の真実の源として厳密にボールトに依拠します。ボールトがよく整えられていれば、A&GEL の各機能は、あなたが信頼する先例、あなたが精査した事実、あなたが支持する戦略に根ざしたものになります。A&GEL が質問に答えるとき、それは一般知識から推測しているのではなく、あなた固有の権威ある情報源から知見を統合しているのです。',
  'pages.angelInsider.issues.feature-vault.sections.1.kicker': '02 — アップロード',
  'pages.angelInsider.issues.feature-vault.sections.1.heading':
    '何を、どのようにアップロードするか',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.0.p':
    '<strong>何をアップロードできますか。</strong>Word 文書、PDF、メールです。そのほかのファイル形式は対応を進めています。',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.1.p':
    '<strong>どのように行いますか。</strong>個々のファイルやフォルダ全体をファイル画面にドラッグ＆ドロップするか、アップロードボタンをクリックしてください。',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.2.figure.caption':
    'ファイルやフォルダをファイル画面に直接ドラッグ＆ドロップする。',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.3.callout.title':
    'ゴミを入れれば、ゴミが出てくる',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.3.callout.body':
    'A&GEL を魔法の神託ではなく、あなたがアップロードしたものをすべて読んだ、疲れを知らない同僚だと考えてください。その同僚に無関係なファイルが山積みの散らかった机を渡せば、その仕事はおそらく混乱します。関連する先例を 1 件渡せば、仕事は鋭くなります。これが A&GEL を使ううえでの核心です。<strong>コンテキストがすべてです。</strong>',
  'pages.angelInsider.issues.feature-vault.sections.2.kicker': '03 — 構成',
  'pages.angelInsider.issues.feature-vault.sections.2.heading': 'フォルダ構成を整えましょう',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.0.p':
    'フォルダ構成は整理整頓のためだけのものではなく、AI を導くメタデータです。「売主」と「顧客」の先例を分けるなど、ファイルを論理的なサブフォルダに整理することで、A&GEL は適切な視点を取り出しやすくなります。',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.1.figure.caption':
    'サブフォルダを掘り下げる — 「ライセンシー」と「ライセンサー」の先例を分けておくとコンテキストが清潔に保たれます。',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.2.p':
    '<strong>「とにかく全部アップロード」の罠を避けましょう。</strong>ライブラリ全体を 1 つのフォルダに放り込んで、あとは AI に任せたくなるものです。しかし、そうしてはいけません。A&GEL は検索拡張生成（RAG）を使用しており、アップロードされたファイルから回答を引き出します。生成 AI は事実を「理解」しているのではなく、確率を予測しているにすぎません。無関係なノイズを与えれば、信号は薄まります。その結果、出力の正確さ・精密さ・信頼性はいずれも下がります。プロンプトに関連する特定のドキュメントやフォルダを、必ず手動で選択してください。',
  'pages.angelInsider.issues.feature-vault.sections.3.kicker': '04 — 微調整',
  'pages.angelInsider.issues.feature-vault.sections.3.heading': '信号を微調整する',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.0.p':
    'A&GEL には、この処理を制御するためのつまみが用意されています。引用した特定のドキュメントを AI に優先させるには<strong>参照ファイル重み</strong>を、そのチャットのためだけにアップロードしたファイルを強調するには<strong>セッションファイル重み</strong>をお使いください。',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.1.p':
    '最後に、A&GEL は出発点であることを忘れないでください。最初の考えを練り上げるためのブレインストーミングの相手であり共同作業の場であって、ゴールラインではありません。出力は必ず、回答にリンクされた出典ドキュメントと照合してください。',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.2.callout.title': '結論',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.2.callout.body':
    'ボールトはゴミ捨て場ではなく、厳選された図書館のように扱いましょう。ドキュメントの置き場所を把握し、コンテキストを厳選すれば、A&GEL は騒がしいチャットボットから高精度なアシスタントへと変わります。',
  'pages.angelInsider.issues.feature-vault.signoff.line': 'ボールトを整え、コンテキストを制する。',
  'pages.angelInsider.issues.feature-vault.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-vault.cta.label': '基本に戻る →',
  'pages.angelInsider.issues.issue-3.title': '新しいタイムラインとマルチステッププロンプトのアプリ',
  'pages.angelInsider.issues.issue-3.subtitle':
    '.msg のアップロード、より賢くなったスクライブ、構造化されたマルチステッププロンプト、そして大幅に刷新されたタイムライン。',
  'pages.angelInsider.issues.issue-3.date': '2026 年 3 月 18 日',
  'pages.angelInsider.issues.issue-3.glance.0':
    '<strong>メールファイル（.msg）</strong>をアップロードして、添付ファイルを含め全文を読み取れるようになりました。',
  'pages.angelInsider.issues.issue-3.glance.1':
    '<strong>スクライブ</strong>がライブ編集、音声再生、1 分ごとの自動保存に対応しました。',
  'pages.angelInsider.issues.issue-3.glance.2':
    '新しい<strong>マルチステッププロンプト</strong>モードが、複雑な法務ワークフローを的を絞ったステップに分解します。',
  'pages.angelInsider.issues.issue-3.glance.3':
    '<strong>タイムライン</strong>が刷新され、複数ドキュメントの時系列を統合できるようになりました。',
  'pages.angelInsider.issues.issue-3.sections.0.kicker': '01 — ファイル',
  'pages.angelInsider.issues.issue-3.sections.0.heading':
    'メールファイル（.msg）をアップロードする',
  'pages.angelInsider.issues.issue-3.sections.0.blocks.0.p':
    'A&GEL のユーザーは、<strong>.msg</strong> のメールファイルをそのままファイルにアップロードし、チャットや各種の専門モードで利用できるようになりました。A&GEL は添付ファイルを含むすべての内容を読み取ります。ただし、<em>社内限定</em>の機密ラベルが付いた添付ファイルや、パスワードで保護された添付ファイルは除きます。',
  'pages.angelInsider.issues.issue-3.sections.0.blocks.1.p':
    'アップロードしたら、メールの要約、添付ドキュメントの要約、あるいはライブラリの任意のプロンプトの実行を A&GEL に依頼できます。',
  'pages.angelInsider.issues.issue-3.sections.1.kicker': '02 — スクライブ',
  'pages.angelInsider.issues.issue-3.sections.1.heading': 'スクライブ：ライブ編集と音声再生',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.0.p':
    '<strong>ライブ編集</strong> — 改良されたスクライブでは文字起こしを編集でき、編集箇所には参照しやすいよう下線が付きます。<strong>音声再生</strong> — 文字起こしを保存した後、元の文字起こしを開いて任意の部分をクリックすると、その箇所から録音を再生できます。',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.1.gallery.0.caption':
    '録音中のスクライブと、リアルタイムの文字起こし。',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.1.gallery.1.caption':
    '元の文字起こし — 任意の部分をクリックすると音声が再生されます。',
  'pages.angelInsider.issues.issue-3.sections.2.kicker': '03 — 新しいモード',
  'pages.angelInsider.issues.issue-3.sections.2.heading': 'マルチステッププロンプト',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.0.p':
    '<strong>専門アプリ</strong>の中にあります。単発のプロンプトは単純な問い合わせには効率的ですが、複雑な法務タスクには構造化された反復的アプローチが有効です。マルチステッププロンプトを使うと、問題を的を絞った一連のやり取りに分解できます。中程度から複雑なドキュメント作業において、私たちが最も気に入っているモードです。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.1.h': 'ワークフローを論理的な段階に分ける',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.0.n': '企業法務・ステップ 1',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.0.text':
    '各当事者が負う義務を要約してください。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.1.n': 'ステップ 2',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.1.text':
    'その要約を踏まえて、一方的または通常と異なる条項を指摘してください。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.2.n': 'ステップ 3',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.2.text':
    '指摘された条項について、私が［当事者］を代理する場合に求めるべき変更の上位 5 件をレッドライン形式で示してください。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.0.n': '訴訟・ステップ 1',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.0.text':
    '［添付の］訴状に基づいて、最初の質問書一式を起案してください。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.1.n': 'ステップ 2',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.1.text':
    'ステップ 1 を終えたうえで、対応する文書提出要求を起案してください。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.2.n': 'ステップ 3',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.2.text':
    '最後に、該当文書を保有している可能性が高い管理者上位 5 名を特定し、その理由を説明してください。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.4.callout.title':
    'プロンプトが 1 つだけでも使う価値があります',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.4.callout.body':
    'ステップが 1 つだけでも、ドキュメントに対して実行したい複雑な単発プロンプトには、このアプリが非常に適しています。チャットモードより優れている場合も少なくありません。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.5.figure.caption':
    'マルチステッププロンプトの出力 — 参照をクリックすると、ハイライト付きのインラインドキュメントビューアーが開きます。',
  'pages.angelInsider.issues.issue-3.sections.3.kicker': '04 — タイムライン',
  'pages.angelInsider.issues.issue-3.sections.3.heading': '大幅に刷新されたタイムライン',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.0.p':
    '<strong>ドキュメントをまたいでタイムラインを統合する。</strong>更新されたタイムラインは、選択した各ドキュメントから時系列を抽出し、それらを 1 つに統合します。それぞれ独自の時系列を持つ大部の陳述書、訴答書面、準備書面が複数ある場合に、きわめて有用です。',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.1.gallery.0.caption':
    '5 つのファイルにまたがる、訴状と答弁書の統合タイムライン。',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.1.gallery.1.caption':
    '出典参照付きで、個々のドキュメントのタイムラインを掘り下げる。',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.2.p':
    '<strong>出典を確認する。</strong>任意の出来事の末尾にある参照をクリックすると、該当行がハイライトされた状態で出典ドキュメントが開きます。',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.3.h': '案件に合わせた、賢いタイムライン',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.4.p':
    'ドキュメントを選んだ後、<strong>プロンプトを拡張</strong>をクリックすると、関心のあるトピックに抽出の焦点を絞れます。<em>基本訴訟（共有）</em>の設定では、出来事の説明、出典ドキュメント、組織／個人、根拠となる段落が抽出されます。独自のフィールドを追加することもできます。',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.5.callout.title': 'メッセージにも使えます',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.5.callout.body':
    'チャットのログや、メッセージ（WhatsApp、WeChat）のスクリーンショットをタイムラインにかければ、時系列を構築できます。',
  'pages.angelInsider.issues.issue-3.signoff.line': 'より小さなステップで、より鋭い時系列を。',
  'pages.angelInsider.issues.issue-3.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-dispute.title': '紛争解決',
  'pages.angelInsider.issues.feature-dispute.subtitle':
    '事件の要約、訴状の分析、答弁書の起案、訴答書面の追跡 — すべて A&GEL の中で。',
  'pages.angelInsider.issues.feature-dispute.glance.0':
    '<strong>事件の要約</strong> — 複雑な判決では、詳細版が簡潔版を総じて上回ります。',
  'pages.angelInsider.issues.feature-dispute.glance.1':
    '<strong>訴状の分析</strong> — 訴状をアップロードして、分析プロンプトをそのまま実行できます。',
  'pages.angelInsider.issues.feature-dispute.glance.2':
    '<strong>答弁書の起案</strong> — 訴状から答弁書の初稿を作成します。',
  'pages.angelInsider.issues.feature-dispute.glance.3':
    '<strong>訴答書面トラッカー</strong> — レビューモードが、ドキュメント一式を通じて各請求原因に対する各当事者の主張を整理します。',
  'pages.angelInsider.issues.feature-dispute.sections.0.kicker': '01 — 事件の要約',
  'pages.angelInsider.issues.feature-dispute.sections.0.heading': '判決と訴答書面を要約する',
  'pages.angelInsider.issues.feature-dispute.sections.0.blocks.0.p':
    'プロンプトライブラリには、判例要約のプロンプトが簡潔版と詳細版の 2 種類あります。私たちの経験では、<strong>詳細版</strong>のほうが総じて優れており、特に複雑な判決で効果を発揮します。A&GEL は出典ドキュメントのみに依拠するよう指示されています。',
  'pages.angelInsider.issues.feature-dispute.sections.0.blocks.1.figure.caption':
    'プロンプトライブラリ内の判例要約（簡潔版）v1.1 と判例要約（詳細版）v1.1。',
  'pages.angelInsider.issues.feature-dispute.sections.1.kicker': '02 — 訴状と答弁書',
  'pages.angelInsider.issues.feature-dispute.sections.1.heading': '訴状の分析と答弁書の起案',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.0.p':
    '初期の事件評価には<strong>訴状の分析と時系列</strong>のプロンプトをお使いください。訴状をアップロードしてプロンプトを実行すると、A&GEL が主要な事実、請求原因、時系列を抽出します。',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.1.p':
    '答弁書の初稿を作成するには、ライブラリの<strong>訴状に対する答弁書を起案する</strong>プロンプトを使います。複製して、自分の案件に合わせてコンテキストを調整してください。',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.2.callout.title':
    '簡潔版より詳細版を',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.2.callout.body':
    '複雑な判決や長大な訴状では、詳細版の要約のほうが一貫してより正確で網羅的な出力を生みます。',
  'pages.angelInsider.issues.feature-dispute.sections.2.kicker': '03 — 訴答書面トラッカー',
  'pages.angelInsider.issues.feature-dispute.sections.2.heading':
    'レビューモードを訴答書面トラッカーとして使う',
  'pages.angelInsider.issues.feature-dispute.sections.2.blocks.0.p':
    'レビューモードは、質問リストを複数のドキュメントに対して同時に実行します。紛争解決であれば、訴状、答弁書、再答弁書を読み込み、請求原因ごとに 1 つずつ質問を定義すれば、A&GEL が各当事者の主張を 1 つの表に整理します。',
  'pages.angelInsider.issues.feature-dispute.sections.2.blocks.1.figure.caption':
    'Lim グループ：5 つのファイルにまたがる詐欺および不正行為の主張を、レビューモードで追跡する。',
  'pages.angelInsider.issues.feature-dispute.signoff.line':
    'より速い事件評価、より充実した準備を。',
  'pages.angelInsider.issues.feature-dispute.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-sidebyside.title': '並べて比較と比較',
  'pages.angelInsider.issues.feature-sidebyside.subtitle':
    '最もきめ細かいレビューモード — 条項ごとに、出典段落まで完全に検証。',
  'pages.angelInsider.issues.feature-sidebyside.glance.0':
    '<strong>並べて比較</strong>は条項ごとに処理し、すべての発見事項について出典段落まで完全に検証できます。',
  'pages.angelInsider.issues.feature-sidebyside.glance.1':
    '<strong>比較</strong>は、変更履歴やドキュメントの修正について一次レビューを作成します。',
  'pages.angelInsider.issues.feature-sidebyside.glance.2':
    'すべての発見事項が該当する出典条項にリンクされるため、ドキュメントを探し回る必要がありません。',
  'pages.angelInsider.issues.feature-sidebyside.glance.3':
    '<strong>ミニチャットウィンドウ</strong>が移動・リサイズ可能になりました。作業領域の外へドラッグできます。',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.kicker': '01 — 並べて比較',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.heading': '出典検証つきの条項ごとの分析',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.0.p':
    '並べて比較は A&GEL で最もきめ細かいレビューモードです。ドキュメントを条項ごとに処理し、発見事項ごとに該当する出典段落を提示するため、出力を原典と直接照合できます。',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.1.figure.caption':
    '株式譲渡契約の並べて比較分析 — 各発見事項が出典条項にリンクされます。',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.2.figure.caption':
    '説明パネル — A&GEL の推論が出典と並べてインライン表示されます。',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.kicker': '02 — 比較',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.heading': '変更履歴の一次レビュー',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.0.p':
    '<strong>比較</strong>は、変更履歴やドキュメントの修正について一次レビューを作成します。修正済みのドキュメントをアップロードすると、A&GEL が何がどう変わり、どのような影響があるのかを構造的に分析します。',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.1.callout.title':
    '出発点であって、完成品ではありません',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.1.callout.body':
    '並べて比較と比較の出力は効率的な出発点です。最終化する前に、必ず出典と照合してください。',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.kicker': '03 — ミニチャット',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.heading':
    '移動できるミニチャットインターフェース',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.blocks.0.p':
    'レビュー、比較、並べて比較のいずれにも<strong>ミニチャットウィンドウ</strong>があり、ドキュメントと A&GEL の出力の両方について同時に質問できます。このウィンドウは<strong>移動とリサイズが可能</strong>になったので、レビュー中の出力を隠さないよう画面上の好きな位置にドラッグできます。',
  'pages.angelInsider.issues.feature-sidebyside.signoff.line': '条項ごとに。出典も検証済みで。',
  'pages.angelInsider.issues.feature-sidebyside.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-multistep.title': 'マルチステッププロンプト',
  'pages.angelInsider.issues.feature-multistep.subtitle':
    '複雑な法務タスクを連続したステップに分解し、各ステップを前の結果の上に積み上げます。',
  'pages.angelInsider.issues.feature-multistep.glance.0':
    '<strong>専門アプリ</strong>の中にあります。',
  'pages.angelInsider.issues.feature-multistep.glance.1':
    '各ステップが前のステップの出力の上に積み上がるため、複雑なワークフローに最適です。',
  'pages.angelInsider.issues.feature-multistep.glance.2':
    '多段階のワークフローにも、ドキュメントに対する単一の複雑なプロンプトにも<em>どちらにも</em>使えます。',
  'pages.angelInsider.issues.feature-multistep.glance.3':
    '出力にはインラインの出典参照が含まれ、クリックするとハイライト付きで出典が開きます。',
  'pages.angelInsider.issues.feature-multistep.sections.0.kicker': '01 — はじめに',
  'pages.angelInsider.issues.feature-multistep.sections.0.heading':
    '複雑な法務業務のための構造化モード',
  'pages.angelInsider.issues.feature-multistep.sections.0.blocks.0.p':
    '<strong>専門アプリ</strong>の中にあります。マルチステッププロンプトを使うと、法的な問題を的を絞った一連のステップに分解でき、各ステップが前の結果の上に積み上がります。多段階のワークフローにも、ドキュメントレベルの精度が必要な単一の複雑なプロンプトにも適しています。',
  'pages.angelInsider.issues.feature-multistep.sections.0.blocks.1.figure.caption':
    '専門アプリ一覧内のマルチステッププロンプト。',
  'pages.angelInsider.issues.feature-multistep.sections.1.kicker': '02 — 例',
  'pages.angelInsider.issues.feature-multistep.sections.1.heading':
    'ワークフローを論理的な段階に分ける',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.0.n':
    '企業法務・ステップ 1',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.0.text':
    '各当事者が負う義務を要約してください。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.1.n': 'ステップ 2',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.1.text':
    'その要約を踏まえて、一方的または通常と異なる条項を指摘してください。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.2.n': 'ステップ 3',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.2.text':
    '指摘された条項について、私が［当事者］を代理する場合に求めるべき変更の上位 5 件をレッドライン形式で示してください。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.0.n': '訴訟・ステップ 1',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.0.text':
    '［添付の］訴状に基づいて、最初の質問書一式を起案してください。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.1.n': 'ステップ 2',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.1.text':
    'ステップ 1 を終えたうえで、対応する文書提出要求を起案してください。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.2.n': 'ステップ 3',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.2.text':
    '該当文書を保有している可能性が高い管理者上位 5 名を特定し、その理由を説明してください。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.2.callout.title':
    'プロンプトが 1 つだけでも使う価値があります',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.2.callout.body':
    'ステップが 1 つだけでも、このアプリはドキュメントに対する複雑なプロンプトに非常に適しています。チャットモードより優れている場合も少なくありません。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.3.figure.caption':
    'マルチステッププロンプトの出力 — 参照をクリックすると、ハイライト付きのインラインドキュメントビューアーが開きます。',
  'pages.angelInsider.issues.feature-multistep.sections.2.kicker': '03 — 実例',
  'pages.angelInsider.issues.feature-multistep.sections.2.heading':
    '2 つのドキュメントにまたがるレポートの起案',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.0.p':
    '2 つのドキュメントから懸念点を抽出し、エグゼクティブサマリー付きの 1 つのレポートにまとめる 3 段階のワークフローです。1 回のチャットプロンプトで確実に行うには複雑すぎる作業です。',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.1.callout.title':
    'ステップ 1 — 抽出',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.1.callout.body':
    '<strong>入力コンテキスト：</strong>[ドキュメント 1 とドキュメント 2 の本文を挿入]<br><strong>プロンプト：</strong>「提示された文章を読んでください。両方のドキュメントに記載されている懸念、論点、リスクを網羅した箇条書きリストを抽出してください。」<br><em>出力：整理・統合された懸念点のリスト。</em>',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.2.callout.title':
    'ステップ 2 — レポート全文の起案',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.2.callout.body':
    '<strong>入力コンテキスト：</strong>[ステップ 1 の出力]<br><strong>プロンプト：</strong>「提示された懸念点のリストを使って、詳細かつ正式なレポートを書いてください。類似する懸念は関連する見出しの下にまとめてください。この段階では序文やエグゼクティブサマリーを含めないでください。」<br><em>出力：構造化されたレポート全文。</em>',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.3.callout.title':
    'ステップ 3 — エグゼクティブサマリーと最終的な統合',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.3.callout.body':
    '<strong>入力コンテキスト：</strong>[ステップ 2 の出力]<br><strong>プロンプト：</strong>「提示されたレポートを読んでください。まず、1 段落の簡潔なエグゼクティブサマリーを書いてください。次に、そのエグゼクティブサマリーを出力し、区切り線を入れ、その下にレポート全文をそのまま出力して、1 つの統合ドキュメントを作成してください。」<br><em>出力：最終的な統合ドキュメント。</em>',
  'pages.angelInsider.issues.feature-multistep.signoff.line':
    'より小さなステップで、より鋭い出力を。',
  'pages.angelInsider.issues.feature-multistep.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-timeline.title': 'タイムライン',
  'pages.angelInsider.issues.feature-timeline.subtitle':
    '最大 100 件のドキュメントにまたがる時系列を、出典検証済みの 1 つのタイムラインにまとめます。',
  'pages.angelInsider.issues.feature-timeline.glance.0':
    '<strong>最大 100 件のドキュメント</strong>から時系列を抽出し、1 つのタイムラインに統合します。',
  'pages.angelInsider.issues.feature-timeline.glance.1':
    '<strong>クリックできるインライン引用</strong> — 参照をクリックすると、該当箇所がハイライトされた状態で出典が開きます。',
  'pages.angelInsider.issues.feature-timeline.glance.2':
    '<strong>スマートタイムライン</strong>では、組織名や根拠となる段落など、独自のフィールドを抽出できます。',
  'pages.angelInsider.issues.feature-timeline.glance.3':
    'チャットのログや、メッセージ（WhatsApp、WeChat）のスクリーンショットにも対応します。',
  'pages.angelInsider.issues.feature-timeline.sections.0.kicker': '01 — 統合タイムライン',
  'pages.angelInsider.issues.feature-timeline.sections.0.heading':
    '複数ドキュメントにまたがる時系列',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.0.p':
    '更新されたタイムラインは、選択した各ドキュメントから時系列を抽出し、それらを 1 つに統合します。それぞれ独自の時系列を持つ大部の陳述書、訴答書面、準備書面が複数ある場合に、きわめて有用です。',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.1.gallery.0.caption':
    '5 つのファイルにまたがる、訴状と答弁書の統合タイムライン。',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.1.gallery.1.caption':
    '個々の出来事を掘り下げる — 出典ドキュメント、関係者、根拠となる段落がすべて表示されます。',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.2.p':
    '<strong>出典を確認する。</strong>任意の出来事の末尾にあるインライン引用をクリックすると、該当行がハイライトされた状態で出典ドキュメントが開きます。',
  'pages.angelInsider.issues.feature-timeline.sections.1.kicker': '02 — スマートタイムライン',
  'pages.angelInsider.issues.feature-timeline.sections.1.heading':
    '案件に合わせて独自のフィールドを抽出する',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.0.p':
    '<strong>プロンプトを拡張</strong>をクリックすると、関心のあるトピックに抽出の焦点を絞れます。<em>基本訴訟（共有）</em>の設定では、出来事の説明、出典ドキュメント、組織／個人、根拠となる段落が抽出されます。独自のフィールドを追加することもできます。',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.1.figure.caption':
    'スマートタイムライン：「プロンプトを拡張」から独自の抽出フィールドを追加する。',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.2.callout.title':
    'メッセージにも使えます',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.2.callout.body':
    'チャットのログや、メッセージ（WhatsApp、WeChat）のスクリーンショットをタイムラインにかければ、時系列を構築できます。',
  'pages.angelInsider.issues.feature-timeline.signoff.line':
    '1 つのタイムラインに、すべてのドキュメントを。',
  'pages.angelInsider.issues.feature-timeline.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-using-files.title': 'A&GEL でのファイルの使い方',
  'pages.angelInsider.issues.feature-using-files.subtitle':
    'A&GEL は Word 文書、PDF、メールをそのまま扱えます（対応形式は今後さらに追加予定です）。ただし、テキストレイヤーの欠如、機密ラベルの設定、ファイル形式などが原因で、アップロードに失敗するファイルもあります。いずれも簡単な対処法があります。',
  'pages.angelInsider.issues.feature-using-files.intro':
    '一部のファイルが A&GEL に正しくアップロードされないことがあります。このガイドでは、テキストレイヤーのないスキャン文書から機密ラベルの問題まで、よくある原因とその解決方法をご説明します。',
  'pages.angelInsider.issues.feature-using-files.glance.0':
    'A&GEL は PDF 内の<strong>テキストレイヤー</strong>を読み取ります。スキャンした紙資料には、それがない場合がよくあります。',
  'pages.angelInsider.issues.feature-using-files.glance.1':
    '古いファイルや、OCR をかけずにスキャンした紙資料でよく起こります。',
  'pages.angelInsider.issues.feature-using-files.glance.2':
    '対処法：PDF を検索可能にしてから、A&GEL に再アップロードしてください。',
  'pages.angelInsider.issues.feature-using-files.glance.3':
    '大量の PDF を一度に変換したい場合は、A&GEL 開発チームがお手伝いできます。',
  'pages.angelInsider.issues.feature-using-files.glance.4':
    '社内文書はアップロード前に<strong>社外</strong>へラベルを変更する必要があります。そうしないと A&GEL は受け付けません。',
  'pages.angelInsider.issues.feature-using-files.glance.5':
    '古い Word 文書（1997〜2004 年の、OOXML 以前の .doc）にはすでに対応しており、変換は不要です。',
  'pages.angelInsider.issues.feature-using-files.sections.0.kicker': '01 — テキストレイヤーの欠如',
  'pages.angelInsider.issues.feature-using-files.sections.0.heading': 'スキャン文書に関する問題',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.0.p':
    'A&GEL は PDF に埋め込まれたテキストレイヤーを抽出してドキュメントを読み取ります。スキャンした紙資料のようにテキストレイヤーがない場合、A&GEL にはページの画像しか見えず、処理できません。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.1.p':
    'スキャンされたドキュメントの多くは、特にコピー機でデジタル化されたものは、画像のみの PDF として保存されています。これは古いファイルや、（OCR をかけずに）画像としてスキャンされた文書でよく見られます。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.2.p':
    '確実に処理されるよう、アップロード前に Kofax など OCR（光学文字認識）に対応した PDF リーダーでファイルを開いてください。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.0.n': 'ステップ 1',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.0.text':
    'Kofax など OCR 機能のある PDF リーダーで、スキャンした PDF を開きます。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.1.n': 'ステップ 2',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.1.text':
    'OCR を実行してファイルを検索可能にします。Kofax では<strong>「検索可能にする」</strong>または<strong>「検索可能な PDF」</strong>の機能です。変換したいファイルが複数ある場合は、1 件ずつ処理するのではなく、バッチまたは複数ファイル対応の OCR オプション（Kofax では「高度な処理」の中にあります）を探してください。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.2.n': 'ステップ 3',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.2.text':
    '変換したファイルを保存し、A&GEL にアップロードします。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.4.p':
    '変換後のファイルには検索可能なテキストレイヤーが含まれ、A&GEL も通常どおり処理できるようになります。なお、後から変換するのではなく、スキャンの時点で検索可能な PDF を作成することもできます。多くのプリンターやスキャナーは、スキャン時に検索可能な PDF を直接出力できます。メニュー名や手順は機種によって異なるため、お使いの機器で同等の「検索可能な PDF」または OCR のオプションをお探しください。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.5.figure.caption':
    '例：このスキャナーの「スキャンして送信」画面では、ファイル形式に PDF を選び、OCR（速度優先または精度優先）を有効にすると、テキストレイヤー付きの検索可能な PDF が作成されます。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.6.p':
    '大量の PDF を一度に OCR 処理する必要がありますか。A&GEL 開発チームにご連絡ください。一括変換の処理をお手伝いできます。',
  'pages.angelInsider.issues.feature-using-files.sections.1.kicker': '02 — 機密ラベル',
  'pages.angelInsider.issues.feature-using-files.sections.1.heading': '機密ラベルに関する問題',
  'pages.angelInsider.issues.feature-using-files.sections.1.blocks.0.p':
    'すべてのドキュメントには、Word や Outlook で保存する際に設定される機密ラベルが付いており、A&GEL はアップロードを受け付ける前にこのラベルを確認します。',
  'pages.angelInsider.issues.feature-using-files.sections.1.blocks.1.p':
    'A&GEL は「社内」の機密ラベルが付いたファイルを拒否します。アップロード前に、ドキュメントのラベルを「社外」に変更して保存してください。',
  'pages.angelInsider.issues.feature-using-files.sections.2.kicker': '03 — 古い Word ファイル',
  'pages.angelInsider.issues.feature-using-files.sections.2.heading':
    '古い Word 文書にも対応しています',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.0.p':
    '古い Word 文書にも対応しています。以下の形式はいずれも、アップロード前に変換や保存し直しをする必要はありません：',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.left.label': 'PDF',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.topMiddle.label':
    'MS Word 現行形式（.docx）',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.bottomMiddle.label':
    'MS Word 1997〜2004（.doc）',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.right.label':
    'メール（.msg）',
  'pages.angelInsider.issues.feature-using-files.signoff.line':
    'スキャン文書は Kofax やプリンターの OCR 設定で検索可能にし、社内文書はアップロード前に「社外」として保存してください。なお、古い Word 形式も現行形式も、変換なしでそのまま使えます。',
  'pages.angelInsider.issues.feature-using-files.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-work-studio.title': 'ワークスタジオ',
  'pages.angelInsider.issues.feature-work-studio.subtitle':
    'チームの標準的な立場を体系化して標準レビューにし、変更履歴付きの Word 文書として受け取ります。',
  'pages.angelInsider.issues.feature-work-studio.glance.0':
    'チームの交渉上の立場を一度ワークスタジオに登録すれば、すべての契約書で再利用できます。',
  'pages.angelInsider.issues.feature-work-studio.glance.1':
    'A&GEL がワークスタジオを適用し、<strong>変更履歴付きの Word 文書</strong>を返します。',
  'pages.angelInsider.issues.feature-work-studio.glance.2':
    '修正案は、承認済み／却下済み／保留中の状態で確認できます。',
  'pages.angelInsider.issues.feature-work-studio.glance.3':
    'ワークスタジオの作成方法と使い方の詳細は、次号の A&GEL Insider でご紹介します。',
  'pages.angelInsider.issues.feature-work-studio.sections.0.kicker': '01 — ワークスタジオ',
  'pages.angelInsider.issues.feature-work-studio.sections.0.heading': '自社の立場を、自動で適用',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.0.p':
    'ワークスタジオを使うと、チームの交渉上の立場や標準的な立場を、再利用可能なレビュー用テンプレートとして体系化できます。一度作成すれば、任意の契約書をアップロードするだけで A&GEL がワークスタジオを適用し、変更履歴形式で修正案を入れた Word 文書を返します。そのままレビューと修正に進めます。',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.1.figure.caption':
    '動作中のワークスタジオ — 承認済み／却下済み／保留中の状態で修正とコメントをレビューする。',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.2.callout.title':
    'ワークスタジオの完全ガイドは近日公開',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.2.callout.body':
    '次号の A&GEL Insider では、ワークスタジオをゼロから作成する方法と、チームの案件で実際に活用する方法をご紹介します。',
  'pages.angelInsider.issues.feature-work-studio.signoff.line': 'あなたの立場を、自動で適用。',
  'pages.angelInsider.issues.feature-work-studio.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-deepresearch.title': 'ディープリサーチ',
  'pages.angelInsider.issues.feature-deepresearch.subtitle':
    '構造化されたリサーチプロンプトによるドキュメント横断の分析。すべての発見事項が出典段落にさかのぼれます。',
  'pages.angelInsider.issues.feature-deepresearch.glance.0':
    '選択したドキュメント一式に対して、構造化されたリサーチプロンプトを実行します。',
  'pages.angelInsider.issues.feature-deepresearch.glance.1':
    'すべての発見事項に<strong>クリックできるインライン引用</strong>が付き、該当箇所がハイライトされた状態で出典を開けます。',
  'pages.angelInsider.issues.feature-deepresearch.glance.2':
    '<strong>専門アプリ</strong>の中にあります。',
  'pages.angelInsider.issues.feature-deepresearch.glance.3':
    '一次資料を厳選してボールトにアップロードしておくと、精度が最大限に高まります。',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.kicker': '01 — 何ができるのか',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.heading':
    '構造化されたプロンプトによるドキュメント横断の分析',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.blocks.0.p':
    'ディープリサーチは、選択したドキュメントに対して構造化されたリサーチプロンプトを実行し、出典付きの詳細な分析を返します。1 つのファイルを掘り下げるのではなく、判例分析、市場調査、規制のマッピングなど、複数のドキュメントにまたがる情報の統合が必要な作業のために設計されています。',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.blocks.1.figure.caption':
    'ディープリサーチの出力 — 各発見事項が、クリックできるインライン引用を通じて出典ドキュメントにさかのぼれます。',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.kicker': '02 — インライン引用',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.heading':
    'すべての発見事項を出典と照合する',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.0.p':
    'ディープリサーチの出力に含まれるすべての発見事項には、<strong>番号付きのインライン引用</strong>が付いています。引用をクリックすると、該当箇所がハイライトされた状態で出典ドキュメントが開きます。ページを離れる必要はありません。',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.1.callout.title':
    'コンテキストは絞り込んで',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.1.callout.body':
    'リサーチの問いに最も関連するドキュメントにコンテキストを限定してください。範囲が広いと信号が薄まります。ディープリサーチは、厳選され的を絞ったアップロードで最も力を発揮します。',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.kicker': '03 — 使いどころ',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.heading':
    '情報の統合が必要な作業に最適',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.blocks.0.p':
    '複数の情報源をまたいで統合する必要があるとき — 複数の陳述書における主張の比較、特定の論点に関する判例の要約、法域をまたぐ規制要件のマッピングなど — にディープリサーチをお使いください。ドキュメントが 1 つだけの場合は、ガイド付き要約や業務範囲サマリーをご検討ください。',
  'pages.angelInsider.issues.feature-deepresearch.signoff.line':
    'すべての発見事項を、出典検証済みで。',
  'pages.angelInsider.issues.feature-deepresearch.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-scopesummary.title': '業務範囲サマリー',
  'pages.angelInsider.issues.feature-scopesummary.subtitle':
    '指定した重点領域に絞った構造化サマリー。抽出された各項目にはクリックできるインライン引用が付きます。',
  'pages.angelInsider.issues.feature-scopesummary.glance.0':
    'ドキュメント全体ではなく、指定した範囲に焦点を当てたサマリーを作成します。',
  'pages.angelInsider.issues.feature-scopesummary.glance.1':
    '抽出された各項目には、出典と照合できる<strong>クリック可能なインライン引用</strong>が付きます。',
  'pages.angelInsider.issues.feature-scopesummary.glance.2':
    '<strong>専門アプリ</strong>の中にあります。',
  'pages.angelInsider.issues.feature-scopesummary.glance.3':
    '範囲の定義が絞られているほど、的を絞った実行可能な抽出結果が得られます。',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.kicker': '01 — 何ができるのか',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.heading':
    '指定した範囲内での焦点を絞った抽出',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.0.p':
    '業務範囲サマリーでは、A&GEL に注目してほしい領域 — 義務、リスク分担、解除権、知的財産条項など — を指定し、その範囲に限定した構造化サマリーを作成できます。出力はドキュメント全体の要約より的を絞ったもので、レビューの優先事項に直接対応します。',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.1.callout.title':
    '範囲は明確に定義しましょう',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.1.callout.body':
    '範囲が絞られているほど出力は精密になります。範囲が広いと、ドキュメント全体の要約に近い出力になります。「データ保護とセキュリティ上の義務」のように的を絞った範囲であれば、簡潔で実行可能な抽出結果が得られます。',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.kicker': '02 — インライン引用',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.heading':
    'すべての項目を、出典検証済みで',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.blocks.0.p':
    '業務範囲サマリーで抽出された各項目には<strong>クリックできるインライン引用</strong>が付きます。クリックすると、該当する条項や段落がハイライトされた状態で出典ドキュメントが開きます。タブを切り替える必要はなく、検証はすべて 1 つのページで完結します。',
  'pages.angelInsider.issues.feature-scopesummary.signoff.line':
    '範囲を絞り、出典を示し、検証する。',
  'pages.angelInsider.issues.feature-scopesummary.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-review.title': 'レビュー',
  'pages.angelInsider.issues.feature-review.subtitle':
    '複数のドキュメントに複数の質問を一度に投げかけると、結果がインライン引用付きの表で表示されます。',
  'pages.angelInsider.issues.feature-review.glance.0':
    '<strong>質問リストを複数のドキュメントに同時に</strong>実行し、結果を 1 つの表にまとめます。',
  'pages.angelInsider.issues.feature-review.glance.1':
    '任意のセルをクリックすると、出典条項へのインライン引用付きの<strong>説明パネル</strong>が開きます。',
  'pages.angelInsider.issues.feature-review.glance.2':
    'レビューのページを離れることなく、<strong>ミニチャット</strong>で追加の質問ができます。',
  'pages.angelInsider.issues.feature-review.glance.3':
    '<strong>専門アプリ</strong>の中にあります。',
  'pages.angelInsider.issues.feature-review.sections.0.kicker': '01 — 何ができるのか',
  'pages.angelInsider.issues.feature-review.sections.0.heading':
    '複数ドキュメント・複数質問のレビューを 1 つの表で',
  'pages.angelInsider.issues.feature-review.sections.0.blocks.0.p':
    'レビューは、質問リストを複数のドキュメントに対して同時に実行し、結果を表として返します。1 行が 1 つの質問、1 列が 1 つのドキュメントです。この形式は、契約書の比較、ドキュメント一式に対するデューデリジェンス、訴答書面にまたがる主張の整理などに適しています。',
  'pages.angelInsider.issues.feature-review.sections.0.blocks.1.figure.caption':
    'AI SaaS ベンチマークレビュー — 20 件のファイルを、定義した質問セットに照らして 1 つの表でレビュー。',
  'pages.angelInsider.issues.feature-review.sections.1.kicker': '02 — 説明パネル',
  'pages.angelInsider.issues.feature-review.sections.1.heading':
    'すべての発見事項に、出典検証済みの説明を',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.0.p':
    '任意のセルをクリックすると<strong>説明パネル</strong>が開きます。各発見事項は構造化されたインライン参照とともに分解して示され、参照をクリックすれば出典条項を直接開けます。',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.1.figure.caption':
    'レビューの説明パネル — 各発見事項が出典条項にリンクされています。',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.2.callout.title':
    '質問リストは一度作れば繰り返し使えます',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.2.callout.body':
    'よく練られた質問リストは、そのドキュメント種別の再利用可能なテンプレートになります。保存しておいて、同じカテゴリの次の契約書群に適用しましょう。',
  'pages.angelInsider.issues.feature-review.sections.2.kicker': '03 — ミニチャット',
  'pages.angelInsider.issues.feature-review.sections.2.heading': 'ページを離れずに追加の質問を',
  'pages.angelInsider.issues.feature-review.sections.2.blocks.0.p':
    '<strong>ミニチャットウィンドウ</strong>を使えば、ドキュメントとレビューの出力の両方について、ページを離れることなく追加の質問ができます。ウィンドウは移動とリサイズが可能なので、作業領域の邪魔になりません。',
  'pages.angelInsider.issues.feature-review.signoff.line':
    'すべてのドキュメント、すべての質問を、1 つの表に。',
  'pages.angelInsider.issues.feature-review.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-msg.title': '.msg メールのアップロード',
  'pages.angelInsider.issues.feature-msg.subtitle':
    'メールファイルをそのまま A&GEL にアップロードし、添付ファイルも含めてほかのドキュメントと同じように扱えます。',
  'pages.angelInsider.issues.feature-msg.glance.0':
    '<strong>.msg</strong> のメールファイルをファイルに直接アップロードできます。',
  'pages.angelInsider.issues.feature-msg.glance.1':
    'A&GEL は添付ファイルを含むすべての内容を読み取ります。',
  'pages.angelInsider.issues.feature-msg.glance.2':
    'チャットでも、各種の専門モード（ガイド付き要約、タイムラインなど）でも使えます。',
  'pages.angelInsider.issues.feature-msg.glance.3':
    '例外：<em>社内限定</em>のラベルが付いた添付ファイルや、パスワードで保護された添付ファイルは対象外です。',
  'pages.angelInsider.issues.feature-msg.sections.0.kicker': '.msg のアップロード',
  'pages.angelInsider.issues.feature-msg.sections.0.heading':
    'メールファイル（.msg）をアップロードする',
  'pages.angelInsider.issues.feature-msg.sections.0.blocks.0.p':
    'A&GEL のユーザーは、<strong>.msg</strong> のメールファイルをそのままファイルにアップロードし、チャットや各種の専門モードで利用できるようになりました。A&GEL は添付ファイルを含むすべての内容を読み取ります。ただし、<em>社内限定</em>の機密ラベルが付いた添付ファイルや、パスワードで保護された添付ファイルは除きます。',
  'pages.angelInsider.issues.feature-msg.sections.0.blocks.1.p':
    'アップロードしたら、メールの要約、添付ドキュメントの要約、あるいはライブラリの任意のプロンプトの実行を A&GEL に依頼できます。',
  'pages.angelInsider.issues.feature-msg.signoff.line': 'メールも、添付ファイルも、まるごと。',
  'pages.angelInsider.issues.feature-msg.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-inline-ref.title': 'インライン参照',
  'pages.angelInsider.issues.feature-inline-ref.subtitle':
    'ディープリサーチ、タイムライン、業務範囲サマリー、レビューでクリックできるピンサイト引用を利用でき、ページを離れずにすべての出力を出典と照合できます。',
  'pages.angelInsider.issues.feature-inline-ref.glance.0':
    'ディープリサーチ、タイムライン、業務範囲サマリーの出力に<strong>クリックできるインライン引用</strong>が付きました。',
  'pages.angelInsider.issues.feature-inline-ref.glance.1':
    '引用をクリックすると、該当箇所がハイライトされた状態で出典ドキュメントが開きます。',
  'pages.angelInsider.issues.feature-inline-ref.glance.2':
    'レビューの<strong>説明パネル</strong>にも、AI が生成した各発見事項について構造化されたインライン参照が付きます。',
  'pages.angelInsider.issues.feature-inline-ref.glance.3':
    'タブを切り替える必要はなく、検証はすべて 1 つのページで完結します。',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.kicker': 'インライン参照',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.heading': 'すべての出力を出典と照合する',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.blocks.0.p':
    'A&GEL の主要な出力アプリ — <strong>ディープリサーチ、タイムライン、業務範囲サマリー</strong> — のすべてに、クリックできるインライン引用が備わりました。各参照には番号が振られリンクされているので、クリックすれば該当箇所がハイライトされた状態で出典ドキュメントが開きます。',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.blocks.1.p':
    'これにより、特定の箇所を検証するためにタブを切り替えたり、出典ドキュメントを手作業で探したりする必要がなくなります。相互参照は 1 つのページ上で行えます。',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.kicker': 'レビューでのインライン参照',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.heading':
    '説明パネルにおける構造化された引用',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.blocks.0.p':
    'レビューページの<strong>説明</strong>セクション（任意のセルをクリックすると開きます）にも、構造化されたインライン参照が追加されました。説明の各項目が出典の条項や段落にリンクされるため、AI が生成した発見事項を一次情報と照合する作業が容易になります。',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.blocks.1.figure.caption':
    'レビューの説明パネル。構造化されたインライン参照が出典ドキュメントにリンクされています。',
  'pages.angelInsider.issues.feature-inline-ref.signoff.line': 'すべての出力を、出典検証済みで。',
  'pages.angelInsider.issues.feature-inline-ref.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.issue-5.title': 'インライン参照、ミニチャットほか',
  'pages.angelInsider.issues.issue-5.subtitle':
    '全アプリでのピンサイト引用、移動できるミニチャット、スクライブのタイムスタンプ、そして使い勝手を高める一連の改善。',
  'pages.angelInsider.issues.issue-5.date': '2026 年 4 月 10 日',
  'pages.angelInsider.issues.issue-5.glance.0':
    'ディープリサーチ、タイムライン、業務範囲サマリー、レビューに<strong>クリックできるインライン引用</strong>が付きました。',
  'pages.angelInsider.issues.issue-5.glance.1':
    'レビュー、比較、並べて比較のミニチャットウィンドウが<strong>移動・リサイズ可能</strong>になりました。',
  'pages.angelInsider.issues.issue-5.glance.2':
    'スクライブの文字起こしをダウンロードした Word 文書に<strong>タイムスタンプ</strong>が含まれるようになりました。',
  'pages.angelInsider.issues.issue-5.glance.3':
    '停止ボタンに加えて、<strong>履歴タブからもセッションを終了</strong>できるようになりました。',
  'pages.angelInsider.issues.issue-5.glance.4':
    '検索の改善：キーワードの一致精度とドキュメント内検索が向上しました。',
  'pages.angelInsider.issues.issue-5.sections.0.kicker': '01 — インライン参照',
  'pages.angelInsider.issues.issue-5.sections.0.heading': '全アプリでのピンサイト引用',
  'pages.angelInsider.issues.issue-5.sections.0.blocks.0.p':
    'ディープリサーチ、タイムライン、業務範囲サマリーに<strong>クリックできるインライン引用</strong>が付きました。これにより、出力を出典ドキュメントと即座に照合できます。引用をクリックすると、該当箇所がハイライトされた状態で出典が開き、ページを離れる必要はありません。',
  'pages.angelInsider.issues.issue-5.sections.0.blocks.1.p':
    'レビューページで展開される<strong>説明</strong>セクションにも、出典ドキュメントにリンクされた構造化インライン参照が追加され、AI が生成した分析を一次情報と照合しやすくなりました。',
  'pages.angelInsider.issues.issue-5.sections.0.blocks.2.figure.caption':
    'レビューの説明パネル — 構造化されたインライン参照が出典ドキュメントにリンクされています。',
  'pages.angelInsider.issues.issue-5.sections.1.kicker': '02 — ミニチャット',
  'pages.angelInsider.issues.issue-5.sections.1.heading': '移動できるミニチャットインターフェース',
  'pages.angelInsider.issues.issue-5.sections.1.blocks.0.p':
    '<strong>レビュー、比較、並べて比較</strong>で利用できるミニチャットウィンドウが、移動・リサイズ可能になりました。出力を確認している間は邪魔にならない位置へドラッグできるので、主要な作業領域を覆うことがありません。',
  'pages.angelInsider.issues.issue-5.sections.2.kicker': '03 — スクライブ',
  'pages.angelInsider.issues.issue-5.sections.2.heading':
    'ダウンロードした文字起こしのタイムスタンプ',
  'pages.angelInsider.issues.issue-5.sections.2.blocks.0.p':
    'ダウンロードしたスクライブの文字起こし（Word 文書）に<strong>タイムスタンプ</strong>が含まれるようになりました。文書から直接、録音の特定の場面に移動できる目印です。',
  'pages.angelInsider.issues.issue-5.sections.2.blocks.1.figure.caption':
    '翻訳とともにタイムスタンプが表示された、ダウンロード済みのスクライブ文字起こし。',
  'pages.angelInsider.issues.issue-5.sections.3.kicker': '04 — そのほかの更新',
  'pages.angelInsider.issues.issue-5.sections.3.heading': '使い勝手の改善',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.0.h':
    'セッションをより簡単に終了できるように',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.1.p':
    '実行中のセッションは、従来の停止ボタンに加えて<strong>履歴タブから削除する</strong>ことでも終了できるようになりました。プロンプトを修正して再実行したいときや、セッションが応答しないときに便利です。',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.2.h': '検索の強化',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.3.p':
    '検索でも<strong>インライン参照</strong>が利用できるようになり、キーワードの一致精度とドキュメント内検索も向上しました。ボールト全体から目的の内容をより簡単に見つけられます。',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.4.h': 'ガイド付き要約の高速化',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.5.p':
    'ガイド付き要約では、生成中に<strong>インライン参照つきの途中経過</strong>が表示されるようになり、全体の出力速度も向上しました。単純なドキュメントでは、要約の読み込みが速すぎて途中経過が表示されないことがあります。',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.6.h': 'ファイル画面の最適化',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.7.p':
    'ファイルページのページネーションが改善され、画面サイズに応じて表示が広がるため、ファイルとフォルダを一度により多く確認できます。',
  'pages.angelInsider.issues.issue-5.signoff.line': '検証はより速く、作業領域はより広く。',
  'pages.angelInsider.issues.issue-5.signoff.name': 'A&GEL 開発チーム',
  'pages.angelInsider.issues.feature-faq.title': 'よくあるご質問',
  'pages.angelInsider.issues.feature-faq.subtitle':
    'A&GEL をはじめるにあたって — ファイル管理やプロンプトの書き方から、出力の確認方法まで。',
  'pages.angelInsider.issues.feature-faq.date': '2026 年 2 月 10 日',
  'pages.angelInsider.issues.feature-faq.glance.0':
    'A&GEL が、あなたの専門性をどのように支え、そして置き換えないのか。',
  'pages.angelInsider.issues.feature-faq.glance.1':
    'ファイル管理のベストプラクティス：何をアップロードし、どう整理するか。',
  'pages.angelInsider.issues.feature-faq.glance.2':
    'ペルソナ・タスク・コンテキスト・形式の枠組みを使った、効果的なプロンプトの書き方。',
  'pages.angelInsider.issues.feature-faq.glance.3': 'A&GEL の出力の正確性と信頼性を確認する方法。',
  'pages.angelInsider.issues.feature-faq.glance.4': 'A&GEL で使われる専門用語の用語集。',
  'pages.angelInsider.issues.feature-faq.sections.0.kicker': '1 — 基本的な考え方',
  'pages.angelInsider.issues.feature-faq.sections.0.heading': '専門家には常に専門家であってもらう',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.0.h':
    'Q：A&GEL の設計思想のひとつに「専門家には常に専門家であってもらう」があります。これはどういう意味ですか。',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.1.p':
    '「専門家には常に専門家であってもらう」とは、その分野のプロフェッショナル／専門家としてのあなたの判断、洞察、誠実さが、仕事の中心であり続けるべきだという考え方を指します。',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.2.p':
    'A&GEL はその専門性に取って代わるものでも、専門家として振る舞うものでもありません。むしろ、ナレッジワーカーや法律家であるあなたが、より多くの材料でより多くを成し遂げられるよう支援するために設計されています。',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.3.h':
    'Q：A&GEL に尋ねようとしている分野について、まったく知識がない場合はどうでしょうか。その場合は A&GEL を使うべきではありませんか。',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.4.p':
    'まだ専門性を身につけている途中であっても、A&GEL の利用を避けるべきだということではありません。使い方により注意を払うべきだ、ということです。A&GEL の出力については、より慎重に、より多くの確認を行ってください。',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.5.p':
    'さらに、チームや会社がアップロードした既存のノウハウへの入り口や案内役として A&GEL を使うこともご検討ください。そうしたノウハウに新しい方法でアクセスし、必要なときに知見や学びを得る手段として使えば、A&GEL はあなたの学習と成長を支える強力なツールになります。',
  'pages.angelInsider.issues.feature-faq.sections.1.kicker': '2 — ファイル管理',
  'pages.angelInsider.issues.feature-faq.sections.1.heading': '何をアップロードし、どう整理するか',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.0.h':
    'Q：どのような参考資料を A&GEL にアップロードすべきですか。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.1.p':
    '原則として、信頼でき、確かで、正確な資料のみをアップロードしてください。たとえば、一次法令資料（制定法、判例など）や、信頼できる社内資料（社内ノウハウ、実績のある自分の文書など）です。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.2.p':
    'A&GEL の出力は、指定したドキュメントやフォルダに大きく依存します。適切なものを選んでアップロードし、そうした信頼できる文書には明確な命名規則を設けてください。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.3.callout.title': 'Word 文書の設定',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.3.callout.body':
    'Word 文書は、A&GEL にアップロードする前にセキュリティ設定を「社外」（またはそれに相当する設定）にしておく必要があります。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.4.h':
    'Q：第三者の文書はどうでしょうか。A&GEL にアップロードできますか。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.5.p':
    'もちろんです。第三者の文書の分析、検討、レビューに A&GEL を使うことをおすすめします。実際、それは（レビューをはじめとする）A&GEL の多くの専門モードにおける中核的な強みのひとつです。相手方代理人や取引相手からの文書も含まれます。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.6.p':
    'ただし、第三者の文書であることが明確に分かるフォルダにアップロードしてください。そうすれば、ファイルパスを見るだけで、信頼できる先例なのか、作業対象の「外部」文書なのかを判別できます。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.7.p':
    'また、A&GEL の利用に関係する社内規程（生成 AI の利用に関する方針など）や利用規範にもご留意ください。必要に応じて、適切な許諾を得たうえで第三者コンテンツを使用することも含まれます。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.8.h':
    'Q：ファイルタブやチャットにアップロードしたファイルの「処理」に時間がかかるのはなぜですか。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.9.p':
    'ドキュメントは A&GEL が扱える形式（「エンベディング」と呼ばれます）に変換する必要があるため、アップロード時に時間がかかることがあります。ただし、これはボールトのファイルにアップロードする際の一度きりの処理です。ファイルタブにアップロードしたドキュメントは、チャットや各種の専門モードでコンテキストとして選択することで、新しいセッションでも再利用できます。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.10.p':
    'チャットでは、ドキュメントを一度アップロードしておけば、「コンテキスト」ボタン、続いて「ドキュメント付きの新規チャット」ボタンをクリックすることで、新しいチャットセッションで同じドキュメントを使って再び会話できます。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.11.h':
    'Q：ファイルタブにドキュメントを一括でアップロードするにはどうすればよいですか。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.12.p':
    'ファイルモードで、画面右上のアップロードボタンをクリックします。アップロードしたいファイルを必要な数だけ選択し、「開く」を押してください。参考資料のアップロード中も、A&GEL のほかの機能を引き続き利用できます。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.13.h':
    'Q：A&GEL にアップロードした参考資料は、どのように分類・管理すべきですか。すべてを 1 つのフォルダにアップロードしてはいけないのはなぜですか。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.14.p':
    '<strong>ファイル管理はなぜ重要なのか。</strong>適切なファイル管理は、(a) A&GEL が回答の文脈とする参考資料を的確に選択できるようにするため、また (b) A&GEL がどの参考資料を使用したかを確認し、生成された出力の正確性と信頼性を担保するために不可欠です。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.15.p':
    '<strong>アップロードした参考資料はどのように管理すべきか。</strong>A&GEL に参考資料をアップロードする際は、すべてを 1 つのフォルダに入れないことを強くおすすめします。代わりに、(i) 主題と (ii) ワークフローでドキュメントを整理・グループ分けすることをおすすめします。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.16.p':
    'ファイルタブでこれを行うには、ドキュメントをアップロードする前に、右上隅の「フォルダを作成」ボタンをクリックして新しいフォルダを作り、主題の名前を付けます。その新しいフォルダ内にサブフォルダを作成し、アップロードするドキュメントのワークフローの名前を付けます。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.17.p':
    'こうしてドキュメントをアップロードすると、主題とワークフローの両方を示す適切なファイルパスが表示されます。例：<code>ホーム / IP ライセンス契約 / ライセンサー</code>',
  'pages.angelInsider.issues.feature-faq.sections.2.kicker': '3 — A&GEL へのプロンプト',
  'pages.angelInsider.issues.feature-faq.sections.2.heading': '効果的なプロンプトを書く',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.0.h':
    'Q：どのような種類のプロンプトが使えますか。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.1.p':
    'A&GEL にはさまざまな方法でプロンプトを与えられます。以下は（思いつきにくいものも含めた）プロンプトの種類の例です：',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.2.h': '情報の収集と取得',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.0':
    '<strong>質問型プロンプト：</strong>事実関係の情報、説明、確認を求める直接的な質問。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.1':
    '<strong>説明型プロンプト：</strong>概念、プロセス、事象の詳細な説明を求めるもの。「説明して」「記述して」「分解して」といった表現がよく使われます。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.2':
    '<strong>調査型プロンプト：</strong>複数の情報源からの統合が必要になることもある、より複雑な情報収集の依頼。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.4.h': 'タスク志向・指示型',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.0':
    '<strong>指示型プロンプト：</strong>「書く」「作成する」「分析する」「要約する」といった動作を表す動詞を使った、明確で直接的な命令。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.1':
    '<strong>多段階タスク型プロンプト：</strong>大きなタスクを連続したステップに分解する複雑な指示。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.2':
    '<strong>テンプレート型プロンプト：</strong>AI が従うべき特定の形式や枠組みを与える構造化されたプロンプト。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.6.h': '分析・問題解決',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.0':
    '<strong>データ分析型プロンプト：</strong>データセットの分析、パターンの特定、知見の抽出を指示するもの。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.1':
    '<strong>問題解決型プロンプト：</strong>課題を提示し、解決策、戦略、提言を求めるもの。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.2':
    '<strong>比較分析型プロンプト：</strong>異なる選択肢の比較、代替案の評価、長所と短所の検討を指示するもの。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.8.h': '分類と整理',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.0':
    '<strong>分類型プロンプト：</strong>文章、データ、情報をあらかじめ定めたクラスやラベルに分類する指示。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.1':
    '<strong>並べ替え・順位付け型プロンプト：</strong>重要度、優先度、選好などの基準に従って情報を整理する依頼。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.2':
    '<strong>タグ付け・ラベル付け型プロンプト：</strong>整理や検索のために、コンテンツにタグ、ラベル、メタデータを付与する指示。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.10.h': '変換と整形',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.0':
    '<strong>翻訳型プロンプト：</strong>ある言語から別の言語へ文章を変換したり、異なる文化的文脈に合わせて内容を調整したりする指示。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.1':
    '<strong>形式変換型プロンプト：</strong>散文を箇条書きにするなど、情報の構造や見せ方を変える依頼。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.2':
    '<strong>文体変換型プロンプト：</strong>異なるトーンや文体で、あるいは異なる読者に向けて内容を書き直す指示。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.12.h': 'そのほかの種類のプロンプト',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.0':
    'ロールプレイ・ペルソナ型プロンプト',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.1':
    '対話・インタラクティブ型プロンプト',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.2':
    'システム・振る舞い制御型プロンプト',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.3': '推論・論理型プロンプト',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.4': 'コード・技術型プロンプト',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.5': '教育・研修型プロンプト',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.14.h':
    'Q：効果的なプロンプトはどのように書けばよいですか。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.15.p':
    '一般に、最も効果的なプロンプトは 4 つの要素で構成されます：<strong>(a) ペルソナ、(b) タスク、(c) コンテキスト、(d) 形式。</strong>',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.16.h': '(a) ペルソナ',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.17.p':
    'ペルソナとは、AI へのプロンプトを書くときに、自分自身について、あるいは A&GEL に演じてほしい役割について伝える情報です。これにより A&GEL を特定の文体やトーンへ導けます。ペルソナを加えると、自分により合った回答が得られます。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.18.prompt.label': '例',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.18.prompt.text':
    'あなたは 30 年の経験を持つ熟練の弁護士です。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.19.h': '(b) タスク',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.20.p':
    'モデルに与える指示です。最良の結果を得るには、タスクの指示を具体的にする必要があります。ただし、AI にタスクを与える際は、明確かつ簡潔であることも重要です。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.21.prompt.label': '例',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.21.prompt.text':
    'このドキュメントを 100 語以内で要約してください。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.22.h': '(c) コンテキスト',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.23.p':
    'A&GEL に与えるコンテキスト（すなわち情報）が、結果を大きく左右します。プロンプトから的を絞った結果を得るには、コンテキストが最善の手段です。出力を生成する際に A&GEL に特に考慮してほしい専門的な「知識」という形で、コンテキストを示すこともできます。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.24.prompt.label': '例',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.24.prompt.text':
    'この要約は、本取引における買主であるクライアント向けです。要約には買主の視点から見た取引の詳細を含めてください。\n\n知識：譲渡、更改、移転に関する条項は、支配権・所有権・持分の変動に関する規定や条項の例には当たりません。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.25.h': '(d) 形式',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.26.p':
    '出力の形式です。リスト、表、Markdown 形式などが選べます。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.27.prompt.label': '例',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.27.prompt.text':
    '要約は表の形式で示してください。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.28.callout.title':
    'プロンプトライブラリから始めましょう',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.28.callout.body':
    '効果的なプロンプトを書くひとつの方法は、効果が実証済みの既存のプロンプトを取り上げ、自分の目的に合わせて調整することです。プロンプトライブラリのタブに移動し、該当するプロンプトを「複製」して、自分の案件に合わせて調整してください。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.29.h':
    '完全な例 — ペルソナ + タスク + コンテキスト + 形式',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.30.prompt.label': 'プロンプトの全体例',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.30.prompt.text':
    'あなたは経験豊富な弁護士です。このドキュメントについて、簡潔な（それぞれ 100 語以内の）要約を作成してください。指示：(1) 述べられている主要な利点や肯定的な点を指摘することに重点を置いてください。別の箇条書きで、それを示すために引用されている事実の例を少なくとも 1 つ挙げてください。(b) 述べられている主要なリスクや不利な点についても同様に扱ってください。別の箇条書きで、それを示すために引用されている事実の例を少なくとも 1 つ挙げてください。要約全体の一貫性と明快さを保ってください。例や裏づけとなる論拠が複数ある場合は、記事の記述に従って、どれが最良または最悪かを述べてください。formal な表現を用い、中立的なトーンを維持してください。個人的な意見や解釈は含めないでください。出力はすべて Markdown 形式で示し、各要点には箇条書きを、特に重要な発見には太字を使用してください。成果物は上級の法務専門家によるレビューを受け、重要性の高い金融取引で使用されるため、正確かつ的確で、専門的なものでなければなりません。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.31.h':
    'Q：RAG とは何ですか。A&GEL はどのようなときに RAG を使いますか。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.32.p':
    '既定では、A&GEL のチャット機能は検索拡張生成（RAG）を使用します。これは、ファイルタブにアップロードした参考資料から情報を取得し、A&GEL に与えたプロンプトとともに生成部分（すなわち LLM）へ渡す仕組みです。A&GEL はその情報に、RAG によって追加されたコンテキストを加えて出力を生成します。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.33.p':
    'RAG と LLM 技術の組み合わせにより、A&GEL は文脈と関連情報を得て「拡張された回答」を生成できます。これが A&GEL の出力の精度を高め、ひいては回答が信頼できるものになる確率を高めます。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.34.h':
    'Q：すべてのプロンプトについて、アップロードした資料をすべて A&GEL に参照させてはいけないのはなぜですか。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.35.p':
    'プロンプトに関係のないアップロード済み資料を A&GEL に参照させないことを強くおすすめします。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.36.p':
    'A&GEL のような生成 AI ツールは、語、条項、契約などの意味を理解しているわけではありません。真の理解ではなく、確率的な方法で動作しています。チャットモードでは、すべてのファイルをコンテキストとして選択した場合、A&GEL はボールトのファイルにアップロードされたすべてのドキュメントから参照を引き出します。しかし、あなたのプロンプトに関係する資料は、特定の主題、さらには特定のワークフローに属するものだけかもしれません。目的に関係のないコンテキストを与えると、A&GEL の出力の速度、正確性、精密さ、信頼性はいずれも低下する可能性が高くなります。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.37.h':
    'Q：プロンプトごとに関連する参考資料を選ぶにはどうすればよいですか。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.38.p':
    'チャットモードで、厳密に関連する参考資料だけをプロンプトのコンテキストとして A&GEL に使わせるには、「コンテキスト」に移動し、選択アイコンをクリックして、関連するドキュメントやフォルダのみを選択してください。',
  'pages.angelInsider.issues.feature-faq.sections.3.kicker': '4 — 出力の使い方',
  'pages.angelInsider.issues.feature-faq.sections.3.heading': '正確性と信頼性を確認する',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.0.h':
    'Q：A&GEL にプロンプトを与えて出力を得ました。その出力をそのまま使ってもよいですか。',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.1.p':
    '一般に、A&GEL の出力を自分の成果物に使う前には、必ず確認すべきです。A&GEL の出力は出発点または参考として使うことのみをおすすめします。また、信頼できる情報源（アップロードした参考資料や検証済みの法務資料など）と常に照合してください。',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.2.h':
    'Q：出力の正確性と信頼性はどのように確認すべきですか。',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.3.p':
    'チャットモードでは、A&GEL の出力は可能な限り参照を含むよう最適化されています。これらの参照は、信頼できる情報（たとえばファイルタブにアップロードした資料）へのリンクです。',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.4.p':
    '<strong>A&GEL はノウハウへの入り口であるべきで、ノウハウそのものの源ではありません。</strong>各参照リンクをクリックすると、A&GEL がコンテキストを取得した参考資料を確認できます。正確性と信頼性を担保するため、A&GEL の出力は常にこれらの参考資料と照合してください。',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.5.p':
    'A&GEL のファイル管理を適切に行っていれば、参照リンクには参照されたドキュメントのファイルパスが表示されるため、A&GEL が正しい主題（およびワークフロー）の資料を使って出力を補強したかどうかも一目で把握できます。たとえば、「賃借権の譲渡人」の立場でプロンプトを与えているのに、A&GEL が「賃借権の譲受人」フォルダ内のドキュメントを参照していることに気づけば、その出力が目的に十分沿っていないとすぐに判断できます。',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.6.callout.title':
    '出力に参照がまったくない場合はどうすればよいですか。',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.6.callout.body':
    '参照のない出力は、信頼できる参考資料に根拠づけられていないため、ハルシネーションが起きやすくなります。参照が見当たらない場合、その出力に示された情報はほぼ確実にモデルの事前学習のみに由来しています。十分なコンテキストを与えたうえでの一般的な文章作成や文章編集に関するプロンプト（文書の平易化や校正など）、あるいは要約への回答であると確信できる場合を除き、その出力は使用しないでください。',
  'pages.angelInsider.issues.feature-faq.sections.4.kicker': '5 — 用語集',
  'pages.angelInsider.issues.feature-faq.sections.4.heading': 'A&GEL で使われる専門用語',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.0.p':
    '<strong>お気に入りファイル重み：</strong>回答を生成する際に、（ボールト内で）「お気に入り」に指定したドキュメントを A&GEL がどの程度優先するかを調整します。重みを高くすると、これらの優先する情報源が、ボールト内の一般的なファイルより大きく出力に影響します。',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.1.p':
    '<strong>再ランキング：</strong>A&GEL が最初の検索結果を見直し、最も関連性の高い条項やテキスト断片を優先する二次的な並べ替え処理です。これにより、回答が生成される前に、最も適切な情報が上位に来るようになります。',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.2.p':
    '<strong>検索比率：</strong>問い合わせに答えるために AI が取得する内部データの量を制御します。比率を高くすると検索範囲が広がり、より多くのコンテキストを取り込めます（広く探索したいときに有用です）。比率を低くすると完全一致に絞り込まれます（おおまかに言えば Ctrl+F に近い動作です）。',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.3.p':
    '<strong>システムプロンプト：</strong>A&GEL の具体的な役割、トーン、動作上の境界を定める基本的な指示の集合です（例：「あなたは 20 年の経験を持つシニアパートナーです」）。これらの設定は、A&GEL がその後のすべての依頼をどう処理するかを導く主要な枠組みとなります。',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.4.p':
    '<strong>「思考」または「推論」：</strong>最終的な回答を生成する前に、A&GEL が複雑な問い合わせを論理的に段階を追って分解する処理です。この内部的な検討は人間の推論を模したもので、複雑な分析における誤りを減らすことを目的としています。',
  'pages.angelInsider.issues.feature-faq.signoff.line':
    '新しいツールはどれも慣れるまでに少し時間がかかります。A&GEL も同じです。使えば使うほど、役に立つようになります。',
  'pages.angelInsider.issues.feature-faq.signoff.name': 'A&GEL 開発チーム',
  'pages.app.addCustomFieldsTitle': '各イベントで抽出するカスタムフィールドを追加',
  'pages.app.addCustomStepButton': 'カスタムステップ',
  'pages.app.addFieldButton': 'フィールドを追加',
  'pages.app.addFromLibraryButton': 'ライブラリから',
  'pages.app.addFromSavedButton': '保存済みの設定',
  'pages.app.addToMattersButton': '案件に追加',
  'pages.app.analysisType.agenticResearch.description':
    '選択したドキュメントとアップロードされたファイルを調査し、出典付きの包括的な回答をまとめます。',
  'pages.app.analysisType.agenticResearch.title': 'エージェンティックリサーチ',
  'pages.app.analysisType.comparison.description':
    '2 つのドキュメントを比較し、相違点をまとめたレポートを作成します。プロンプトを指定して比較の観点を絞り込むこともできます。',
  'pages.app.analysisType.comparison.title': '比較',
  'pages.app.analysisType.contractDeadlines.description':
    '契約書やドキュメントに記載されたすべての期限、重要な日付、期間を一覧化します。クライアントの詳細（例：「クライアントはネットバンキングを専門とするシンガポールの銀行です」）を伝えると精度が向上します。',
  'pages.app.analysisType.contractDeadlines.title': '期限を抽出',
  'pages.app.analysisType.executiveSummary.description':
    '主要な助言、論点、リスク、対応事項を簡潔にまとめたエグゼクティブサマリーを作成します。',
  'pages.app.analysisType.executiveSummary.title': 'エグゼクティブサマリー',
  'pages.app.analysisType.gartnerReport.description':
    '予測と提言を含む詳細な業界レポートを作成します。',
  'pages.app.analysisType.gartnerReport.title': 'Gartner 形式のレポート',
  'pages.app.analysisType.guidedSummary.description':
    'プロンプトに沿って、1 つのドキュメントの詳細な要約を作成します。',
  'pages.app.analysisType.multiStepPrompt.description':
    '複数のプロンプトを順番に実行し、各ステップの出力を積み上げていきます。',
  'pages.app.analysisType.multiStepPrompt.title': 'マルチステッププロンプト',
  'pages.app.analysisType.scopeOfWork.description':
    '支援やサービスの依頼が記載されたクライアントのメール、レター、RFP をアップロードまたは選択してください。「プロンプト」でクライアントの詳細（例：「クライアントはネットバンキングを専門とするシンガポールの銀行です」）を伝えると精度が向上します',
  'pages.app.analysisType.scopeOfWork.title': '業務範囲サマリー',
  'pages.app.analysisType.standardInfo.description':
    '簡潔な要約、注目すべき人物・組織の一覧、および出来事の短いタイムラインを作成します。ドキュメントは最大 100 件まで指定できます。',
  'pages.app.analysisType.timeline.description':
    '最大 100 件のドキュメントにわたる詳細な出来事のタイムラインを作成します。',
  'pages.app.analyzingFiles': 'ファイルを分析しています...',
  'pages.app.applicablePartiesColumnTitle': '該当当事者',
  'pages.app.appsInstructions':
    '対象とするファイルを複数選択し、下のリストから分析の種類を選んでください。処理には 1〜5 分程度かかります。',
  'pages.app.appsList.agenticResearch.description':
    '選択したドキュメントとアップロードされたファイルを調査し、出典付きの包括的な回答をまとめます。',
  'pages.app.appsList.contractDeadlines.description':
    '契約書やドキュメントに記載されたすべての期限、重要な日付、期間を一覧化します。',
  'pages.app.appsList.executiveSummary.description':
    '経営層向けに、要点・調査結果・提言を俯瞰的にまとめます',
  'pages.app.appsList.gartnerReport.description':
    '確度が高く客観的な調査手法による、詳細な業界分析',
  'pages.app.appsList.guidedSummary.description':
    'プロンプトに沿って、1 つのドキュメントの詳細な要約を作成します',
  'pages.app.appsList.multiStepPrompt.description':
    '複数のプロンプトを順番に実行し、各ステップの出力を積み上げます',
  'pages.app.appsList.scopeOfWork.description':
    '支援やサービスの依頼が記載されたクライアントのメール、レター、RFP をアップロードまたは選択してください。',
  'pages.app.appsList.standardInfo.description':
    '簡潔な要約、人物・組織の一覧、短いタイムラインを作成します',
  'pages.app.appsList.timeline.description':
    '最大 100 件のドキュメントにわたる詳細な出来事のタイムラインを作成します',
  'pages.app.appsTitle': 'アプリ',
  'pages.app.backToSavedPromptsLabel': '保存済みプロンプトに戻る',
  'pages.app.backgroundColumnTitle': '背景',
  'pages.app.buildMultiStepPromptTitle': 'マルチステッププロンプトを作成',
  'pages.app.buildNewButton': '新しい設定',
  'pages.app.clauseColumnTitle': '条項',
  'pages.app.clearStepsButton': 'クリア',
  'pages.app.clearStepsConfirm': 'リストからすべてのステップを削除しますか？',
  'pages.app.clientDetailsPlaceholder': 'クライアントの名称と簡単な詳細',
  'pages.app.clientInformationTitle': 'クライアント情報',
  'pages.app.clientLabel': 'クライアント',
  'pages.app.collapseAllPrompts': 'すべてのプロンプトを折りたたむ',
  'pages.app.collapsePrompt': 'プロンプトを折りたたむ',
  'pages.app.compilingFinalSummary': '最終サマリーをまとめています...',
  'pages.app.complexityLabel': '複雑度',
  'pages.app.configNameLabel': '設定名',
  'pages.app.configTagsLabel': 'タグ',
  'pages.app.configurationDeletedSuccess': '設定を削除しました',
  'pages.app.configurationSavedSuccess': '設定を保存しました',
  'pages.app.configurationUpdatedSuccess': '設定を更新しました',
  'pages.app.contactLabel': '連絡先',
  'pages.app.counterpartyLabel': '相手方',
  'pages.app.dateReferenceColumnTitle': '日付／参照',
  'pages.app.deadlinesSectionTitle': '期限',
  'pages.app.deleteConfigConfirmTitle': 'この設定を削除してもよろしいですか？',
  'pages.app.deleteStepTooltip': 'ステップを削除',
  'pages.app.detailsColumnTitle': '詳細',
  'pages.app.doneCount': '完了（{completed}/{total}）',
  'pages.app.dragHereToUpload': 'ここにドラッグしてアップロード',
  'pages.app.dragStepTooltip': 'ステップをドラッグ',
  'pages.app.dropZoneForNamedStep': '{stepName} のドロップ領域',
  'pages.app.dropZoneForStepNumber': 'ステップ {stepNumber} のドロップ領域',
  'pages.app.durationColumnTitle': '期間',
  'pages.app.enterConfigNamePlaceholder': '設定名を入力',
  'pages.app.enterDescriptionPlaceholder': '説明を入力',
  'pages.app.enterTagsPlaceholder': 'タグを入力して Enter キーを押してください',
  'pages.app.entitiesColumnTitle': '組織・団体',
  'pages.app.expandAllPrompts': 'すべてのプロンプトを展開',
  'pages.app.expandPrompt': 'プロンプトを展開',
  'pages.app.extendPromptTabLabel': 'プロンプトを拡張',
  'pages.app.extraFieldDescriptionPlaceholder': '説明（例：記載されている金額を抽出する）',
  'pages.app.extraFieldKeyPlaceholder': 'キー（例：予算）',
  'pages.app.extractColumnTitle': '抽出',
  'pages.app.extractDeadlinesModalDescription':
    '契約書やドキュメントに記載されたすべての期限、重要な日付、期間を一覧化します。クライアントの詳細（例：「クライアントはネットバンキングを専門とするシンガポールの銀行です」）を伝えると精度が向上します',
  'pages.app.fileCountLabel': '{count} 件のファイル',
  'pages.app.filesCompleteCount': '{completed}/{total} 件のファイルが完了',
  'pages.app.hardDeadlineColumnTitle': '確定期限',
  'pages.app.inProgressSuffix': '（進行中）',
  'pages.app.keyDatesDeadlinesTitle': '重要な日付と期限',
  'pages.app.libraryPanelTitle': 'プロンプトライブラリ',
  'pages.app.loadSavedConfigPlaceholder': '保存済みの設定を読み込む',
  'pages.app.loadingDocumentTip': 'ドキュメントを読み込んでいます...',
  'pages.app.mattersUpdatedSuccess': '案件を更新しました',
  'pages.app.moveStepDownTooltip': '下へ移動',
  'pages.app.moveStepUpTooltip': '上へ移動',
  'pages.app.newAnalysisModesDescription':
    '契約書をより有効に活用できるよう、強力な分析モードを 2 つ新たに追加しました。',
  'pages.app.newAnalysisModesTitle': '新しい分析モード',
  'pages.app.newFieldDefaultKey': 'フィールド {number}',
  'pages.app.newSessionLabel': '新しいセッション',
  'pages.app.newStepDefaultName': '新しいステップ',
  'pages.app.noSourceDocumentsDescription': '出典ドキュメントがありません',
  'pages.app.noTimelineItemsExtracted': 'タイムラインの項目が抽出されませんでした。',
  'pages.app.overallTabLabel': '全体',
  'pages.app.overviewSectionTitle': '概要',
  'pages.app.partiesSectionTitle': '当事者',
  'pages.app.peopleEntitiesInvolvedLabel': '関係する人物／組織',
  'pages.app.periodsDurationsTitle': '期間',
  'pages.app.pleaseEnterPlaceholder': '入力してください',
  'pages.app.processingNextStep': '次のステップを処理しています...',
  'pages.app.promptForStepPlaceholder': 'このステップのプロンプト',
  'pages.app.promptLabelWithValue': 'プロンプト：{prompt}',
  'pages.app.provideDetailsTabLabel': '詳細を入力',
  'pages.app.provideDocumentsTabLabel': 'ドキュメントを指定',
  'pages.app.providePromptsTabLabel': 'プロンプトを入力',
  'pages.app.provisionColumnTitle': '規定',
  'pages.app.publishAudienceGroupsLabel': 'グループ',
  'pages.app.publishAudienceLabel': '公開範囲',
  'pages.app.publishAudienceOptionFirmWide': '事務所全体',
  'pages.app.publishAudienceOptionGroup': 'グループ',
  'pages.app.publishAudienceOptionPublic': '全体公開',
  'pages.app.publishButton': '公開',
  'pages.app.publishConfigTitle': '設定を公開',
  'pages.app.publishFirmWideNotice':
    'この設定は組織内の全員と共有されます。承認のため組織管理者にリクエストが送信されます。',
  'pages.app.publishPublicNotice':
    'この設定はすべてのユーザーに表示されます。承認のためスーパー管理者にリクエストが送信されます。',
  'pages.app.publishRequestSubmitted':
    '公開リクエストを送信しました — 管理者の承認をお待ちください',
  'pages.app.publishedToGroup': 'グループに公開しました',
  'pages.app.readingDocumentName': '{name} を読み込んでいます',
  'pages.app.restrictionColumnTitle': '制限',
  'pages.app.restrictiveCovenantsTitle': '制限的誓約条項',
  'pages.app.reuseButton': '再利用',
  'pages.app.runAppButton': 'アプリを実行',
  'pages.app.sanitizedCheckingDocuments': 'ドキュメントを確認しています…',
  'pages.app.sanitizedSearchingDocuments': 'ドキュメントを検索しています…',
  'pages.app.sanitizedWorkingThroughDocuments': 'ドキュメントを処理しています…',
  'pages.app.saveAsConfigButton': '名前を付けて保存',
  'pages.app.saveConfigButton': '設定を保存',
  'pages.app.saveConfigurationTitle': '設定を保存',
  'pages.app.savedPromptStepCount': '{count, plural, other {# ステップ}}',
  'pages.app.savedPromptsEmpty': '保存済みのマルチステッププロンプトが見つかりません',
  'pages.app.savedPromptsPanelTitle': '保存済みの設定を選択',
  'pages.app.savedPromptsSearchPlaceholder': '保存済みプロンプトを検索...',
  'pages.app.savedPromptsTagFilterPlaceholder': 'タグで絞り込む',
  'pages.app.scopeOfWorkModalDescription':
    '支援やサービスの依頼が記載されたクライアントのメール、レター、RFP をアップロードまたは選択してください。「プロンプト」でクライアントの詳細（例：「クライアントはネットバンキングを専門とするシンガポールの銀行です」）を伝えると精度が向上します',
  'pages.app.searchMattersPlaceholder': '案件を検索...',
  'pages.app.searchPromptsPlaceholder': 'プロンプトを検索...',
  'pages.app.selectAtLeastOneGroupError': 'グループを 1 つ以上選択してください',
  'pages.app.selectDocumentsStepTitle': '1. 分析したいドキュメントを選択してください',
  'pages.app.selectMattersLabel': '案件を選択：',
  'pages.app.sharedConfigLabel': '{name}（共有）',
  'pages.app.sourcesColumnTitle': '出典',
  'pages.app.specialRequestsSectionTitle': '特記事項',
  'pages.app.specificInformationStepTitle': '2. 個別情報（任意）',
  'pages.app.stepNamePlaceholder': 'ステップ名（例：エンティティの抽出）',
  'pages.app.stepNumberLabel': 'ステップ {number}',
  'pages.app.stepsAddedFromConfig': '{count, plural, other {# ステップを追加しました}}',
  'pages.app.subagentLabel': 'サブエージェント {number}',
  'pages.app.subjectLabel': '件名',
  'pages.app.summaryLabel': '要約',
  'pages.app.timelineFieldsDescription':
    'タイムラインに表示したい追加の列を定義します。各フィールドについて、キー（列見出し）と抽出したい情報の説明を入力してください。',
  'pages.app.tool.checkingDocuments': 'ドキュメントを確認中',
  'pages.app.tool.readingDocument': 'ドキュメントを読み込み中',
  'pages.app.tool.searchingDocuments': 'ドキュメントを検索中',
  'pages.app.tool.workingWithName': '処理中（{name}）',
  'pages.app.tool.writingReport': 'レポートを作成中',
  'pages.app.untitledSession': '（無題）',
  'pages.app.updateConfigButton': '更新',
  'pages.app.updateConfigurationTitle': '設定を更新',
  'pages.app.updateMattersFailed': '案件の更新に失敗しました',
  'pages.app.uploadOrSelectFilesError':
    'ファイルをアップロードするか、既存のファイルを選択してください',
  'pages.app.urgencyColumnTitle': '緊急度',
  'pages.app.useAnotherAppButton': '別のアプリを使う',
  'pages.app.whatsNew': '新着情報',
  'pages.app.workingEllipsis': '処理中…',
  'pages.app.workingThroughDocumentsCount': 'ドキュメントを処理しています（{completed}/{total}）',
  'pages.chat.addToMatters': '案件に追加',
  'pages.chat.agentQuestion.answersSent': '回答をエージェントに送信しました',
  'pages.chat.agentQuestion.customAnswerPlaceholder': 'または独自の回答を入力...',
  'pages.chat.agentQuestion.dismissQuestion': '質問を閉じる',
  'pages.chat.agentQuestion.noAnswer': '（回答なし）',
  'pages.chat.agentQuestion.question': '質問',
  'pages.chat.agentQuestion.questionOfTotal': '質問 {current} / {total}',
  'pages.chat.agentQuestion.questionProgress': '{current} / {total}',
  'pages.chat.agentQuestion.reviewAnswers': '回答を確認',
  'pages.chat.agentQuestion.reviewYourAnswers': '送信する前に回答をご確認ください。',
  'pages.chat.agentQuestion.seeLess': '表示を減らす',
  'pages.chat.agentQuestion.seeMore': 'さらに表示',
  'pages.chat.agentQuestion.sendAnswers': '回答を送信',
  'pages.chat.agentQuestion.submitted': '送信済み',
  'pages.chat.agentQuestion.summary': '要約',
  'pages.chat.agenticRag': 'エージェンティック RAG',
  'pages.chat.agenticRag.lockedByDeepResearch':
    'ディープリサーチを使用するには、この機能を有効にする必要があります。',
  'pages.chat.agenticRag.description':
    'エージェントがコンテキストのファイルを検索するタイミングを判断します',
  'pages.chat.agenticRag.tooltip':
    '出典付きのエージェンティック検索を有効にします。チャットのコンテキストにドキュメントが必要です。',
  'pages.chat.allowSelfPrompting': '自己プロンプトを許可',
  'pages.chat.allowSelfPrompting.description':
    'エージェントがライブラリから適したプロンプトを適用します',
  'pages.chat.allowSelfPrompting.tooltip':
    '有効にすると、回答を改善するために、アシスタントがライブラリのプロンプトを提案・適用することがあります。',
  'pages.chat.attachedDocument': '添付ドキュメント',
  'pages.chat.auth.contentOpenedInNewTab': 'コンテンツを新しいタブで開きました',
  'pages.chat.auth.dataOpenedInNewTab': 'データを新しいタブで開きました',
  'pages.chat.auth.failedToFetchUrl': 'URL の取得に失敗しました：{error}',
  'pages.chat.auth.failedToOpenNewTab': '新しいタブを開けませんでした',
  'pages.chat.auth.fileOpenedInNewTab': 'ファイルを新しいタブで開きました',
  'pages.chat.auth.jsonResponseTitle': 'JSON レスポンス',
  'pages.chat.auth.textResponseTitle': 'テキストレスポンス',
  'pages.chat.cannotCopyNonTextContent': 'テキスト以外の内容はコピーできません',
  'pages.chat.chatTitle': 'チャット',
  'pages.chat.clickOrDragToUpload': 'クリックまたはドラッグしてアップロード',
  'pages.chat.connectionInterrupted': '接続が中断されました。{retry}してください。',
  'pages.chat.context.custom': 'カスタム {suffix}',
  'pages.chat.context.defaultWithName': 'デフォルト（{name}）',
  'pages.chat.context.fullContext': '全コンテキスト',
  'pages.chat.context.label': 'コンテキスト',
  'pages.chat.context.selectedLabel': '件選択中',
  'pages.chat.customisation': 'カスタマイズ',
  'pages.chat.dragHereToUpload': 'ここにドラッグしてアップロード',
  'pages.chat.emptyState.desktopTitle': '本日は A&GEL にどのようなお手伝いをご希望ですか？',
  'pages.chat.emptyState.mobileTitle': 'A&GEL に何をお手伝いさせますか？',
  'pages.chat.emptyState.subtitle':
    '下のプロンプトを選んですぐに始めるか、直接入力して A&GEL とチャットしてください。',
  'pages.chat.failedToCopyMessage': 'メッセージのコピーに失敗しました',
  'pages.chat.failedToDownloadFile': 'ファイルのダウンロードに失敗しました：{error}',
  'pages.chat.fileDownloadedSuccessfully': 'ファイルをダウンロードしました',
  'pages.chat.filesInVault': 'ボールト内のファイル',
  'pages.chat.home': 'ホーム',
  'pages.chat.htmlContentIframeTitle': 'HTML コンテンツ',
  'pages.chat.messageCopied': 'メッセージをコピーしました',
  'pages.chat.newChatConfirm.content':
    '現在のチャット履歴を消去して、新しいセッションを開始してもよろしいですか？',
  'pages.chat.newChatConfirm.okText': 'はい、新しいチャットを開始します',
  'pages.chat.newChatConfirm.title': '新しいチャットを開始しますか？',
  'pages.chat.nextStep.button': '次のステップ',
  'pages.chat.nextStep.review': 'レビュー',
  'pages.chat.nextStep.workstudio': 'ワークスタジオ',
  'pages.chat.referenceDocument': '参照ドキュメント',
  'pages.chat.referenceTitle': '参照：{title}',
  'pages.chat.referencesCount': '{count} 件の参照',
  'pages.chat.selectedContext': '選択中のコンテキスト',
  'pages.chat.selfPromptedUsing': '{name} を使って自己プロンプトを行いました。',
  'pages.chat.showMoreLines': 'さらに表示（{count} 行）',
  'pages.chat.sourcesCount': '出典（{count}）',
  'pages.chat.startNewChat': '新しいチャットを開始',
  'pages.chat.starterPrompt.caseSummariser.description':
    'シンガポールの判例を要約するための、法的コンテキストを含む詳細なプロンプト。',
  'pages.chat.starterPrompt.caseSummariser.name': '判例要約',
  'pages.chat.starterPrompt.draftChecklist.description':
    '任意のドキュメントから A&GEL にチェックリストを作成させるプロンプト。',
  'pages.chat.starterPrompt.draftChecklist.name': 'チェックリストを作成',
  'pages.chat.starterPrompt.summariseArticle.description': '記事を要約する汎用プロンプト。',
  'pages.chat.starterPrompt.summariseArticle.name': 'この記事を要約',
  'pages.chat.status.completed': '完了',
  'pages.chat.status.working': '処理中',
  'pages.chat.toolCategory.compare': 'テキストを比較中',
  'pages.chat.toolCategory.generate': 'ドキュメントを生成中',
  'pages.chat.toolCategory.read': 'ドキュメントを読み込み中',
  'pages.chat.toolCategory.searchDoc': 'ドキュメントを検索中',
  'pages.chat.toolCategory.searchFiles': 'ファイルを検索中',
  'pages.chat.toolCategory.selfInstruction': '指示を適用中',
  'pages.chat.transientFiles': '一時ファイル',
  'pages.chat.unknownFileName': '不明',
  'pages.chat.unknownFileNameLong': '不明なファイル',
  'pages.chat.untitledSession': '（無題）',
  'pages.chat.upload.failedToUploadFile': '{fileName} のアップロードに失敗しました',
  'pages.chat.upload.fileTypeNotAllowed':
    'このファイル形式は使用できません。PDF、DOC、DOCX、MSG、EML、TXT、MD、XLS、XLSX、PPT、PPTX のみ使用できます。',
  'pages.chat.upload.onlyAllowedTypes':
    'PDF、DOC、DOCX、MSG、EML、TXT、MD、XLS、XLSX、PPT、PPTX のファイルのみアップロードしてください',
  'pages.chat.upload.someFilesSkipped':
    '一部のファイルがスキップされました。PDF、DOC、DOCX、MSG、EML、TXT、MD、XLS、XLSX、PPT、PPTX のファイルのみ使用できます',
  'pages.chat.uploadedImageAlt': 'アップロード済み',
  'pages.chat.waiting.almostThere': 'もう少しです...',
  'pages.chat.waiting.fetchingThatForYou': '取得しています...',
  'pages.chat.waiting.hangTight': '対応中です。もう少しお待ちください...',
  'pages.chat.waiting.holdOnRetrieving': '少々お待ちください。情報を取得しています...',
  'pages.chat.waiting.justAMoment': '少々お待ちください...',
  'pages.chat.waiting.letMeCheck': '確認しています...',
  'pages.chat.waiting.lookingThatUp': 'お調べしています...',
  'pages.chat.waiting.oneSecPlease': '少々お待ちください...',
  'pages.chat.waiting.workingOnIt': '対応中です...',
  'pages.chat.outlookSearch.offTooltip': 'Outlook メールを検索',
  'pages.chat.outlookSearch.onTooltip': 'Outlook 検索はオンです',
  'pages.chat.outlookSearch.connectTooltip':
    'Outlook のメールを検索するには Microsoft に接続してください',
  'pages.chat.outlookSearch.permissionMissing':
    'Outlook 検索にはメールの読み取り権限が必要です。もう一度お試しください。',
  'pages.chat.webSearch.confidentialityNotice':
    'ウェブ検索がオンになっています。プロンプトに依頼者の秘密情報や秘匿特権の対象となる情報を含めないでください。',
  'pages.chat.researchPlan.complete': '調査完了',
  'pages.chat.researchReport.tab.report': 'レポート',
  'pages.chat.researchReport.tab.searches': '検索 ({count})',
  'pages.chat.researchReport.tab.sources': '出典 ({count})',
  'pages.chat.researchReport.noSearches': 'このレポートに記録された検索はありません。',
  'pages.chat.researchReport.noSources': 'このレポートで引用された出典はありません。',
  'pages.chat.researchReport.openReport': 'レポートを表示',
  'pages.chat.researchReport.counts': '検索 {searches} 件 · 出典 {sources} 件',
  'pages.chat.researchReport.title': '調査レポート',
  'pages.chat.researchReport.open': 'レポート全文を開く',
  'pages.chat.researchPlan.ready': '開始できます',
  'pages.chat.researchPlan.editing': '編集中',
  'pages.chat.researchPlan.addTopic': 'トピックを追加',
  'pages.chat.researchPlan.editSubtitle':
    '下のトピックを編集してください。変更は調査開始前に適用されます。',
  'pages.chat.researchPlan.cancel': 'キャンセル',
  'pages.chat.researchPlan.saveChanges': '変更を保存',
  'pages.chat.researchPlan.showDetails': '詳細を表示',
  'pages.chat.researchPlan.working': '処理中 ({done}/{total})',
  'pages.chat.researchPlan.stop': '停止',
  'pages.chat.researchPlan.viewProgress': '進捗を表示',
  'pages.chat.researchPlan.progressTitle': '調査の進捗',
  'pages.chat.researchPlan.tab.progress': '進捗',
  'pages.chat.research.copied': 'レポートをコピーしました',
  'pages.chat.research.copyFailed': 'レポートをコピーできませんでした',
  'pages.chat.research.pageRead': '読み込み済み',
  'pages.chat.research.tableOfContents': '目次',
  'pages.chat.research.resizeContents': '目次の幅を変更',
  'pages.chat.research.windowTitle': '調査',
  'pages.chat.research.completed': '完了',
  'pages.chat.research.running': '進行中',
  'pages.chat.research.stopped': '停止済み',
  'pages.chat.research.failed': '失敗',
  'pages.chat.research.tab.report': 'レポート',
  'pages.chat.research.tab.searches': '検索 ({count})',
  'pages.chat.research.tab.sources': '出典 ({count})',
  'pages.chat.research.reportPending': 'レポートは作成されるとここに表示されます。',
  'pages.chat.research.noSearches': 'まだ検索はありません。',
  'pages.chat.research.noSources': 'まだ出典はありません。',
  'pages.chat.research.searchSent': '送信済み',
  'pages.chat.research.searchRunning': '検索中',
  'pages.chat.research.searchSkipped': 'スキップ',
  'pages.chat.researchPlan.title': '調査プラン',
  'pages.chat.researchPlan.stepCount': '{count, plural, other {#件のステップ}}',
  'pages.chat.researchPlan.inProgress': '調査を実行中',
  'pages.chat.researchPlan.edit': '編集',
  'pages.chat.researchPlan.done': '完了',
  'pages.chat.researchPlan.start': '調査を開始',
  'pages.chat.researchPlan.addStep': 'ステップを追加',
  'pages.chat.researchPlan.removeStep': 'ステップ{number}を削除',
  'pages.chat.researchPlan.includeStep': 'ステップ{number}を含める',
  'pages.chat.researchPlan.started': '調査を開始しました',
  'pages.chat.webSearch.googleSuggestions': 'Google 検索の候補',
  'pages.chat.webSearch.permission.title': '検索の許可',
  'pages.chat.webSearch.permission.manual': '手動',
  'pages.chat.webSearch.permission.manualDescription': '送信前に各クエリを確認します',
  'pages.chat.webSearch.permission.auto': '自動',
  'pages.chat.webSearch.permission.autoDescription':
    '確認なしで実行されます。クエリは事務所外に送信されます',
  'pages.chat.webSearch.permission.deep': 'ディープリサーチ',
  'pages.chat.webSearch.permission.deepDescription': '計画を立てて多数の検索を実行します。常に自動',
  'pages.comparison.analysisFallbackTitle': '分析',
  'pages.comparison.outcomeUnverified': '未検証',
  'pages.comparison.commentTags': 'コメントタグ',
  'pages.comparison.allCommentTags': 'すべてのコメントタグ',
  'pages.comparison.noMatchingComments': '選択したタグに一致するコメントはありません',
  'pages.comparison.downloadExcel': 'Excelをダウンロード',
  'pages.comparison.stopSuccess': '比較を停止しました。途中までの結果を確認できます。',
  'pages.comparison.stopFailed': '比較の停止に失敗しました',
  'pages.comparison.uploadSuccess': '{fileName} をアップロードしました',
  'pages.comparison.uploadFailed': '{fileName} のアップロードに失敗しました',
  'pages.comparison.uploadLimitExceeded':
    'このタスク種別でアップロードできるファイルは {max} 件までです。',
  'pages.comparison.pollingTimeout':
    'ポーリングがタイムアウトしました。タスクの処理はまだ続いている可能性があります。',
  'pages.comparison.taskStarted': '比較タスクを開始しました',
  'pages.comparison.startFailed': '比較の開始に失敗しました',
  'pages.comparison.previousAnalysisTitle': '前の分析',
  'pages.comparison.analysisPositionCounter': '{current} / {total}',
  'pages.comparison.analysisFoundCounter': '{total} 件',
  'pages.comparison.nextAnalysisTitle': '次の分析',
  'pages.comparison.messageHeading': 'メッセージ',
  'pages.comparison.noResultsYet': 'まだ結果がありません',
  'pages.comparison.startComparisonButton': '比較を開始',
  'pages.comparison.newComparisonButton': '新しい比較を開始',
  'pages.comparison.searchComparisonsPlaceholder': '比較を検索',
  'pages.comparison.reuseButton': '再利用',
  'pages.comparison.selectMattersLabel': '案件を選択：',
  'pages.comparison.searchMattersPlaceholder': '案件を検索...',
  'pages.comparison.mattersUpdated': '案件を更新しました',
  'pages.comparison.mattersUpdateFailed': '案件の更新に失敗しました',
  'pages.comparison.addToMattersButton': '案件に追加',
  'pages.comparison.untitled': '（無題）',
  'pages.comparison.processingMoreResults': '追加の結果を処理しています...',
  'pages.comparison.processingComparison': '比較を処理しています...',
  'pages.comparison.taskType.strikethroughUnderline.label': '取り消し線と下線',
  'pages.comparison.taskType.strikethroughUnderline.description':
    '通常の取り消し線と下線の書式で示された変更を分析します。',
  'pages.comparison.taskType.trackedChanges.label': '変更履歴',
  'pages.comparison.taskType.trackedChanges.description':
    '変更履歴機能で行われた修正とコメントを確認します。',
  'pages.comparison.taskType.twoVersions.label': '2 つのバージョン',
  'pages.comparison.taskType.twoVersions.description':
    'ドキュメントの別々の 2 つのバージョンを比較し、相違点を特定します。',
  'pages.comparison.taskType.referenceDocument.label': '対象と参照',
  'pages.comparison.taskType.referenceDocument.description':
    '対象ドキュメントを参照ドキュメント（タームシートなど）と比較します。',
  'pages.comparison.requirement.singleDocument': 'ドキュメント 1 件',
  'pages.comparison.requirement.twoDocuments': 'ドキュメント 2 件',
  'pages.comparison.startHereTab': 'ここから始める',
  'pages.comparison.selectDocumentsPrompt': '比較を行うドキュメントを選択してください',
  'pages.comparison.dragUploadText': 'クリックまたはファイルをこの領域にドラッグしてアップロード',
  'pages.comparison.swapOrderButton': '順序を入れ替える',
  'pages.comparison.fileLabel.old': '（旧）',
  'pages.comparison.fileLabel.new': '（新）',
  'pages.comparison.fileLabel.reference': '（参照）',
  'pages.comparison.fileLabel.target': '（対象）',
  'pages.comparison.customInstructionTab': 'カスタム指示（任意）',
  'pages.comparison.modifyPromptTitle': 'プロンプトを変更',
  'pages.comparison.customInstructionPlaceholder':
    'A&GEL への具体的な指示を入力してください（例：「クライアントは XYZ です。クライアントに影響する修正に注目してください」「マレー語でコメントしてください」など）',
  'pages.comparison.pageTitle': '比較',
  'pages.comparison.legalReviewDescription':
    '比較は、修正に対する「リーガルレビュー」を行うよう最適化されています（既定では、修正から生じる法的影響についてコメントします）。',
  'pages.comparison.similarDocumentComparisonTitle': '類似ドキュメントの比較',
  'pages.comparison.referenceDocumentComparisonTitle': '参照ドキュメントとの比較',
  'pages.comparison.dragHereToUpload': 'ここにドラッグしてアップロード',
  'pages.comparison.documentCount.unknownFile': '不明なファイル',
  'pages.comparison.documentCount.fileCount': '{count} 件のファイル',
  'pages.comparison.reviewDirection.reviewedOnBehalfOf': 'レビュー対象の立場：',
  'pages.comparison.reviewDirection.swapButton': 'レビューの立場を入れ替える',
  'pages.comparison.invalidFileDocxOrPdf':
    '{fileName} は有効な .docx または .pdf ファイルではありません',
  'pages.comparison.invalidFileDocx': '{fileName} は有効な .docx ファイルではありません',
  'pages.comparison.twoVersionsFileCountError':
    '2 つのバージョンの比較には、ドキュメントをちょうど 2 件アップロードしてください。',
  'pages.comparison.singleFileCountError':
    'このタスクには、ドキュメントをちょうど 1 件アップロードしてください。',
  'pages.composer.changeAction.accept': '承認',
  'pages.composer.changeAction.reject': '却下',
  'pages.composer.changeAction.reset': 'リセット',
  'pages.composer.documentView.foundCount': '{count} 件',
  'pages.composer.documentView.nextChangeArrow': '次へ ↓',
  'pages.composer.documentView.nextChangeTitle': '次の変更',
  'pages.composer.documentView.positionCount': '{current} / {total}',
  'pages.composer.documentView.previousChangeTitle': '前の変更',
  'pages.composer.documentView.stepNumber': 'ステップ {number}',
  'pages.composer.documentView.turnNumber': 'ターン {number}',
  'pages.composer.playbook.askAgel': 'A&GEL に質問',
  'pages.composer.playbook.chooseDocumentDescription':
    '.docx を選択すると、そのキャンバスとチャットが開きます。',
  'pages.composer.playbook.chooseDocumentTitle': '開始するドキュメントを選択してください',
  'pages.composer.playbook.createSessionFailed': 'ワークスタジオのセッション作成に失敗しました',
  'pages.composer.playbook.documentCanvas': 'ドキュメントキャンバス',
  'pages.composer.playbook.docxOnlyAllowedError':
    'ワークスタジオモードでは .docx ファイルのみ使用できます',
  'pages.composer.playbook.docxOnlySkippedWarning':
    '一部のファイルがスキップされました。.docx ファイルのみ使用できます',
  'pages.composer.playbook.docxOnlySupportedError':
    'ワークスタジオモードでは .docx ファイルのみ対応しています',
  'pages.composer.playbook.downloadGenerating': '生成中…',
  'pages.composer.playbook.dragToUpload': 'ここにドラッグしてアップロード',
  'pages.composer.playbook.fileUploadFailed': '{fileName} のアップロードに失敗しました',
  'pages.composer.playbook.fileUploadedSuccess': '{fileName} をアップロードしました',
  'pages.composer.playbook.newButtonText': '新しいワークスタジオ',
  'pages.composer.playbook.openFailed': 'ワークスタジオを開けませんでした',
  'pages.composer.playbook.reuseButton': '再利用',
  'pages.composer.playbook.resizeChatPane': 'チャット領域のサイズを変更',
  'pages.composer.playbook.searchPlaceholder': 'ワークスタジオを検索',
  'pages.composer.playbook.title': 'ワークスタジオ',
  'pages.composer.playbook.tryGuidedSample': 'ガイド付きサンプルを試す',
  'pages.composer.playbookReview.acceptAllButton': 'すべて承認',
  'pages.composer.playbookReview.acceptChangeError':
    '変更の承認に失敗しました。もう一度お試しください。',
  'pages.composer.playbookReview.addCommentButton': 'コメント',
  'pages.composer.playbookReview.addCommentPlaceholder': 'コメントを追加...',
  'pages.composer.playbookReview.addCommentTooltip': 'コメントを追加',
  'pages.composer.playbookReview.allAcceptError':
    'すべての変更の承認に失敗しました。もう一度お試しください。',
  'pages.composer.playbookReview.allAcceptedSuccess': 'すべての変更を承認しました',
  'pages.composer.playbookReview.allRejectError':
    'すべての変更の却下に失敗しました。もう一度お試しください。',
  'pages.composer.playbookReview.allRejectedSuccess': 'すべての変更を却下しました',
  'pages.composer.playbookReview.allResetError':
    'すべての変更のリセットに失敗しました。もう一度お試しください。',
  'pages.composer.playbookReview.allResetSuccess': 'すべての変更を保留中にリセットしました',
  'pages.composer.playbookReview.backToWorkstudio': 'ワークスタジオに戻る',
  'pages.composer.playbookReview.changeOfTotal': '変更 {index} / {total}',
  'pages.composer.playbookReview.commentSaveError':
    'コメントの保存に失敗しました。もう一度お試しください。',
  'pages.composer.playbookReview.commentSavedSuccess': 'コメントを保存しました',
  'pages.composer.playbookReview.discardDraftButton': '下書きを破棄',
  'pages.composer.playbookReview.documentLoadFailedError':
    'このドキュメントを読み込めません。ページを更新してもう一度お試しください。',
  'pages.composer.playbookReview.documentViewAriaLabel': 'ドキュメント表示',
  'pages.composer.playbookReview.doneEditingButton': '完了',
  'pages.composer.playbookReview.downloadGenericError': 'ダウンロードの生成に失敗しました',
  'pages.composer.playbookReview.downloadInfoTooltip':
    '各ターンは引き続きレビューできます。ダウンロードすると、承認済みおよび保留中のレイヤーを適用した現在の統合ドキュメントが生成されます。',
  'pages.composer.playbookReview.downloadSuccess': 'ドキュメントをダウンロードしました',
  'pages.composer.playbookReview.downloadTimeoutError': 'ダウンロードの生成がタイムアウトしました',
  'pages.composer.playbookReview.editCommentButton': 'コメントを編集',
  'pages.composer.playbookReview.editCommentTooltip': 'コメントを編集',
  'pages.composer.playbookReview.editDocumentButton': '編集',
  'pages.composer.playbookReview.groupAcceptAllCount': 'すべて承認（{count}）',
  'pages.composer.playbookReview.groupAcceptedError':
    '変更の承認に失敗しました。もう一度お試しください。',
  'pages.composer.playbookReview.groupAcceptedSuccess': '同一の変更 {count} 件を承認しました',
  'pages.composer.playbookReview.groupRejectAllCount': 'すべて却下（{count}）',
  'pages.composer.playbookReview.groupRejectedError':
    '変更の却下に失敗しました。もう一度お試しください。',
  'pages.composer.playbookReview.groupRejectedSuccess': '同一の変更 {count} 件を却下しました',
  'pages.composer.playbookReview.groupResetAllCount': 'すべてリセット（{count}）',
  'pages.composer.playbookReview.groupResetError':
    '変更のリセットに失敗しました。もう一度お試しください。',
  'pages.composer.playbookReview.groupResetSuccess': '同一の変更 {count} 件をリセットしました',
  'pages.composer.playbookReview.hidePromptButton': 'プロンプトを隠す',
  'pages.composer.playbookReview.layerChangeCount': '{count, plural, other {# 件の変更}}',
  'pages.composer.playbookReview.loadingDocument': 'ドキュメントを読み込んでいます...',
  'pages.composer.playbookReview.localDraftTag': 'ローカル下書き',
  'pages.composer.playbookReview.localDraftTooltip':
    '未保存の下書きです。「編集を保存」で、テキストの変更を変更履歴として記録できます。',
  'pages.composer.playbookReview.noChangesDescription':
    '指定された指示に対して、AI は変更を提案しませんでした。',
  'pages.composer.playbookReview.noChangesFromStep': 'このステップによる変更はありません',
  'pages.composer.playbookReview.noChangesTitle': '変更は見つかりませんでした',
  'pages.composer.playbookReview.previousChangesFallback': '以前の変更',
  'pages.composer.playbookReview.processingTimeoutError':
    '処理に想定より時間がかかっています。ページを更新して状況をご確認ください。',
  'pages.composer.playbookReview.regenerateLabel': '再生成',
  'pages.composer.playbookReview.rejectAllButton': 'すべて却下',
  'pages.composer.playbookReview.rejectChangeError':
    '変更の却下に失敗しました。もう一度お試しください。',
  'pages.composer.playbookReview.resetAllButton': 'すべてリセット',
  'pages.composer.playbookReview.reviewViewAriaLabel': 'レビュー表示',
  'pages.composer.playbookReview.saveEditsButton': '編集を保存',
  'pages.composer.playbookReview.saveEditsError':
    '編集の保存に失敗しました。下書きは保持されています。もう一度お試しください。',
  'pages.composer.playbookReview.saveEditsNoChanges': '保存するテキストの変更はありません。',
  'pages.composer.playbookReview.saveEditsSuccess': '編集を変更履歴として保存しました。',
  'pages.composer.playbookReview.saveEditsTooltip':
    'テキストの変更を変更履歴として保存します。書式のみの変更は保存されません。',
  'pages.composer.playbookReview.saveEditsUnavailableTooltip':
    'このドキュメントのレイアウトは本文テキストに対応づけられないため、保存できません。編集はローカルの下書きのまま保持されます。',
  'pages.composer.playbookReview.selfPromptedUsing':
    '{promptName} を使って自己プロンプトを行いました。',
  'pages.composer.playbookReview.showFullPromptButton': 'プロンプト全文を表示',
  'pages.composer.playbookReview.showMoreIdentical':
    '同一の変更 {count} 件を{action, select, hide {隠す} other {表示}}',
  'pages.composer.playbookReview.showingDocumentView': 'ドキュメント表示中',
  'pages.composer.playbookReview.showingStepView': 'ステップごとの表示中',
  'pages.composer.playbookReview.status.accepted': '承認済み',
  'pages.composer.playbookReview.status.pending': '保留中',
  'pages.composer.playbookReview.status.rejected': '却下',
  'pages.composer.playbookReview.statusDistributionAriaLabel': 'レビュー状況の内訳',
  'pages.composer.playbookReview.stepChangeCount': '{count, plural, other {# 件の変更}}',
  'pages.composer.playbookReview.stepTag': 'ステップ {number}',
  'pages.composer.playbookReview.stepViewAriaLabel': 'ステップごとの表示',
  'pages.composer.playbookReview.turnNeedsRegeneration': 'このターンは再生成が必要です。',
  'pages.composer.playbookReview.turnRegenerationReason':
    '前のターンでの判断により、このターンの基となったドキュメントが変更されました。',
  'pages.composer.playbookReview.turnHasConflicts': 'このターンには競合する変更があります。',
  'pages.composer.playbookReview.turnConflictReason':
    '提案された変更の一部が互いに重なっています。ターンを再生成して適用し直してください。',
  'pages.composer.playbookReview.turnHasUnlocatableChanges':
    'このターンには、位置を特定できなかった変更があります。',
  'pages.composer.playbookReview.turnUnlocatableReason':
    '提案された変更の一部について、ドキュメント内の位置を特定できませんでした。ターンを再生成して適用し直してください。',
  'pages.composer.playbookReview.turnTitle': 'ターン {order}：{prompt}',
  'pages.composer.playbookReview.undoChangeError': '元に戻せませんでした。もう一度お試しください。',
  'pages.composer.playbookReview.updatingCanvas': 'レビューキャンバスを更新しています...',
  'pages.composer.playbookReview.viewChangeTooltip': '元のドキュメントで変更を確認',
  'pages.composer.playbookReview.viewContextButton': 'コンテキストを表示',
  'pages.composer.playbookReview.waitForUpdateWarning':
    'ダウンロードする前に、現在の更新が完了するまでお待ちください。',
  'pages.dashboard.allChannelsOption': 'すべてのチャネル',
  'pages.dashboard.presetPast30Days': '過去 30 日間',
  'pages.dashboard.presetToday': '今日',
  'pages.dashboard.presetWtd': '今週',
  'pages.dashboard.presetMtd': '今月',
  'pages.dashboard.presetYtd': '今年',
  'pages.dashboard.exportLoading': 'ダッシュボードをエクスポート',
  'pages.dashboard.downloaded': 'ダウンロードしました',
  'pages.dashboard.downloadingName': '{name} をダウンロード中',
  'pages.dashboard.chatGptMessageSeries': 'ChatGPT メッセージ',
  'pages.dashboard.storyboardMessageSeries': 'ストーリーボードメッセージ',
  'pages.dashboard.broadcastMessageSeries': 'ブロードキャストメッセージ',
  'pages.dashboard.messageTrendDataTitle': 'メッセージ推移データ',
  'pages.dashboard.messageTrendDataTooltip': '選択した期間におけるメッセージ統計の推移。',
  'pages.dashboard.newUsersSeries': '新規ユーザー',
  'pages.dashboard.activeUsersSeries': 'アクティブユーザー',
  'pages.dashboard.userTrendDataTitle': 'ユーザー推移データ',
  'pages.dashboard.userTrendDataTooltip': '選択した期間におけるユーザー統計の推移。',
  'pages.dashboard.userActivityHeatmapTitle': 'ユーザー活動ヒートマップ',
  'pages.dashboard.userActivityHeatmapTooltip':
    '選択した期間における、曜日別・時間帯別のユーザーメッセージの平均件数。',
  'pages.dashboard.wordCloudTitle': 'ワードクラウド',
  'pages.dashboard.wordCloudTooltip':
    '選択した期間のユーザーメッセージで頻繁に使われた語を図示したものです。',
  'pages.dashboard.realTimeUsersTitle': 'リアルタイムユーザー',
  'pages.dashboard.activeUsersTitle': 'アクティブユーザー',
  'pages.dashboard.newUsersTitle': '新規ユーザー',
  'pages.dashboard.promptTokensTitle': '入力トークン',
  'pages.dashboard.completionTokensTitle': '出力トークン',
  'pages.dashboard.userMessagesTitle': 'ユーザーメッセージ',
  'pages.dashboard.chatGptTitle': 'ChatGPT',
  'pages.dashboard.storyboardsTitle': 'ストーリーボード',
  'pages.dashboard.botMessagesTitle': 'ボットメッセージ',
  'pages.dashboard.broadcastsTitle': 'ブロードキャスト',
  'pages.dashboard.repliesTitle': '返信',
  'pages.dashboard.messageExchangesTitle': 'メッセージのやり取り',
  'pages.dashboard.broadcastTitle': '#ブロードキャスト',
  'pages.dashboard.outreachTitle': 'リーチ',
  'pages.dashboard.totalUsersTitle': '総ユーザー数',
  'pages.dashboard.totalUserMessagesTitle': 'ユーザーメッセージ合計',
  'pages.dashboard.totalBotMessagesTitle': 'ボットメッセージ合計',
  'pages.dashboard.totalMessageExchangesTitle': 'メッセージのやり取り合計',
  'pages.diagnostics.usersFilter.label': 'ユーザー：',
  'pages.diagnostics.usersFilter.placeholder': 'ユーザー',
  'pages.diagnostics.typesFilter.label': '種類：',
  'pages.diagnostics.typesFilter.placeholder': '種類',
  'pages.diagnostics.dateFilter.label': '日付：',
  'pages.diagnostics.datePreset.past30Days': '過去 30 日間',
  'pages.diagnostics.datePreset.today': '今日',
  'pages.diagnostics.datePreset.wtd': '今週',
  'pages.diagnostics.datePreset.mtd': '今月',
  'pages.diagnostics.datePreset.ytd': '今年',
  'pages.diagnostics.errorItem.description': ' {username}・作成日時：{createdTime}',
  'pages.files.you': 'あなた',
  'pages.files.assignAnotherOwnerFirst': '先に別のオーナーを指定してください。',
  'pages.files.keepAtLeastOneMember': 'メンバーを 1 人以上残してください。',
  'pages.files.keepAtLeastOneOwner': 'オーナーを 1 人以上残してください。',
  'pages.files.deletingEllipsis': '削除中...',
  'pages.files.failedToDelete': '削除に失敗しました',
  'pages.files.dropToUploadCurrentFolder': 'ドロップすると現在のフォルダにアップロードします',
  'pages.files.deleteConfirm.title': '{count} 件のファイルを削除しますか？',
  'pages.files.fromPath': '元の場所：{path}',
  'pages.files.createdAtColumn': '作成日時',
  'pages.files.favoritesTitle': 'お気に入り',
  'pages.files.searchFavoritesPlaceholder': 'お気に入りを検索...',
  'pages.files.chatTooltip': 'チャット',
  'pages.files.uploadingEllipsis': 'アップロード中...',
  'pages.files.paginationRangeOfTotal': '{total} 件中 {start}-{end}',
  'pages.files.enterNamePlaceholder': '名前を入力',
  'pages.files.deleteConfirm.itemContent': '「{name}」を削除してもよろしいですか？',
  'pages.files.chatWithFolderTooltip': 'このフォルダについてチャットする',
  'pages.files.chatWithFileTooltip': 'このファイルについてチャットする',
  'pages.files.filePreviewAlt': 'ファイルプレビュー',
  'pages.files.fileTypeCannotBePreviewed': 'このファイル形式はプレビューできません',
  'pages.files.uploadFilesMenuItem': 'ファイルをアップロード',
  'pages.files.uploadFolderMenuItem': 'フォルダをアップロード',
  'pages.files.newFolderButton': '新しいフォルダ',
  'pages.files.sortOption.newestFirst': '新しい順',
  'pages.files.sortOption.oldestFirst': '古い順',
  'pages.files.sortOption.nameAZ': '名前 A–Z',
  'pages.files.sortOption.nameZA': '名前 Z–A',
  'pages.files.deleteAllFailedFilesConfirm':
    '{count, plural, other {アップロードに失敗した {count} 件のファイルをすべて削除しますか？}}',
  'pages.files.cleanupButton': '整理',
  'pages.files.selectButton': '選択',
  'pages.files.addGroupTitle': 'グループを追加',
  'pages.files.editGroupTitle': 'グループを編集',
  'pages.files.groupType.privateGroup': 'プライベートグループ',
  'pages.files.groupType.firmWide': '事務所全体',
  'pages.files.groupType.public': '全体公開',
  'pages.files.selectGroupTypeRequired': 'グループの種類を選択してください。',
  'pages.files.groupNameRequired': 'グループ名を入力してください。',
  'pages.files.groupNameTaken': 'この名前のグループはすでに存在します。',
  'pages.files.folderNameTaken': 'この名前のフォルダはすでに存在します。',
  'pages.files.newFolderDisabledTooltip':
    'ここにフォルダは作成できません。グループを開いて、その中にフォルダを作成してください。',
  'pages.files.addPersonPlaceholder': 'メンバーを追加',
  'pages.files.noMembersYet': 'メンバーはまだいません。',
  'pages.files.memberColumn': 'メンバー',
  'pages.files.roleColumn': 'ロール',
  'pages.files.roleOwner': 'オーナー',
  'pages.files.roleMember': 'メンバー',
  'pages.files.revisionHistoryTitle': '変更履歴',
  'pages.files.renamedTo': ' → ',
  'pages.files.noFieldValue': '{field}なし',
  'pages.files.chatWithGroupTooltip': 'このグループについてチャットする',
  'pages.files.searchFilesPlaceholder': 'ファイルを検索...',
  'pages.files.historyTitle': '履歴',
  'pages.files.addNewButton': '新規追加',
  'pages.files.homeButton': 'ホーム',
  'pages.files.selectFolderPlaceholder': 'フォルダを選択',
  'pages.files.moveMultipleFilesTitle': '{count} 件のファイルを移動',
  'pages.files.moveSingleFileTitle': '「{name}」を移動',
  'pages.files.addAtLeastOneMember': 'メンバーを 1 人以上追加してください。',
  'pages.files.selectAtLeastOneOwner': 'オーナーを 1 人以上選択してください。',
  'pages.files.folderWarning.privateGroup': '安全性が低め：グループ内に公開されます。',
  'pages.files.folderWarning.firmWide': '非常に危険：事務所全体に公開されます。',
  'pages.files.folderWarning.public': '非常に危険：全員に公開されます。',
  'pages.files.duplicateFileNameError': 'ファイル名が重複しています。ファイル名を変更してください',
  'pages.files.failedToUpdate': '更新に失敗しました',
  'pages.files.filesDeletedCount': '{count} 件のファイルを削除しました',
  'pages.files.filesMovedCount': '{count} 件のファイルを移動しました',
  'pages.files.failedToDeleteCount': '{count} 件のファイルの削除に失敗しました',
  'pages.files.failedToMoveCount': '{count} 件のファイルの移動に失敗しました',
  'pages.files.filesDeletedCountWithFailures':
    '{count} 件のファイルを削除し、{failedCount} 件が失敗しました',
  'pages.files.filesMovedCountWithFailures':
    '{count} 件のファイルを移動し、{failedCount} 件が失敗しました',
  'pages.files.failedToDeleteFiles': 'ファイルの削除に失敗しました',
  'pages.files.failedToMoveFiles': 'ファイルの移動に失敗しました',
  'pages.files.unnamedFile': '名前なし',
  'pages.files.failedToUploadFile': '{fileName} のアップロードに失敗しました',
  'pages.files.failedToCreateFolder': 'フォルダの作成に失敗しました：{folderName}',
  'pages.files.someFilesSkippedUnsupportedTypes':
    '一部のファイルは非対応の形式のためスキップされました',
  'pages.files.uploadingFolderEllipsis': 'フォルダをアップロード中...',
  'pages.files.folderUploadFailed': 'フォルダのアップロードに失敗しました',
  'pages.files.allowedFileTypesMessage':
    'PDF、DOC、DOCX、MSG、EML、TXT、MD、PPT、PPTX、XLS、XLSX のファイルのみ対応しています',
  'pages.library.attachedDocsAccessNote':
    'プロンプトに添付されたドキュメントへのアクセス権は、プロンプト自体へのアクセス権に準じます。',
  'pages.library.functionOption.summarise': '要約',
  'pages.library.functionOption.search': '検索',
  'pages.library.functionOption.selfInstruct': '自己指示',
  'pages.library.functionOption.translate': '翻訳',
  'pages.library.functionOption.transcribe': '文字起こし',
  'pages.library.functionOption.reviewAnalyse': 'レビュー/分析',
  'pages.library.functionOption.playbook': 'プレイブック',
  'pages.library.functionOption.comparison': '比較',
  'pages.library.functionOption.template': 'テンプレート',
  'pages.library.functionOption.review': 'レビュー',
  'pages.library.functionOption.amend': '修正',
  'pages.library.functionOption.redFlagging': 'リスク抽出',
  'pages.library.functionOption.promptlet': 'プロンプトレット',
  'pages.library.visibilityOption.personal': '個人',
  'pages.library.visibilityOption.group': 'グループ',
  'pages.library.visibilityOption.firmWide': '事務所全体',
  'pages.library.visibilityOption.public': '全体公開',
  'pages.library.updateSuccess': '更新しました',
  'pages.library.updateFailed': '更新に失敗しました',
  'pages.library.copySuccess': 'プロンプトをクリップボードにコピーしました',
  'pages.library.copyFailed': 'プロンプトのコピーに失敗しました',
  'pages.library.selfInstruction': '自己指示',
  'pages.library.pendingApproval': '承認待ち',
  'pages.library.publishPromptModalTitle': 'プロンプトを公開',
  'pages.library.publishButton': '公開',
  'pages.library.publishRequestSentToAdmin':
    'このプロンプトの公開リクエストを、承認のため管理者に送信しました。',
  'pages.library.publishSuccess': 'プロンプトを公開しました。',
  'pages.library.publishFailedDefault':
    '公開リクエストの送信に失敗しました。もう一度お試しください。',
  'pages.library.field.visibility': '公開範囲',
  'pages.library.firmWideVisibilityNote':
    'このプロンプトは組織内の全員に表示されます。承認のため組織管理者にリクエストが送信されます。',
  'pages.library.publicVisibilityNote':
    'このプロンプトはすべてのユーザーに表示されます。承認のためスーパー管理者にリクエストが送信されます。',
  'pages.library.pendingApprovalNote':
    '公開リクエストが承認待ちです。リクエストが承認または却下されるまで、事務所全体と全体公開は選択できません。',
  'pages.library.cloneButton': '複製',
  'pages.library.chatWithPromptButton': 'このプロンプトでチャットする',
  'pages.library.enterPromptNamePlaceholder': 'プロンプト名を入力',
  'pages.library.field.purpose': '目的',
  'pages.library.enterPurposePlaceholder': '目的を入力',
  'pages.library.field.notes': 'メモ',
  'pages.library.enterNotesPlaceholder': 'メモを入力',
  'pages.library.field.author': '作成者',
  'pages.library.allowSelfInstruction': '自己指示を許可',
  'pages.library.attachedDocuments': '添付ドキュメント',
  'pages.library.documentsCount': '{count} 件のドキュメント',
  'pages.library.field.prompt': 'プロンプト',
  'pages.library.enterPromptContentPlaceholder': 'プロンプトの内容を入力',
  'pages.library.noPromptsSelected': 'プロンプトが選択されていません',
  'pages.library.promptClonedSuccess': 'プロンプトを複製しました',
  'pages.library.cloneAuthorLabel': '作成者：{author}',
  'pages.library.cloneAudienceLabel': '公開範囲：{visibility}',
  'pages.library.undoChangesButton': '変更を元に戻す',
  'pages.library.saveChangesButton': '変更を保存',
  'pages.library.unsavedChangesTitle': '保存されていない変更',
  'pages.library.unsavedChangesContent':
    '保存されていない変更があります。終了してもよろしいですか？',
  'pages.library.exitModifyButton': '編集を終了',
  'pages.library.field.tags': 'タグ',
  'pages.library.title': 'プロンプトライブラリ',
  'pages.library.description':
    'AI 言語モデルとのやり取りを導き、最適化するために設計済みのプロンプトを体系的にまとめたコレクションです。ライティング、コーディング、データ分析、クリエイティブ生成など、目的・タスク・領域ごとにプロンプトを整理した中央リポジトリとして機能します。',
  'pages.library.exitCompareButton': '比較を終了',
  'pages.library.compareButton': '比較',
  'pages.library.addPromptModalTitle': 'プロンプトを追加',
  'pages.library.addButton': '追加 +',
  'pages.library.tagsPlaceholder': 'タグの一覧',
  'pages.library.filterByFunctionPlaceholder': '機能で絞り込む',
  'pages.library.filterByAudiencePlaceholder': '公開範囲で絞り込む',
  'pages.library.searchPlaceholder': 'プロンプトとタグを検索',
  'pages.library.favoriteOnly': 'お気に入りのみ',
  'pages.library.filterByLabel': '絞り込み：',
  'pages.library.compareSelectHint': '比較したいプロンプトを 2 つまたは 3 つ選択してください',
  'pages.library.untitledPrompt': '無題のプロンプト',
  'pages.library.compareLimitWarning': '比較できるプロンプトは最大 3 つまでです',
  'pages.library.copyPromptButton': 'プロンプトをコピー',
  'pages.organisation.idColumnTitle': 'ID',
  'pages.organisation.untitledOrganisationFallback': '無題の組織',
  'pages.organisation.userLimitLabel': 'ユーザー上限',
  'pages.organisation.userLimitUnlimitedCount': '{count} / 無制限',
  'pages.organisation.userLimitUnlimited': '無制限',
  'pages.organisation.userLimitOnly': '上限：{limit}',
  'pages.organisation.msTenantIdsLabel': 'MS テナント ID',
  'pages.organisation.organisationsTableHeaderTitle': '組織',
  'pages.organisation.createOrganisationLabel': '組織を作成',
  'pages.organisation.usersTableHeaderTitle': '{orgName} のユーザー',
  'pages.organisation.defaultOrganisationName': '組織',
  'pages.organisation.userLimitReachedTooltip': 'ユーザー数が上限に達しました',
  'pages.organisation.addUserButtonLabel': 'ユーザーを追加',
  'pages.organisation.usernameColumnTitle': 'ユーザー名',
  'pages.organisation.emailColumnTitle': 'メールアドレス',
  'pages.organisation.roleLabel': 'ロール',
  'pages.organisation.defaultUserRoleLabel': 'ユーザー',
  'pages.organisation.changeRoleButtonLabel': 'ロールを変更',
  'pages.organisation.removeUserConfirmTitle': 'このユーザーを組織から削除しますか？',
  'pages.organisation.userRemovedSuccessMessage': 'ユーザーを削除しました',
  'pages.organisation.unableToRemoveUserErrorMessage': 'ユーザーを削除できませんでした',
  'pages.organisation.editOrganisationModalTitle': '組織を編集',
  'pages.organisation.organisationUpdatedSuccessMessage': '組織を更新しました',
  'pages.organisation.organisationCreatedSuccessMessage': '組織を作成しました',
  'pages.organisation.organisationNameRequiredMessage': '組織名は必須です',
  'pages.organisation.organisationNameLabel': '組織名',
  'pages.organisation.userLimitTooltip':
    '許可するユーザー数の上限です。無制限にする場合は空欄のままにしてください。',
  'pages.organisation.msTenantIdsTooltip':
    'これらの Microsoft テナント ID に属するユーザーは、SSO でログインできます。',
  'pages.organisation.userEmailLabel': 'ユーザーのメールアドレス',
  'pages.organisation.userEmailPlaceholder': 'user@company.com',
  'pages.organisation.emailRequiredMessage': 'メールアドレスは必須です',
  'pages.organisation.roleRequiredMessage': 'ロールは必須です',
  'pages.organisation.userAddedSuccessMessage': 'ユーザーを追加しました',
  'pages.organisation.unableToAddUserErrorMessage': 'ユーザーを追加できませんでした',
  'pages.organisation.roleUpdatedSuccessMessage': 'ロールを更新しました',
  'pages.organisation.unableToUpdateRoleErrorMessage': 'ロールを更新できませんでした',
  'pages.organisation.unableToLoadRolesErrorMessage': 'ロールを読み込めませんでした',
  'pages.playbook.header.title': 'ワークスタジオ',
  'pages.playbook.emptyState.title': '準備はできています。',
  'pages.playbook.emptyState.description':
    '書き直し、条項のレビュー、要約、あるいは特定箇所の修正をご依頼ください。',
  'pages.playbook.checkingDocument': 'ドキュメントを確認しています...',
  'pages.playbook.updatingReviewCanvas': 'レビューキャンバスを更新しています...',
  'pages.playbook.inputPlaceholder': '変更したい内容を A&GEL に伝えてください...',
  'pages.playbook.inputAriaLabel': 'ワークスタジオの指示',
  'pages.playbook.contextButton': 'コンテキスト',
  'pages.playbook.sendButtonAriaLabel': 'ワークスタジオの指示を送信',
  'pages.playbook.sendInstructionError': 'ワークスタジオの指示の送信に失敗しました',
  'pages.projectsHub.func.chat': 'チャット',
  'pages.projectsHub.func.scribe': 'スクライブ',
  'pages.projectsHub.func.apps': 'アプリ',
  'pages.projectsHub.func.review': 'レビュー',
  'pages.projectsHub.func.sideBySide': '並べて比較',
  'pages.projectsHub.func.comparison': '比較',
  'pages.projectsHub.func.translation': '翻訳',
  'pages.projectsHub.func.template': 'カスタム出力',
  'pages.projectsHub.func.quote': '見積',
  'pages.projectsHub.untitledSession': '無題',
  'pages.projectsHub.untitledFileLabel': '（無題）',
  'pages.projectsHub.errors.loadDataFailed': 'データの読み込みに失敗しました',
  'pages.projectsHub.subfolderCreated': 'サブフォルダを作成しました',
  'pages.projectsHub.collectionCreated': 'コレクションを作成しました',
  'pages.projectsHub.errors.createFailed': '作成に失敗しました',
  'pages.projectsHub.errors.updateFailed': '更新に失敗しました',
  'pages.projectsHub.deleteCollectionConfirm.title': 'コレクションを削除',
  'pages.projectsHub.deleteCollectionConfirm.content': '「{name}」を削除しますか？',
  'pages.projectsHub.collectionDeleted': '削除済み',
  'pages.projectsHub.errors.deleteFailed': '失敗しました',
  'pages.projectsHub.sessionsAdded': '{count} 件のセッションを追加しました',
  'pages.projectsHub.errors.addSessionsFailed': '追加に失敗しました',
  'pages.projectsHub.sessionRemoved': 'セッションを削除しました',
  'pages.projectsHub.errors.removeSessionFailed': 'セッションの削除に失敗しました',
  'pages.projectsHub.sessionsRemoved': '{count} 件のセッションを削除しました',
  'pages.projectsHub.errors.removeSessionsFailed': 'セッションの削除に失敗しました',
  'pages.projectsHub.fieldSaved': '保存しました',
  'pages.projectsHub.errors.saveFieldFailed': '保存に失敗しました',
  'pages.projectsHub.folderDeleted': 'フォルダを削除しました',
  'pages.projectsHub.errors.deleteFolderFailed': 'フォルダの削除に失敗しました',
  'pages.projectsHub.folderCreated': 'フォルダを作成しました',
  'pages.projectsHub.errors.createFolderFailed': 'フォルダの作成に失敗しました',
  'pages.projectsHub.deleteFolderConfirm.description': '「{name}」とその中身をすべて削除しますか？',
  'pages.projectsHub.deleteSessionsConfirm.title': 'セッションを削除',
  'pages.projectsHub.deleteSessionsConfirm.description':
    'このコレクションから {count} 件のセッションを削除しますか？',
  'pages.projectsHub.removeSessionConfirm.title': 'セッションを削除',
  'pages.projectsHub.removeSessionConfirm.description':
    'このコレクションから「{name}」を削除しますか？',
  'pages.projectsHub.sort.newestFirst': '新しい順',
  'pages.projectsHub.sort.oldestFirst': '古い順',
  'pages.projectsHub.sort.nameAsc': '名前（A-Z）',
  'pages.projectsHub.sort.nameDesc': '名前（Z-A）',
  'pages.projectsHub.doubleClickToOpen': 'ダブルクリックで開く',
  'pages.projectsHub.tidyUp': '整理する',
  'pages.projectsHub.exit': '終了',
  'pages.projectsHub.manage': '管理',
  'pages.projectsHub.deleteSessionsButton': '削除（{count}）',
  'pages.projectsHub.searchSessionsPlaceholder': 'セッションを検索',
  'pages.projectsHub.emptyState.noFiles': 'ファイルがありません',
  'pages.projectsHub.newFolderButton': '新しいフォルダ',
  'pages.projectsHub.addSessionsButton': 'セッションを追加',
  'pages.projectsHub.folderInfoLabel': 'フォルダ情報',
  'pages.projectsHub.mattersHeading': '案件',
  'pages.projectsHub.mattersSubtitle':
    'コレクションを作成し、さまざまな機能のセッションを 1 つのワークスペースにまとめて管理できます。',
  'pages.projectsHub.hubBreadcrumbLabel': 'ハブ',
  'pages.projectsHub.deleteFolderButton': 'フォルダを削除',
  'pages.projectsHub.itemsLabel': 'アイテム',
  'pages.projectsHub.selectSubfolderEmptyState': 'サブフォルダを選択すると詳細が表示されます',
  'pages.projectsHub.selectFolderEmptyState': 'フォルダを選択すると詳細が表示されます',
  'pages.projectsHub.noCollectionsMatch': '現在のフィルターに一致するコレクションがありません。',
  'pages.projectsHub.noSessionsFoundForFunction': '{func} のセッションが見つかりません。',
  'pages.projectsHub.addSelectedSessionsButton':
    '{count, plural, =0 {選択したものを追加} other {# 件のセッションを追加}}',
  'pages.projectsHub.step1ChooseFunctionType': 'ステップ 1 — 機能の種類を選択',
  'pages.projectsHub.selectFunctionPlaceholder': '機能を選択',
  'pages.projectsHub.step2SelectSessions': 'ステップ 2 — 追加するセッションを選択',
  'pages.projectsHub.createFolderButton': 'フォルダを作成',
  'pages.projectsHub.folderNameLabel': 'フォルダ名',
  'pages.projectsHub.subfolderNamePlaceholder': '例：デューデリジェンス',
  'pages.projectsHub.collectionNamePlaceholder': '例：M&A デューデリジェンス',
  'pages.projectsHub.optionalDescriptionPlaceholder': '説明（任意）',
  'pages.projectsHub.optionalNotesPlaceholder': 'メモ（任意）',
  'pages.projectsHub.createCollectionModalTitle': 'コレクションを作成',
  'pages.projectsHub.collectionNameLabel': 'コレクション名',
  'pages.projectsHub.editCollectionModalTitle': '編集 • {name}',
  'pages.projectsHub.itemCountLabel': '{count, plural, other {# 件のアイテム}}',
  'pages.projectsHub.fileCountLabel': '{count, plural, other {# 件のファイル}}',
  'pages.quote.historyTooltip': '履歴（Tab+H）',
  'pages.quote.hideTooltip': '非表示（Tab+H）',
  'pages.quote.newQuoteTooltip': '新しい見積（Tab+N）',
  'pages.quote.untitled': '（無題）',
  'pages.quote.newQuote': '新しい見積',
  'pages.quote.deletedExample': 'サンプルを削除しました',
  'pages.quote.generateDescription': 'テンプレートと事実関係に基づいて見積書を作成します',
  'pages.quote.sizeLabel': 'サイズ',
  'pages.quote.sizeShort': '短め',
  'pages.quote.sizeMedium': '普通',
  'pages.quote.sizeLong': '長め',
  'pages.quote.examplesLabel': '例',
  'pages.quote.promptLabel': 'プロンプト',
  'pages.quote.examplesTitle': '例',
  'pages.quote.quoteTitle': '見積',
  'pages.quote.uploadManageExamples': 'サンプルをアップロード／管理',
  'pages.quote.generateQuoteSubtitle': '見積を作成',
  'pages.quote.fileLabel': 'ファイル',
  'pages.quote.deleteConfirmTitle': '次のサンプルを削除してもよろしいですか？',
  'pages.review.addAtLeastOneQuestion': '送信する前に質問を 1 つ以上追加してください。',
  'pages.review.addAtLeastOneQuestionFirst': '先に質問を 1 つ以上追加してください。',
  'pages.review.addAtLeastOneQuestionRule': '質問を 1 つ以上追加してください',
  'pages.review.addQuestionButton': '質問',
  'pages.review.addSectionButton': 'セクション',
  'pages.review.addToMatters': '案件に追加',
  'pages.review.adhocModifyMode': 'アドホック編集',
  'pages.review.audiencePlaceholder': 'クライアント名または想定読者',
  'pages.review.authorLabel': '作成者',
  'pages.review.categoryLabel': 'カテゴリ',
  'pages.review.cellDetailsDrawer.addCommentPlaceholder': 'コメントを追加...',
  'pages.review.cellDetailsDrawer.answer': '回答',
  'pages.review.cellDetailsDrawer.comments': 'コメント',
  'pages.review.cellDetailsDrawer.commentsWithCount': 'コメント（{count}）',
  'pages.review.cellDetailsDrawer.exactMatch':
    '出典ドキュメント内で完全に一致する箇所が見つかりました',
  'pages.review.cellDetailsDrawer.explanation': '説明',
  'pages.review.cellDetailsDrawer.fullReference': '参照全文',
  'pages.review.cellDetailsDrawer.fuzzyMatch':
    '出典ドキュメント内でおおよそ一致する箇所が見つかりました',
  'pages.review.cellDetailsDrawer.openDocument': 'ドキュメントを開く',
  'pages.review.cellDetailsDrawer.openInSearch': '検索で開く',
  'pages.review.cellDetailsDrawer.verified': '検証済み',
  'pages.review.cellDetailsDrawer.verify': '検証',
  'pages.review.cellMarkedUnverified': 'セルを未検証としてマークしました',
  'pages.review.cellMarkedVerified': 'セルを検証済みとしてマークしました',
  'pages.review.cellUpdateFailed': 'セルの更新に失敗しました',
  'pages.review.cellUpdatedSuccessfully': 'セルを更新しました',
  'pages.review.cellVerificationUpdateFailed': 'セルの検証状態の更新に失敗しました',
  'pages.review.changesUndone': '変更を元に戻しました',
  'pages.review.chatWithEntireOutput': '出力全体についてチャットする',
  'pages.review.cloneButton': '複製',
  'pages.review.clonedNamePrefix': '複製 - {name}',
  'pages.review.columnEditModal.addTitle': '新しいドキュメント（列）を追加',
  'pages.review.columnEditModal.columnUpdated':
    '列の更新を開始しました。列はまもなく更新されます。',
  'pages.review.columnEditModal.columnsAdded':
    '新しい列を追加しました。マトリックスはまもなく更新されます。',
  'pages.review.columnEditModal.dropToUpload': 'ここにファイルをドロップしてアップロード',
  'pages.review.columnEditModal.fileRequired':
    'この列で使用するファイルをアップロードまたは選択してください。',
  'pages.review.columnEditModal.filesRequiredValidation':
    'ファイルをアップロードするか、既存のファイルを選択してください',
  'pages.review.columnEditModal.updateFailed': '列の更新に失敗しました',
  'pages.review.columnEditModal.updateTitle': 'この列の新しいドキュメント',
  'pages.review.createQuestionListButton': '質問リストを作成',
  'pages.review.createdByYou': 'あなた',
  'pages.review.customInstruction': 'カスタム指示',
  'pages.review.customInstructionOptional': 'カスタム指示（任意）',
  'pages.review.deleteQuestionListConfirm': 'この質問リストを削除してもよろしいですか？',
  'pages.review.downloadExcel': 'Excel（.xlsx）',
  'pages.review.downloadWord': 'Word（.docx）',
  'pages.review.dragHereToUpload': 'ここにドラッグしてアップロード',
  'pages.review.exitButton': '終了',
  'pages.review.exitClone': '複製を終了',
  'pages.review.exitCreate': '作成を終了',
  'pages.review.exitModify': '編集を終了',
  'pages.review.fileCount': '{count} 件のファイル',
  'pages.review.mattersUpdateFailed': '案件の更新に失敗しました',
  'pages.review.mattersUpdated': '案件を更新しました',
  'pages.review.modifyButton': '変更',
  'pages.review.newCategoryPlaceholder': '新しいカテゴリ',
  'pages.review.newQuestionListDefaultName': '新しいレビュー質問リスト',
  'pages.review.noEmailOnFile': '登録されたメールアドレスがありません',
  'pages.review.noNotesAvailable': 'メモはありません。',
  'pages.review.noPrivateGroupsFound': 'プライベートグループが見つかりません',
  'pages.review.noPurposeAvailable': '目的は設定されていません。',
  'pages.review.noQuestionsYet': '質問はまだありません。',
  'pages.review.notesLabel': 'メモ',
  'pages.review.pendingApproval': '承認待ち',
  'pages.review.pollingTimeout':
    'ポーリングがタイムアウトしました。レビューの処理はまだ続いている可能性があります。',
  'pages.review.publishButton': '公開',
  'pages.review.publishFailed': '質問リストの公開に失敗しました',
  'pages.review.publishTargetFirm': '事務所全体',
  'pages.review.publishToLabel': '公開先：',
  'pages.review.publishedAccess.firm': '事務所',
  'pages.review.publishedAccess.privateGroup': 'プライベートグループ',
  'pages.review.publishedAccess.public': '全体公開',
  'pages.review.publishedToLabel': '{access} に公開しました',
  'pages.review.publishedToPrivateGroup': '質問リストをプライベートグループに公開しました',
  'pages.review.publishedToPrivateGroups': '質問リストをプライベートグループに公開しました',
  'pages.review.purposeLabel': '目的',
  'pages.review.questionListCloned': '質問リストを複製しました',
  'pages.review.questionListCreated': '質問リストを作成しました',
  'pages.review.questionListDeleted': '質問リストを削除しました',
  'pages.review.questionListImporter.allColumns': 'すべての列（各セルを連結）',
  'pages.review.questionListImporter.checklistText': 'チェックリストのテキスト',
  'pages.review.questionListImporter.checklistTextPlaceholder':
    'チェックリストをここに貼り付けてください。1 行に 1 要件を記載します。',
  'pages.review.questionListImporter.columnOption': '列 {index} - {label}',
  'pages.review.questionListImporter.couldNotParse': 'チェックリストを解析できませんでした。',
  'pages.review.questionListImporter.couldNotReadFile': '{fileName} を読み込めませんでした。',
  'pages.review.questionListImporter.docxColumn': 'DOCX の列',
  'pages.review.questionListImporter.dropZoneHint':
    'DOCX、PDF、EML、MSG、TXT、MD に対応。ファイルはローカルに保持されます。',
  'pages.review.questionListImporter.dropZoneText':
    'クリックまたはチェックリストをこの領域にドラッグ',
  'pages.review.questionListImporter.granularityEveryLine': '各行を 1 つの質問にする',
  'pages.review.questionListImporter.granularityLevel2': 'レベル 2 まで',
  'pages.review.questionListImporter.granularityLevel3': 'レベル 3 まで',
  'pages.review.questionListImporter.granularityLevel4': 'レベル 4 まで',
  'pages.review.questionListImporter.granularityLevel5': 'レベル 5 まで',
  'pages.review.questionListImporter.granularityTopLevel': '最上位のみ',
  'pages.review.questionListImporter.groupByLevel': '質問をレベルごとにまとめる',
  'pages.review.questionListImporter.importQuestions': '質問をインポート',
  'pages.review.questionListImporter.importQuestionsAction': '質問をインポート',
  'pages.review.questionListImporter.loadedFile': '{fileName} を読み込みました',
  'pages.review.questionListImporter.noQuestionsDetected':
    'チェックリストから質問を検出できませんでした。',
  'pages.review.questionListImporter.noQuestionsSelected':
    'インポートする質問が選択されていません。',
  'pages.review.questionListImporter.pasteOrSelectRequired':
    'プレビューする前に、チェックリストを貼り付けるか選択してください。',
  'pages.review.questionListImporter.previewQuestions': '質問をプレビュー',
  'pages.review.questionListImporter.questionGranularity': '質問の粒度',
  'pages.review.questionListImporter.questionsReadyCount':
    '{count, plural, other {# 件の質問}}の準備ができました',
  'pages.review.questionListImporter.readingChecklist': 'チェックリストを読み込んでいます...',
  'pages.review.questionListImporter.removeFile': 'ファイルを削除',
  'pages.review.questionListImporter.removeQuestion': '質問 {number} を削除',
  'pages.review.questionListImporter.removeQuestionsHint':
    'インポートしたくない質問は削除してください。',
  'pages.review.questionListImporter.reviewQuestions': '質問を確認',
  'pages.review.questionListNamePlaceholder': 'レビュー質問リストの名前',
  'pages.review.questionListUpdated': '質問リストを更新しました',
  'pages.review.questionNamePlaceholder': '質問',
  'pages.review.questionRow.dragToReorder': 'ドラッグして並べ替え',
  'pages.review.questionRow.moveDown': '下へ移動',
  'pages.review.questionRow.moveUp': '上へ移動',
  'pages.review.questionRow.rowType': '行の種類',
  'pages.review.questionsList': '質問リスト',
  'pages.review.quickQuestionsDescription':
    'その場で作成した質問に基づいて、1 つまたは複数のドキュメントの構造化されたレビューを作成します',
  'pages.review.quickQuestionsHeading': 'クイック質問',
  'pages.review.rejected': '却下',
  'pages.review.resizeHint': '境界線をドラッグしてサイズを変更できます。',
  'pages.review.restoreConfigFailed': '設定の復元に失敗しました。もう一度お試しください。',
  'pages.review.resultPanel.processing': '処理中',
  'pages.review.resultPanel.stopped': '処理を停止しました。',
  'pages.review.reuseButton': '再利用',
  'pages.review.rowEditModal.addTitle': '新しい質問（行）を追加',
  'pages.review.rowEditModal.promptLabel': 'プロンプト',
  'pages.review.rowEditModal.promptRequired': 'プロンプトを入力してください。',
  'pages.review.rowEditModal.rowAdded':
    '新しい行を追加しました。マトリックスはまもなく更新されます。',
  'pages.review.rowEditModal.rowUpdated': '行の更新を開始しました。行はまもなく更新されます。',
  'pages.review.rowEditModal.updateFailed': '行の更新に失敗しました',
  'pages.review.rowEditModal.updateTitle': '質問プロンプトを更新',
  'pages.review.saveAsButton': '名前を付けて保存',
  'pages.review.saveChangesButton': '変更を保存',
  'pages.review.searchMattersPlaceholder': '案件を検索...',
  'pages.review.sectionNamePlaceholder': 'セクション見出し',
  'pages.review.selectCellHint': 'セル、行、列をクリックすると選択できます。',
  'pages.review.selectDocumentsToReview': 'レビューを行うドキュメントを選択してください',
  'pages.review.selectDocumentsToReviewNumbered': '2. レビューを行うドキュメントを選択してください',
  'pages.review.selectMatters': '案件を選択：',
  'pages.review.selectPrivateGroupsHint':
    '共有先のプライベートグループを 1 つ以上選択してください：',
  'pages.review.selectPrivateGroupsPlaceholder': 'プライベートグループを選択',
  'pages.review.sentForApproval': '質問リストを承認申請しました',
  'pages.review.sentimentLegendPrefix': '凡例：AI の評価：',
  'pages.review.sentimentNegative': '否定的',
  'pages.review.sentimentPositive': '肯定的',
  'pages.review.showAll': 'すべて表示',
  'pages.review.startNewReview': '新しいレビューを開始',
  'pages.review.stayButton': 'とどまる',
  'pages.review.submitReviewFailed': 'レビューの送信に失敗しました',
  'pages.review.systemPromptLabel': 'システムプロンプト',
  'pages.review.tabs.customiseOptional': 'カスタマイズ（任意）',
  'pages.review.tabs.prompts': 'プロンプト',
  'pages.review.tabs.selectDocuments': 'ドキュメントを選択',
  'pages.review.tabs.startHere': 'ここから始める',
  'pages.review.typeHerePlaceholder': 'ここに入力...',
  'pages.review.undoChangesButton': '変更を元に戻す',
  'pages.review.unsavedChangesWillBeLost': '保存されていない変更はすべて失われます。',
  'pages.review.untitledSession': '（無題）',
  'pages.review.updateFailed': '更新に失敗しました',
  'pages.review.viewMode': '表示',
  'pages.review.whatsNewDescription':
    'ドキュメントレビューをより快適にする新機能をいくつか追加しました。',
  'pages.review.whoIsItFor': '対象は誰ですか？',
  'pages.review.whoIsItForNumbered': '1. 対象は誰ですか？',
  'pages.scribe.addToMatters': '案件に追加',
  'pages.scribe.aiWorking': 'AI が処理しています...',
  'pages.scribe.appDescription': '音声ファイルや録音を、構造化されたテキストに書き起こします。',
  'pages.scribe.audioUploadFailedSavingOnly':
    '音声ファイルのアップロードに失敗したため、文字起こしのみ保存します',
  'pages.scribe.audioUploadSuccess': '音声ファイルをアップロードしました',
  'pages.scribe.autoDetect': '自動検出',
  'pages.scribe.autoGenerateFailed': '選択した出力の自動生成に失敗しました',
  'pages.scribe.autoRecordingName': '録音 {timestamp}',
  'pages.scribe.autoSavedNote': '{relative}（{time}）に自動保存しました',
  'pages.scribe.convertingEllipsis': '変換中...',
  'pages.scribe.customLanguageFallback': 'カスタム',
  'pages.scribe.deleteConfirm.content': 'この文字起こしを削除してもよろしいですか？',
  'pages.scribe.deleteConfirm.title': '文字起こしを削除',
  'pages.scribe.deleteTranscriptFailed': '文字起こしの削除に失敗しました',
  'pages.scribe.discardChangesConfirm.cancelText': '編集を続ける',
  'pages.scribe.discardChangesConfirm.content': '保存されていない編集があります。破棄しますか？',
  'pages.scribe.discardChangesConfirm.okText': '破棄',
  'pages.scribe.discardChangesConfirm.title': '変更を破棄しますか？',
  'pages.scribe.downloadAudio': '音声をダウンロード',
  'pages.scribe.downloadFailed': 'ダウンロードに失敗しました',
  'pages.scribe.downloadScript': '文字起こしをダウンロード',
  'pages.scribe.downloadStarted': 'ダウンロードを開始しました',
  'pages.scribe.downloadingAudio': '音声をダウンロード中...',
  'pages.scribe.enterTranscriptNamePlaceholder': '文字起こしの名前を入力',
  'pages.scribe.errors.authTokenFailed': '認証トークンの取得に失敗しました',
  'pages.scribe.errors.startRecordingFailed': '録音の開始に失敗しました',
  'pages.scribe.exitRecordingConfirm.cancelText': '録音を続ける',
  'pages.scribe.exitRecordingConfirm.content': '文字起こしは保存されません。',
  'pages.scribe.exitRecordingConfirm.okText': '録音を終了',
  'pages.scribe.exitRecordingConfirm.title': '録音を終了しますか？',
  'pages.scribe.exitRecordingPopconfirm.description':
    '録音を終了しますか？文字起こしは保存されません。',
  'pages.scribe.fastForward10': '10 秒早送り',
  'pages.scribe.fileUploadFailed': '{fileName} のアップロードに失敗しました。',
  'pages.scribe.fileUploadSuccess': 'ファイルをアップロードしました。処理を開始します。',
  'pages.scribe.generateButton': '生成',
  'pages.scribe.generationFailedRetryText': '生成に失敗しました。再生成をお試しください。',
  'pages.scribe.generationStarted': '生成を開始しました',
  'pages.scribe.guidedTourLabel': 'ガイド付きツアー',
  'pages.scribe.historyButton': '履歴',
  'pages.scribe.homeButton': 'ホーム',
  'pages.scribe.idleTour.chooseLanguageDesc':
    '文字起こしの言語（または自動検出）を選び、必要に応じてライブ翻訳を設定してください。',
  'pages.scribe.idleTour.chooseLanguageTitle': '言語を選択',
  'pages.scribe.idleTour.provideAudioDesc':
    'ライブ録音を開始するか、既存の音声ファイルをアップロードできます。',
  'pages.scribe.idleTour.provideAudioTitle': '音声を用意する',
  'pages.scribe.idleTour.selectFormatDesc':
    '形式（議事録、メールの下書き、ボイスメモなど）を選択してください。後から別の形式を生成することもできます。',
  'pages.scribe.idleTour.selectFormatTitle': '形式を選択',
  'pages.scribe.idleTour.welcomeDesc': 'このページの用途はこちらでご確認ください。',
  'pages.scribe.idleTour.welcomeTitle': 'スクライブへようこそ',
  'pages.scribe.initializingTranscription': '文字起こしを初期化しています...',
  'pages.scribe.interruptedModal.content':
    '接続が失われたため（デバイスがスリープしたなど）、録音が中断されました。「文字起こしを表示」をクリックすると、記録された内容を保存できます。',
  'pages.scribe.interruptedModal.okText': '文字起こしを表示',
  'pages.scribe.interruptedModal.title': '録音が中断されました',
  'pages.scribe.langGroup.custom': 'カスタム',
  'pages.scribe.langGroup.everythingElse': 'その他の言語',
  'pages.scribe.langGroup.otherOption': 'その他…',
  'pages.scribe.langGroup.preferred': '優先',
  'pages.scribe.langGroup.seaEastAsian': '東南アジア・東アジア',
  'pages.scribe.languageSelector.addLanguageButton': '言語を追加',
  'pages.scribe.languageSelector.customPlaceholder': '言語を入力（例：マレー語）',
  'pages.scribe.liveTranslationLabel': 'ライブ翻訳',
  'pages.scribe.loadingAudio': '音声を読み込み中...',
  'pages.scribe.mattersUpdatedSuccess': '案件を更新しました',
  'pages.scribe.modeNotGenerated': '{modeLabel} はまだ生成されていません',
  'pages.scribe.nameYourTranscriptPlaceholder': '文字起こしに名前を付けてください',
  'pages.scribe.newRecordingTitle': '新しい録音',
  'pages.scribe.newTranscript': '新しい文字起こし',
  'pages.scribe.newTranscriptName': '新しい文字起こし {timestamp}',
  'pages.scribe.noAudioFileAvailable': '利用できる音声ファイルがありません。',
  'pages.scribe.noAudioForDownload': 'ダウンロードできる音声ファイルがありません。',
  'pages.scribe.noContentAvailable': '内容がありません。再生成してください。',
  'pages.scribe.noOutputsGenerated': '生成された出力はありません',
  'pages.scribe.noRecentRecordings': '最近の録音はまだありません。',
  'pages.scribe.noSegmentsToEdit': '編集できるセグメントがありません',
  'pages.scribe.noTimestampedSegments': 'タイムスタンプ付きの文字起こしセグメントがありません。',
  'pages.scribe.notAvailable': '該当なし',
  'pages.scribe.optionEmailDrafts': 'メールの下書き',
  'pages.scribe.outputNotGeneratedYet': 'この出力はまだ生成されていません。',
  'pages.scribe.outputViewer.actionItemsLabel': 'アクションアイテム',
  'pages.scribe.outputViewer.addActionItemButton': 'アクションアイテムを追加',
  'pages.scribe.outputViewer.columnAction': 'アクション',
  'pages.scribe.outputViewer.columnAssignee': '担当者',
  'pages.scribe.outputViewer.columnDueDate': '期限',
  'pages.scribe.outputViewer.columnTask': 'タスク',
  'pages.scribe.outputViewer.commaSeparatedNamesPlaceholder': '名前をカンマ区切りで入力',
  'pages.scribe.outputViewer.fieldBody': '本文',
  'pages.scribe.outputViewer.fieldCategory': 'カテゴリ',
  'pages.scribe.outputViewer.fieldCleanedTranscript': '整形済みの文字起こし',
  'pages.scribe.outputViewer.fieldExecutiveSummary': 'エグゼクティブサマリー',
  'pages.scribe.outputViewer.fieldGeneratedTitle': '生成されたタイトル',
  'pages.scribe.outputViewer.fieldKeyDecisions': '主な決定事項',
  'pages.scribe.outputViewer.fieldNextMeeting': '次回の会議',
  'pages.scribe.outputViewer.fieldParticipants': '参加者',
  'pages.scribe.outputViewer.fieldRecipients': '宛先',
  'pages.scribe.outputViewer.fieldSignatureBlock': '署名欄',
  'pages.scribe.outputViewer.fieldSubject': '件名',
  'pages.scribe.outputViewer.fieldTopic': '議題',
  'pages.scribe.outputViewer.generatingContent': '内容を生成しています...',
  'pages.scribe.outputViewer.generationFailed': '生成に失敗しました',
  'pages.scribe.outputViewer.onePerLinePlaceholder': '1 行に 1 件',
  'pages.scribe.outputViewer.pleaseCheckFields': '入力内容をご確認ください',
  'pages.scribe.outputViewer.titleDefault': '出力',
  'pages.scribe.outputViewer.titleEmailDraft': 'メールの下書き',
  'pages.scribe.outputViewer.titleMeetingNotes': '議事録',
  'pages.scribe.outputViewer.titleVoiceMemo': 'ボイスメモ',
  'pages.scribe.outputViewer.unknownOutputType': '不明な出力形式',
  'pages.scribe.pauseRecordingTitle': '録音を一時停止',
  'pages.scribe.recentRecordingsTitle': '最近の録音',
  'pages.scribe.recentlyTranscribed': '最近文字起こししたもの',
  'pages.scribe.recordingInProgressWarning':
    '現在録音中です。セッションを切り替える前に録音を停止してください',
  'pages.scribe.recordingMicOnlyNote':
    '録音はマイクの音声のみを取り込み、スピーカーの音声は取り込みません。パソコンで再生中の音声を文字起こしするには、別のデバイスを使うか、録音をアップロードしてください。',
  'pages.scribe.recordingPaused': '録音を一時停止しました',
  'pages.scribe.recordingPausedInline': '録音を一時停止中',
  'pages.scribe.regenerateButton': '再生成',
  'pages.scribe.resumeRecordingTitle': '録音を再開',
  'pages.scribe.retranslatingSegments': '編集したセグメントを再翻訳しています...',
  'pages.scribe.fillingMissingTranslations': '未翻訳のセグメントを翻訳しています...',
  'pages.scribe.rewind10': '10 秒巻き戻し',
  'pages.scribe.saveEditsFailed': '文字起こしの編集の保存に失敗しました',
  'pages.scribe.saveFailed': '保存に失敗しました',
  'pages.scribe.saveTranscriptFailed': '文字起こしの保存に失敗しました',
  'pages.scribe.saveTranscriptModalTitle': '文字起こしを保存',
  'pages.scribe.saveTranscriptTitle': '文字起こしを保存',
  'pages.scribe.savedSuccessfully': '保存しました',
  'pages.scribe.savingTranscript': '文字起こしを保存しています...',
  'pages.scribe.scribeTitle': 'スクライブ',
  'pages.scribe.scribeTourButton': 'スクライブツアー',
  'pages.scribe.scrollToBottom': '最下部へスクロール',
  'pages.scribe.searchMattersPlaceholder': '案件を検索...',
  'pages.scribe.searchTranscriptsPlaceholder': '文字起こしを検索',
  'pages.scribe.segmentTranslationFailed': 'セグメントの翻訳に失敗しました',
  'pages.scribe.selectMattersLabel': '案件を選択：',
  'pages.scribe.startGenerationFailed': '生成の開始に失敗しました',
  'pages.scribe.startTranscriptionFailed': '文字起こし処理の開始に失敗しました',
  'pages.scribe.status.clickMicToStart': 'マイクをクリックして録音を開始',
  'pages.scribe.status.defaultDescription':
    '音声ファイルや録音を、構造化されたテキストに書き起こします',
  'pages.scribe.status.processingFile': 'ファイルを処理しています... {stage}',
  'pages.scribe.status.queued': '待機中',
  'pages.scribe.status.transcriptionCancelled': '文字起こしをキャンセルしました',
  'pages.scribe.status.transcriptionCompleted': '文字起こしが完了しました',
  'pages.scribe.status.transcriptionFailed': '文字起こしに失敗しました',
  'pages.scribe.stopRecordingConfirm.cancelText': 'とどまる',
  'pages.scribe.stopRecordingConfirm.content':
    '録音が進行中です。このページを離れると録音が停止します。続行しますか？',
  'pages.scribe.stopRecordingConfirm.okText': 'ページを離れる',
  'pages.scribe.stopRecordingConfirm.title': '録音を停止しますか？',
  'pages.scribe.stopRecordingSaveTitle': '録音を停止して保存',
  'pages.scribe.tabs.emailDraft': 'メールの下書き',
  'pages.scribe.tabs.meetingNotes': '議事録',
  'pages.scribe.tabs.rawTranscript': '元の文字起こし',
  'pages.scribe.tabs.voiceMemo': 'ボイスメモ',
  'pages.scribe.tourButton': 'ツアー',
  'pages.scribe.transcriptDeleted': '文字起こしを削除しました',
  'pages.scribe.transcriptEmpty': '文字起こしが空です',
  'pages.scribe.transcriptNameUpdated': '文字起こしの名前を更新しました',
  'pages.scribe.transcriptSavedSuccess': '文字起こしを保存しました',
  'pages.scribe.transcriptTour.audioDesc':
    '文字起こしは録音と同期しています。各文が、それが話された正確な時点にリンクしています。音声の任意の箇所をタップすると、対応するテキストを確認できます。',
  'pages.scribe.transcriptTour.audioTitle': '音声 ',
  'pages.scribe.transcriptTour.audioTranscriptDesc':
    '自動生成された黒い文字はクリックできます。任意の文をタップすると、その時点にジャンプします。クリックした文は青くなり、その音声が自動的に再生されます。録音の任意の箇所をすばやく聞き直すのにお使いください。',
  'pages.scribe.transcriptTour.audioTranscriptTitle': '音声の文字起こし',
  'pages.scribe.transcriptTour.generateMoreModesDesc':
    'ほかのタブに移動して「生成」をクリックすると、別の形式も作成できます。',
  'pages.scribe.transcriptTour.generateMoreModesTitle': 'ほかの形式を生成する',
  'pages.scribe.transcriptTour.viewResultsDesc': '文字起こしの結果はここに表示されます。',
  'pages.scribe.transcriptTour.viewResultsTitle': '結果を表示',
  'pages.scribe.transcriptUpdated': '文字起こしを更新しました',
  'pages.scribe.transcriptionFailedDesc':
    'スクライブはこの音声を文字起こしできませんでした。音声ファイルをダウンロードし、もう一度アップロードしてみてください。',
  'pages.scribe.transcriptionFailedTitle': '文字起こしに失敗しました',
  'pages.scribe.transcriptionLanguageQuestion': '文字起こしにはどの言語を使いますか？',
  'pages.scribe.transcriptionPurposeQuestion': 'この文字起こしは何に使う予定ですか？',
  'pages.scribe.translatingEllipsis': '翻訳中...',
  'pages.scribe.increaseTranslationSize': '翻訳テキストを大きくする',
  'pages.scribe.decreaseTranslationSize': '翻訳テキストを小さくする',
  'pages.scribe.translationTextSize': '翻訳テキストのサイズ',
  'pages.scribe.unassigned': '未割り当て',
  'pages.scribe.unnamedTranscript': '名前のない文字起こし',
  'pages.scribe.untitled': '無題',
  'pages.scribe.untitledParens': '（無題）',
  'pages.scribe.untitledTranscript': '無題の文字起こし',
  'pages.scribe.updateMattersFailed': '案件の更新に失敗しました',
  'pages.scribe.updateNameFailed': '文字起こしの名前の更新に失敗しました',
  'pages.scribe.updateTranscriptNameTitle': '文字起こしの名前を更新',
  'pages.scribe.uploadRecordingButton': '録音をアップロード',
  'pages.scribe.uploadingAudioFile': '音声ファイルをアップロード中...',
  'pages.scribe.waitingEllipsis': '待機中...',
  'pages.scribe.waitingForTranslations': '翻訳の完了を待っています...',
  'pages.scribe.whatsNew': '新着情報',
  'pages.scribe.whatsNew.filteringSortingDesc': '文字起こしの管理と検索を行う画面を改善しました。',
  'pages.scribe.whatsNew.filteringSortingLabel': '絞り込みと並べ替え：',
  'pages.scribe.whatsNew.guidanceTabsDesc': '始め方の説明や新機能の紹介を簡単に見つけられます。',
  'pages.scribe.whatsNew.guidanceTabsLabel': 'ガイドタブ：',
  'pages.scribe.whatsNew.integratedTourDesc':
    'スクライブの機能を紹介するガイド付きツアーを、新着情報タブから直接開始できます。',
  'pages.scribe.whatsNew.integratedTourLabel': '統合されたツアー：',
  'pages.scribe.whatsNew.intro': 'より快適に文字起こしを行えるよう、スクライブを改善しました：',
  'pages.scribe.whatsNew.upcomingFeaturesDesc':
    'より詳細な多言語の設定や、高度な構造化出力形式にご期待ください。',
  'pages.scribe.whatsNew.upcomingFeaturesTitle': '今後の機能',
  'pages.search.chunkCopiedSuccess': 'チャンクをコピーしました',
  'pages.search.chunkCopyFailed': 'チャンクのコピーに失敗しました',
  'pages.search.searchRatioLabel': '検索比率',
  'pages.search.favouriteFileWeightLabel': 'お気に入りファイル重み',
  'pages.search.rerankLabel': '再ランキング',
  'pages.search.filePreviewAlt': 'ファイルプレビュー',
  'pages.search.previewNotSupported': 'このファイル形式はプレビューできません',
  'pages.search.chunkPageLabel': 'ページ：{pageNumber}',
  'pages.search.matchPercentage': '一致度 {score}%',
  'pages.search.openChunkAriaLabel': 'チャンク {index} を開く',
  'pages.search.navigateResultsTitle': '結果を移動',
  'pages.search.loadingChunkResults': 'チャンクの結果を読み込んでいます...',
  'pages.search.chunkResultCount': '{count, plural, other {件のチャンク結果}}',
  'pages.search.previousResultTitle': '前の結果',
  'pages.search.nextResultTitle': '次の結果',
  'pages.search.chatWithDocumentButton': 'このドキュメントについてチャットする',
  'pages.search.searchWithinDocumentPlaceholder': 'ドキュメント内を検索...',
  'pages.search.filterDownLabel': '絞り込む',
  'pages.search.documentPreviewTitle': 'ドキュメントのプレビュー',
  'pages.search.askAgelPlaceholder': 'A&GEL に質問',
  'pages.search.searchAllButton': 'すべて検索',
  'pages.search.advancedSettingsButton': '詳細設定',
  'pages.search.allTagsOption': ' すべてのタグ',
  'pages.sideBySide.addAtLeastOneQuestion': '質問を 1 つ以上追加してください',
  'pages.sideBySide.addAtLeastOneQuestionBeforeSubmitting':
    '送信する前に質問を 1 つ以上追加してください。',
  'pages.sideBySide.addNewQuestionsPlaceholder': '新しい質問を追加（1 行に 1 件）',
  'pages.sideBySide.addPlusButton': '追加 +',
  'pages.sideBySide.addQuestionsLabel': '質問を追加',
  'pages.sideBySide.addToMattersButton': '案件に追加',
  'pages.sideBySide.authorFieldLabel': '作成者',
  'pages.sideBySide.authorLabel': '作成者：',
  'pages.sideBySide.categoryLabel': 'カテゴリ',
  'pages.sideBySide.cellDetails.answer': '回答',
  'pages.sideBySide.cellDetails.verified': '検証済み',
  'pages.sideBySide.cellDetails.verify': '検証',
  'pages.sideBySide.cellMarkedUnverified': 'セルを未検証としてマークしました',
  'pages.sideBySide.cellMarkedVerified': 'セルを検証済みとしてマークしました',
  'pages.sideBySide.cellUpdatedSuccess': 'セルを更新しました',
  'pages.sideBySide.changesUndone': '変更を元に戻しました',
  'pages.sideBySide.clickOrDragToUpload': 'クリックまたはドラッグしてアップロード',
  'pages.sideBySide.cloneButton': '複製',
  'pages.sideBySide.cloneModeLabel': '複製',
  'pages.sideBySide.clonedNamePrefix': '複製 - {name}',
  'pages.sideBySide.columnEditModal.columnAddedSuccess':
    '新しい列を追加しました。マトリックスはまもなく更新されます。',
  'pages.sideBySide.columnEditModal.columnUpdateStartedSuccess':
    '列の更新を開始しました。列はまもなく更新されます。',
  'pages.sideBySide.columnEditModal.enterPromptWarning': 'プロンプトを入力してください。',
  'pages.sideBySide.columnEditModal.promptLabel': 'プロンプト',
  'pages.sideBySide.columnEditModal.promptPlaceholder':
    'この列のプロンプト／システム指示を記述してください',
  'pages.sideBySide.columnEditModal.title': '列を変更',
  'pages.sideBySide.columnEditModal.updateColumnFailed': '列の更新に失敗しました',
  'pages.sideBySide.createCustomQuestionListDescription':
    'このセッション用にカスタムの並べて比較用質問リストを作成します',
  'pages.sideBySide.createModeLabel': '作成',
  'pages.sideBySide.createQuestionListButton': '質問リストを作成',
  'pages.sideBySide.createdByLabel': '作成者：',
  'pages.sideBySide.createdByYou': 'あなた',
  'pages.sideBySide.customInstructionOptional': '2. カスタム指示（任意）',
  'pages.sideBySide.deleteQuestionListConfirm': 'この質問リストを削除してもよろしいですか？',
  'pages.sideBySide.dragHereToUpload': 'ここにドラッグしてアップロード',
  'pages.sideBySide.emailButton': 'メールアドレス',
  'pages.sideBySide.exitButton': '終了',
  'pages.sideBySide.exitModeButton': '{mode}を終了',
  'pages.sideBySide.fileCount': '{count} 件のファイル',
  'pages.sideBySide.firmOption': '事務所',
  'pages.sideBySide.firmWideOption': '事務所全体',
  'pages.sideBySide.fromDocumentOption': 'ドキュメントから',
  'pages.sideBySide.groupOption': 'グループ',
  'pages.sideBySide.leadRowHeader': '出典ドキュメントの段落',
  'pages.sideBySide.manualCraftOption': '手動で作成',
  'pages.sideBySide.modifyButton': '変更',
  'pages.sideBySide.modifyModeLabel': '変更',
  'pages.sideBySide.newCategoryPlaceholder': '新しいカテゴリ',
  'pages.sideBySide.newQuestionListButtonLabel': '新しい並べて比較用質問リスト',
  'pages.sideBySide.newQuestionListDefaultName': '新しい並べて比較用質問リスト',
  'pages.sideBySide.noNotesAvailable': 'メモはありません。',
  'pages.sideBySide.noPurposeAvailable': '目的は設定されていません。',
  'pages.sideBySide.noSystemPromptConfigured': 'システムプロンプトは設定されていません。',
  'pages.sideBySide.notesFieldLabel': 'メモ',
  'pages.sideBySide.notesLabel': 'メモ：',
  'pages.sideBySide.pendingApprovalTag': '承認待ち',
  'pages.sideBySide.pollingTimeoutWarning':
    'ポーリングがタイムアウトしました。並べて比較の処理はまだ続いている可能性があります。',
  'pages.sideBySide.processing': '処理中',
  'pages.sideBySide.processingStopped': '処理を停止しました。',
  'pages.sideBySide.publicOption': '全体公開',
  'pages.sideBySide.publishButton': '公開',
  'pages.sideBySide.publishQuestionListFailed': '質問リストの公開に失敗しました',
  'pages.sideBySide.publishStatusLabel': '公開ステータス',
  'pages.sideBySide.publishToLabel': '公開先：',
  'pages.sideBySide.publishedToAccess': '{access} に公開しました',
  'pages.sideBySide.publishedToGroupSuccess': '質問リストをグループに公開しました',
  'pages.sideBySide.publishedToPrivateGroups': '質問リストをプライベートグループに公開しました',
  'pages.sideBySide.publisherLabel': '公開者：',
  'pages.sideBySide.purposeFieldLabel': '目的',
  'pages.sideBySide.purposeLabel': '目的：',
  'pages.sideBySide.questionListClonedSuccess': '質問リストを複製しました',
  'pages.sideBySide.questionListCreatedSuccess': '質問リストを作成しました',
  'pages.sideBySide.questionListDeletedSuccess': '質問リストを削除しました',
  'pages.sideBySide.questionListNamePlaceholder': '並べて比較用質問リストの名前',
  'pages.sideBySide.questionListUpdatedSuccess': '質問リストを更新しました',
  'pages.sideBySide.questionsListLabel': '質問リスト',
  'pages.sideBySide.quickQuestionsDescription':
    'その場で作成した質問に基づいて、1 つまたは複数のドキュメントの構造化された並べて比較を作成します',
  'pages.sideBySide.quickQuestionsTitle': 'クイック質問',
  'pages.sideBySide.rejectedTag': '却下',
  'pages.sideBySide.restoreConfigurationFailed':
    '設定の復元に失敗しました。もう一度お試しください。',
  'pages.sideBySide.reuseButton': '再利用',
  'pages.sideBySide.reviewTemplateQuestionsDescription': 'このテンプレートの質問を確認します',
  'pages.sideBySide.saveChangesButton': '変更を保存',
  'pages.sideBySide.selectDocumentDescription': '並べて比較を行うドキュメントを選択してください',
  'pages.sideBySide.selectGroupsPlaceholder': 'グループを選択',
  'pages.sideBySide.selectGroupsToShareDescription':
    '共有先のグループを 1 つ以上選択してください：',
  'pages.sideBySide.selectionDescription':
    '質問リストに基づいて、1 つまたは複数のドキュメントの構造化された並べて比較を作成します',
  'pages.sideBySide.selectionFeatureName': '並べて比較',
  'pages.sideBySide.selectionTitle': '並べて比較',
  'pages.sideBySide.sentForApprovalSuccess': '質問リストを承認申請しました',
  'pages.sideBySide.showQuestionsButton': '質問を表示',
  'pages.sideBySide.startGenerateReview': 'レビューの生成を開始',
  'pages.sideBySide.startNewSideBySideButton': '新しい並べて比較を開始',
  'pages.sideBySide.stayButton': 'とどまる',
  'pages.sideBySide.submitFailed': '並べて比較の送信に失敗しました',
  'pages.sideBySide.systemPromptLabel': 'システムプロンプト',
  'pages.sideBySide.tabs.prompts': 'プロンプト',
  'pages.sideBySide.tabs.questionList': '質問リスト',
  'pages.sideBySide.tabs.selectDocuments': 'ドキュメントを選択',
  'pages.sideBySide.targetAudiencePlaceholder': 'クライアント名または想定読者',
  'pages.sideBySide.teamsButton': 'Teams',
  'pages.sideBySide.templateSystemPromptLabel': 'テンプレートのシステムプロンプト',
  'pages.sideBySide.tour.noHistorySessions':
    '履歴に並べて比較のセッションがありません。このステップを表示するには、まず 1 つ作成してください。',
  'pages.sideBySide.tour.step1.description':
    'まず、利用可能なカテゴリから質問リストを選択します。任意の質問リストカードをクリックして進んでください。',
  'pages.sideBySide.tour.step1.title': '質問リストを選択',
  'pages.sideBySide.tour.step2.description':
    '想定読者またはクライアント名を入力し、並べて比較したいドキュメントを選択してください。',
  'pages.sideBySide.tour.step2.title': '想定読者を入力してファイルを選択',
  'pages.sideBySide.tour.step3.description':
    'ここでシステムプロンプトと質問リストを確認できます。履歴パネルに切り替えると過去のセッションを表示できます。',
  'pages.sideBySide.tour.step3.title': 'システムプロンプトと質問を表示',
  'pages.sideBySide.tour.step4.description':
    '送信すると、並べて比較の結果が表に表示されます。セルをクリックすると詳細を確認できます。',
  'pages.sideBySide.tour.step4.title': '並べて比較の結果を表示',
  'pages.sideBySide.typeHerePlaceholder': 'ここに入力...',
  'pages.sideBySide.undoChangesButton': '変更を元に戻す',
  'pages.sideBySide.unsavedChangesWillBeLost': '保存されていない変更はすべて失われます。',
  'pages.sideBySide.untitled': '（無題）',
  'pages.sideBySide.updateCellFailed': 'セルの更新に失敗しました',
  'pages.sideBySide.updateCellVerificationFailed': 'セルの検証状態の更新に失敗しました',
  'pages.sideBySide.updateFailed': '更新に失敗しました',
  'pages.sideBySide.uploadDocumentFailed': 'ドキュメントのアップロードに失敗しました',
  'pages.sideBySide.whatsNewDescription':
    'ドキュメントの並べて比較をより快適にする新機能をいくつか追加しました。',
  'pages.sideBySide.whoIsItForQuestion': '1. 対象は誰ですか？',
  'pages.template.waitingMessage.justAMoment': '少々お待ちください...',
  'pages.template.waitingMessage.fetchingThatForYou': '取得しています...',
  'pages.template.waitingMessage.hangTight': '対応中です。もう少しお待ちください...',
  'pages.template.waitingMessage.letMeCheck': '確認しています...',
  'pages.template.waitingMessage.oneSecPlease': '少々お待ちください...',
  'pages.template.waitingMessage.lookingThatUp': 'お調べしています...',
  'pages.template.waitingMessage.almostThere': 'もう少しです...',
  'pages.template.waitingMessage.holdOnRetrieving': '少々お待ちください。情報を取得しています...',
  'pages.template.waitingMessage.workingOnIt': '対応中です...',
  'pages.template.dragDropUpload': 'ここにドラッグしてアップロード',
  'pages.template.uploadInvalidFileTypes':
    'PDF、DOC、DOCX、MSG、EML、TXT、MD のファイルのみアップロードしてください',
  'pages.template.someFilesSkipped':
    '一部のファイルがスキップされました。PDF、DOC、DOCX、MSG、EML、TXT、MD のファイルのみ使用できます',
  'pages.template.fileUploadedSuccess': '{fileName} をアップロードしました',
  'pages.template.fileUploadFailed': '{fileName} のアップロードに失敗しました',
  'pages.template.loadTemplateDetailsFailed': 'テンプレートの詳細の読み込みに失敗しました',
  'pages.template.viewLess': '表示を減らす',
  'pages.template.viewAll': 'すべて表示',
  'pages.template.tour.step1Title': 'カスタム出力テンプレートを選択',
  'pages.template.tour.step1Description':
    'まず、利用可能なカテゴリからテンプレートのプリセットを選択します。',
  'pages.template.tour.step2Title': '分析するファイルを選択',
  'pages.template.tour.step2Description':
    'カスタム出力を実行したいドキュメントをアップロードまたは選択してください。',
  'pages.template.tour.step3Title': 'プロンプトと指示を確認',
  'pages.template.tour.step3Description':
    'ここで想定読者の詳細と、任意のカスタム指示を入力します。',
  'pages.template.tour.step4Title': '結果を表示',
  'pages.template.tour.step4Description':
    '送信すると、生成されたカスタム出力がこの領域に表示されます。',
  'pages.template.noSessionsFound':
    'テンプレートのセッションが見つかりません。結果を表示するには、まず実行してください。',
  'pages.template.startNewCustomOutput': '新しいカスタム出力を開始',
  'pages.template.untitled': '（無題）',
  'pages.template.newSession': '新しいセッション',
  'pages.template.fileCount': '{count} 件のファイル',
  'pages.template.reuseButton': '再利用',
  'pages.template.addToMattersButton': '案件に追加',
  'pages.template.startFillingTemplates': 'テンプレートへの入力を開始',
  'pages.template.unsavedChangesWarning': '保存されていない変更はすべて失われます。',
  'pages.template.stayButton': 'とどまる',
  'pages.template.exitButton': '終了',
  'pages.template.undoChangesButton': '変更を元に戻す',
  'pages.template.changesUndoneMessage': '変更を元に戻しました',
  'pages.template.templateCreatedSuccess': 'テンプレートを作成しました',
  'pages.template.templateUpdatedSuccess': 'テンプレートを更新しました',
  'pages.template.fillRequiredFields': '必須項目をすべて入力してください',
  'pages.template.saveTemplateFailed': 'テンプレートの保存に失敗しました',
  'pages.template.createTemplateButton': 'テンプレートを作成',
  'pages.template.saveTemplateButton': 'テンプレートを保存',
  'pages.template.presetNamePlaceholder': 'カスタムテンプレートプリセットの名前',
  'pages.template.categoryLabel': 'カテゴリ',
  'pages.template.newCategoryPlaceholder': '新しいカテゴリ',
  'pages.template.addCategoryButton': 'カテゴリを追加',
  'pages.template.purposeLabel': '目的',
  'pages.template.notesLabel': 'メモ',
  'pages.template.systemPromptLabel': 'システムプロンプト',
  'pages.template.typeProse': '文章',
  'pages.template.typeTable': '表',
  'pages.template.tableTypeLabel': '表の種類',
  'pages.template.tableTypeTooltip':
    '「条項ごと」および「ドキュメントごと」の表では、ユーザー定義の列は使用できません。',
  'pages.template.tableTypeStandard': '標準',
  'pages.template.tableTypeDocument': 'ドキュメントごと',
  'pages.template.tableTypeClause': '条項ごと',
  'pages.template.columnsLabel': '列',
  'pages.template.newColumnButton': '新しい列',
  'pages.template.exampleLabel': '例',
  'pages.template.userDefinedLabel': 'ユーザー定義',
  'pages.template.userDefinedColumnTooltip': 'ユーザー定義の列',
  'pages.template.columnTypeString': '文字列',
  'pages.template.columnTypeNumber': '数値',
  'pages.template.columnTypeDatetime': '日時',
  'pages.template.sectionsLabel': 'セクション',
  'pages.template.newSectionButton': '新しいセクション',
  'pages.template.headingColumnHeader': '見出し',
  'pages.template.promptColumnHeader': 'プロンプト',
  'pages.template.modifyButton': '変更',
  'pages.template.publishToLabel': '公開先：',
  'pages.template.publishFirmWide': '事務所全体',
  'pages.template.publicAccessLabel': '全体公開',
  'pages.template.firmAccessLabel': '事務所',
  'pages.template.publishButton': '公開',
  'pages.template.publishSentForApproval': 'テンプレートプリセットを承認申請しました',
  'pages.template.publishTemplateFailed': 'テンプレートの公開に失敗しました',
  'pages.template.deleteConfirmQuestion': 'このテンプレートを削除してもよろしいですか？',
  'pages.template.templateDeletedSuccess': 'テンプレートを削除しました',
  'pages.template.deleteTemplateFailed': 'テンプレートの削除に失敗しました',
  'pages.template.customTemplateCreatedForSession':
    'このセッション用のカスタムテンプレートを作成しました',
  'pages.template.publishStatusLabel': '公開ステータス',
  'pages.template.pendingApprovalStatus': '承認待ち',
  'pages.template.rejectedStatus': '却下',
  'pages.template.publishedToStatus': '{target} に公開しました',
  'pages.template.authorLabel': '作成者',
  'pages.template.emailButton': 'メールアドレス',
  'pages.template.noPurposeAvailable': '目的は設定されていません。',
  'pages.template.noNotesAvailable': 'メモはありません。',
  'pages.template.startHereTab': 'ここから始める',
  'pages.template.whoIsItForQuestion': '1. 対象は誰ですか？',
  'pages.template.clientAudiencePlaceholder': 'クライアント名または想定読者',
  'pages.template.selectDocumentsQuestion': '2. レビューを行うドキュメントを選択してください',
  'pages.template.customInstructionTab': 'カスタム指示（任意）',
  'pages.template.modifyPromptLabel': 'プロンプトを変更',
  'pages.template.typeHerePlaceholder': 'ここに入力...',
  'pages.template.noSystemPromptConfigured': 'システムプロンプトは設定されていません。',
  'pages.template.exampleValuePrefix': '例：{example}',
  'pages.template.customOutputTitle': 'カスタム出力',
  'pages.template.customOutputDescription':
    '特定の種類の情報を抽出したい場合や、より徹底した分析が必要な場合に向けて、カスタマイズしたプロンプト（A&GEL では「カスタム出力」と呼びます）を作成・使用し、ドキュメントをより目的に合わせて分析できます',
  'pages.template.whatsNewButton': '新着情報',
  'pages.template.tourButton': 'ツアー',
  'pages.template.addNewCustomTemplateButton': '新しいカスタムテンプレートを追加',
  'pages.template.whatsNewModal.intro':
    'ドキュメントレビューをより快適にする新機能をいくつか追加しました：',
  'pages.template.whatsNewModal.improvedFilteringTitle': 'フィルター機能の改善：',
  'pages.template.whatsNewModal.improvedFilteringBody':
    '公開範囲と作成者のフィルターが追加され、質問リストをより素早く見つけられます。',
  'pages.template.whatsNewModal.adhocQuestionsTitle': 'アドホックな質問：',
  'pages.template.whatsNewModal.adhocQuestionsBody':
    'その場で質問を追加できる、より柔軟な方法です。',
  'pages.template.whatsNewModal.uiEnhancementsTitle': 'UI の改善：',
  'pages.template.whatsNewModal.uiEnhancementsBody':
    'テンプレートの管理がより直感的でシンプルなインターフェースになりました。',
  'pages.template.upcomingFeaturesTitle': '今後の機能',
  'pages.template.upcomingFeaturesBody':
    '共同レビューや高度な AI 分析など、今後のアップデートにご期待ください。',
  'pages.template.tourIndicator': '{current} / {total}',
  'pages.translation.addToMattersButton': '案件に追加',
  'pages.translation.batchFileCountLabel': '{count} 件のファイル',
  'pages.translation.batchTranslationStarted': '一括翻訳を開始しました',
  'pages.translation.copiedSuccess': 'コピーしました',
  'pages.translation.couldNotResolveFile':
    '選択されたファイルを特定できませんでした。もう一度アップロードするか、ファイルを選択してください。',
  'pages.translation.customInstructionTab': 'カスタム指示（任意）',
  'pages.translation.docxOrPdfOnly': 'DOCX または PDF ファイルのみ選択してください。',
  'pages.translation.downloadFailed': 'ダウンロードに失敗しました（{status}）',
  'pages.translation.dragHereToUpload': 'ここにドラッグしてアップロード',
  'pages.translation.enterLanguageRequired': '言語を入力してください',
  'pages.translation.failedRenderOriginalPreview': '原文プレビューの表示に失敗しました',
  'pages.translation.failedRenderTranslatedPreview': '訳文プレビューの表示に失敗しました',
  'pages.translation.failedToFetchDocx': 'DOCX の取得に失敗しました（{status}）',
  'pages.translation.failedToStartTranslation': '翻訳の開始に失敗しました',
  'pages.translation.failedToStartTranslationMissingId':
    '翻訳を開始できませんでした（ID がありません）',
  'pages.translation.fileCountLabel': '{count} 件のファイル',
  'pages.translation.filterFilesPlaceholder': 'ファイルを絞り込む',
  'pages.translation.liveTranslationHint': '左側に入力すると、右側に訳文がすぐに表示されます。',
  'pages.translation.liveTranslationTitle': 'ライブ翻訳',
  'pages.translation.modifyPromptLabel': 'プロンプトを変更',
  'pages.translation.failed': '翻訳に失敗しました',
  'pages.translation.noPreviewAvailable': 'プレビューを利用できません',
  'pages.translation.noFilesMatch': '「{query}」に一致するファイルがありません',
  'pages.translation.noTranslatedDocumentYet': '翻訳済みのドキュメントはまだありません。',
  'pages.translation.originalLabel': '原文',
  'pages.translation.viewSideBySide': '左右に並べる',
  'pages.translation.viewAlternating': '交互に表示',
  'pages.translation.originalPdfTitle': '原文 PDF',
  'pages.translation.otherLanguagePlaceholder': '例：タミル語',
  'pages.translation.outputLanguageStep': '2. 出力言語',
  'pages.translation.previewNotSupported':
    '現在、プレビューは DOCX と PDF のファイルのみ対応しています。',
  'pages.translation.processingTitle': '処理中…',
  'pages.translation.processingTranslation': '翻訳を処理しています…',
  'pages.translation.promptOptionalLabel': 'プロンプト（任意）',
  'pages.translation.recentlyTranslatedLabel': '最近翻訳したもの',
  'pages.translation.renderingOriginal': '原文を表示しています…',
  'pages.translation.renderingTranslation': '訳文を表示しています…',
  'pages.translation.reuseButton': '再利用',
  'pages.translation.searchTranslationsPlaceholder': '翻訳を検索',
  'pages.translation.selectAtLeastOneDocument':
    '翻訳するドキュメントを 1 件以上アップロードまたは選択してください。',
  'pages.translation.selectAtMostDocuments':
    '翻訳するドキュメントは最大 {max} 件まで選択してください。',
  'pages.translation.selectDocumentStep': '1. 翻訳したいドキュメントを選択してください',
  'pages.translation.selectLanguagePlaceholder': '言語を選択',
  'pages.translation.selectLanguageRequired': '言語を選択してください',
  'pages.translation.selectOutputLanguagePlaceholder': '出力言語を 1 つ選択',
  'pages.translation.selectOutputLanguageRequired': '出力言語を選択してください。',
  'pages.translation.startHereTab': 'ここから始める',
  'pages.translation.startLiveTranslationButton': 'ライブ翻訳を開始',
  'pages.translation.startNewTranslationButton': '新しい翻訳を開始',
  'pages.translation.startTranslationButton': '翻訳を開始',
  'pages.translation.stopTranslationFailed': '翻訳の停止に失敗しました',
  'pages.translation.swapLanguagesTooltip': '言語を入れ替える',
  'pages.translation.title': '翻訳',
  'pages.translation.translateButton': '翻訳',
  'pages.translation.translatedLabel': '訳文',
  'pages.translation.translatedPdfTitle': '翻訳済み PDF',
  'pages.translation.downloadAsPdf': 'PDF – 元のレイアウト',
  'pages.translation.downloadAsWord': 'Word – 編集可能なテキスト',
  'pages.translation.zoomIn': '拡大',
  'pages.translation.zoomOut': '縮小',
  'pages.translation.fitWidth': '幅に合わせる',
  'pages.translation.translationFailedError': '翻訳に失敗しました',
  'pages.translation.translationHint':
    'ドキュメントを 1 つ以上の出力言語に翻訳します。結果は原文のセグメントと並べて表示されます。',
  'pages.translation.translationStoppedSuccess': '翻訳を停止しました',
  'pages.translation.translationTaskStarted': '翻訳タスクを開始しました',
  'pages.translation.typeTextToTranslatePlaceholder': '翻訳したいテキストを入力',
  'pages.translation.unknownLanguage': '不明',
  'pages.translation.untitledFallback': '（無題）',
  'pages.translation.untitledTranslationFallback': '無題の翻訳',
  'pages.user.passwordConfirmationPlaceholder': 'パスワードの確認',
  'pages.user.logoAlt': 'ロゴ',
  'pages.user.emailPlaceholder': 'メールアドレス',
  'pages.user.passwordPlaceholder': 'パスワード',
  'pages.user.newPasswordPlaceholder': '新しいパスワード',
  'pages.user.forgotPassword.emailSentMessage':
    'そのメールアドレスが登録されている場合は、まもなくメールが送信されます',
  'pages.user.forgotPassword.submitButton': 'リセットリンクを送信',
  'pages.user.resetPassword.successMessage': 'パスワードを更新しました',
  'pages.user.resetPassword.submitButton': 'パスワードをリセット',
  'pages.user.resetPassword.passwordRequired': 'パスワードは必須です',
  'pages.user.resetPassword.passwordMinLength': '8 文字以上で入力してください',
  'pages.user.resetPassword.passwordNeedsAlpha': '英字を 1 文字以上含めてください',
  'pages.user.resetPassword.passwordNeedsNumber': '数字を 1 文字以上含めてください',
  'pages.user.resetPassword.passwordNeedsSpecial': '記号を 1 文字以上含めてください',
  'pages.user.resetPassword.confirmPasswordRequired': '新しいパスワードを再入力してください',
  'pages.user.resetPassword.passwordMismatch': '入力された 2 つのパスワードが一致しません',
  'pages.user.login.tenantNotRegistered':
    'お使いの Microsoft テナントはこのアプリに登録されていません。IT 管理者にお問い合わせください。',
  'pages.user.login.ssoNotConfigured': 'Microsoft SSO が正しく設定されていません',
  'pages.user.login.ssoAccountNotFound': 'Microsoft SSO のアカウントが見つかりません',
  'pages.user.login.emailPasswordWrong': 'メールアドレスまたはパスワードが正しくありません',
  'pages.user.login.contactAdminContent':
    'パスワードのリセットについては管理者にお問い合わせください。',
  'pages.user.management.pageTitle': '管理',
  'pages.user.rolesLoadingPlaceholder': 'ロールを読み込み中...',
  'pages.user.selectRolePlaceholder': 'ロールを選択',
  'pages.user.billing.seatsMinimumError': 'シート数は 1 以上の整数で入力してください。',
  'pages.user.billing.contactRequiredError': '請求先の担当者名とメールアドレスは必須です。',
  'pages.user.billing.contactNameInvalidError':
    "請求先の担当者名に使用できるのは、英字、スペース、ハイフン（-）、アポストロフィ（'）のみです。",
  'pages.user.billing.renewOrChoosePlan': '更新／プランを選択',
  'pages.user.billing.switchPlanAction': 'プランを変更',
  'pages.user.billing.subscribeAction': '登録する',
  'pages.user.billing.renewPlanAction': 'プランを更新',
  'pages.user.billing.switchPlanModalTitle': 'プランの変更',
  'pages.user.billing.switchPlanConfirmContent':
    'チェックアウトに移動し、{planName}（{interval}ごと）の {seats} シート分として {total} が請求されます。',
  'pages.user.billing.switchPlanConfirmContentRenewal':
    '解約済みのサブスクリプションを更新するため、チェックアウトに移動し、{planName}（{interval}ごと）の {seats} シート分として {total} が請求されます。',
  'pages.user.billing.switchPlanConfirmContentReplace':
    'チェックアウトに移動し、{planName}（{interval}ごと）の {seats} シート分として {total} が請求されます。現在のプランは置き換えられます。',
  'pages.user.billing.renewThisPlanButton': 'このプランを更新',
  'pages.user.billing.currentPlanButton': '現在のプラン',
  'pages.user.billing.switchToThisPlanButton': 'このプランに変更',
  'pages.user.billing.subscribeToThisPlanButton': 'このプランに登録',
  'pages.user.billing.planText': 'プラン',
  'pages.user.billing.selectedTag': '選択中',
  'pages.user.billing.totalLabel': '合計：',
  'pages.user.billing.billingContactTitle': '請求先の担当者',
  'pages.user.billing.billingContactHint': '決済手続きと請求書の発行に必要です。',
  'pages.user.billing.fullNameLabel': '氏名',
  'pages.user.billing.billingEmailLabel': '請求先メールアドレス',
  'pages.user.billing.seatsLabel': 'シート数',
  'pages.user.billing.registeringTenantTitle': 'Microsoft テナントを登録しています',
  'pages.user.billing.tenantStep1': 'ステップ 1/4：Microsoft SSO の設定を読み込んでいます...',
  'pages.user.billing.ssoNotEnabledError':
    'Microsoft SSO が有効になっていません。管理者にお問い合わせください。',
  'pages.user.billing.tenantStep2':
    'ステップ 2/4：Microsoft のサインイン用ポップアップを開いています。サインインし、テナントへのアクセスを許可してください。',
  'pages.user.billing.tenantStep3': 'ステップ 3/4：テナントのトークンをサーバーで検証しています...',
  'pages.user.billing.tenantStep4':
    'ステップ 4/4：テナントの登録情報を現在の組織に保存しています...',
  'pages.user.billing.tenantRegistrationCompleteTitle': 'Microsoft テナントの登録が完了しました',
  'pages.user.billing.tenantAddedMessage':
    '完了しました。テナント ID {tenantId} を組織に追加しました。',
  'pages.user.billing.tenantAlreadyRegisteredMessage':
    'テナント ID {tenantId} はすでに組織に登録されています。追加の操作は必要ありません。',
  'pages.user.billing.tenantRegisterGenericError':
    'Microsoft テナントを登録できませんでした。もう一度お試しください。',
  'pages.user.billing.tenantRegistrationFailedTitle': 'Microsoft テナントの登録に失敗しました',
  'pages.user.billing.tenantRegistrationIncompleteMessage': '登録が完了しませんでした。{detail}',
  'pages.user.billing.loadInvoicesError': '請求書を読み込めませんでした。',
  'pages.user.billing.loadBillingDetailsError': '請求情報を読み込めませんでした。',
  'pages.user.billing.openCheckoutError': '請求のチェックアウトを開けませんでした。',
  'pages.user.billing.seatChangeScheduledMessage':
    'シート数の変更を予約しました。次回の更新時に反映されます。',
  'pages.user.billing.seatsUpdatedMessage': 'シート数を更新しました。',
  'pages.user.billing.tenantPopupNotice':
    'このウィンドウは開いたままにしてください。Microsoft のポップアップが必要です。サインインと同意を完了すると続行できます。',
  'pages.user.billing.editSeatsModalTitle': 'シート数を編集',
  'pages.user.billing.saveSeatsButton': 'シート数を保存',
  'pages.user.billing.currentTotalLabel': '現在の合計',
  'pages.user.billing.previewTotalLabel': '変更後の合計（見込み）',
  'pages.user.billing.differenceLabel': '次回更新時との差額',
  'pages.user.billing.seatChangeRenewalNotice':
    'シート数の変更は、次回の更新日（{nextInvoiceDisplay}）に反映されます。',
  'pages.user.billing.invoices': '請求書',
  'pages.user.billing.nextInvoiceDateLabel': '次回の請求日：',
  'pages.user.billing.invoiceColumn': '請求書',
  'pages.user.billing.dueColumn': '支払期日',
  'pages.user.billing.amountColumn': '金額',
  'pages.user.billing.downloadInvoiceError': '請求書の PDF をダウンロードできませんでした。',
  'pages.user.billing.membersSeatsLabel': 'メンバー数／シート数',
  'pages.user.billing.scheduledTag': '予約済み',
  'pages.user.billing.pendingSeatsNotice': '→ 次回更新時から {seats} シート',
  'pages.user.billing.editSeatsButton': 'シート数を編集',
  'pages.user.billing.currentPlanCardLabel': '現在のプラン',
  'pages.user.billing.priceLabel': '料金：',
  'pages.user.billing.billingCardTitle': '請求',
  'pages.user.billing.nextInvoiceLabel': '次回の請求',
  'pages.user.billing.registerMicrosoftTenantButton': 'Microsoft テナントを登録',
  'pages.user.billing.contactOrgAdmin': '組織の管理者にお問い合わせください。',
  'pages.user.billing.graceDeadlineFallback': '猶予期限',
  'pages.user.billing.paymentIssueTitle': '支払いに問題があります',
  'pages.user.billing.pastDueDescription':
    'サブスクリプションの支払いが期日を過ぎています。{graceDate} まではご利用いただけます。中断を避けるため、今すぐ更新してください。',
  'pages.user.billing.subscriptionCancelledTitle': 'サブスクリプションは解約されました。',
  'pages.user.billing.subscriptionInactiveTitle': 'サブスクリプションが無効です',
  'pages.user.billing.orgAccessRestrictedDescription':
    '請求の問題が解決されるまで、組織へのアクセスは制限されます。',
  'pages.welcomeDashboard.jsonResponseTitle': 'JSON レスポンス',
  'pages.welcomeDashboard.textResponseTitle': 'テキストレスポンス',
  'pages.welcomeDashboard.visibility.public': '全体公開',
  'pages.welcomeDashboard.visibility.firm': '事務所',
  'pages.welcomeDashboard.visibility.unknown': '不明',
  'pages.welcomeDashboard.rejectButton': '却下',
  'pages.welcomeDashboard.approveButton': '承認',
  'pages.welcomeDashboard.metrics.wordsGeneratedToday.title': '本日生成された単語数',
  'pages.welcomeDashboard.metrics.wordsGenerated.chartLabel': '生成された単語数',
  'pages.welcomeDashboard.metrics.wordsGeneratedToday.description': 'AI による起案支援',
  'pages.welcomeDashboard.metrics.pagesProcessed.title': '処理した A4 ページ数',
  'pages.welcomeDashboard.metrics.pagesProcessed.chartLabel': '処理したページ数',
  'pages.welcomeDashboard.metrics.pagesProcessed.description': '本日進行中の案件全体',
  'pages.welcomeDashboard.metrics.documentsDownloaded.title': 'ダウンロードしたドキュメント数',
  'pages.welcomeDashboard.metrics.documentsDownloaded.chartLabel': 'ダウンロードしたドキュメント数',
  'pages.welcomeDashboard.metrics.documentsDownloaded.description': '本日書き出したファイル',
  'pages.welcomeDashboard.metrics.questionsAnswered.title': '回答した質問数',
  'pages.welcomeDashboard.metrics.questionsAnswered.chartLabel': '回答した質問数',
  'pages.welcomeDashboard.metrics.questionsAnswered.description': '本日処理した AI プロンプト',
  'pages.welcomeDashboard.features.apps.name': 'アプリ',
  'pages.welcomeDashboard.features.apps.description': '内容を分析・要約します',
  'pages.welcomeDashboard.features.scribe.name': 'スクライブ',
  'pages.welcomeDashboard.features.scribe.description': 'ドキュメントの文字起こし',
  'pages.welcomeDashboard.features.comparison.name': '比較',
  'pages.welcomeDashboard.features.comparison.description': 'ドキュメントを並べて比較します',
  'pages.welcomeDashboard.features.review.name': 'レビュー',
  'pages.welcomeDashboard.features.review.description': '質問を使ってドキュメントをレビューします',
  'pages.welcomeDashboard.features.translation.name': '翻訳',
  'pages.welcomeDashboard.features.translation.description': 'ドキュメントを翻訳します',
  'pages.welcomeDashboard.features.chat.name': 'チャット',
  'pages.welcomeDashboard.features.chat.description': 'AI アシスタントとチャットします',
  'pages.welcomeDashboard.features.templates.name': 'テンプレート',
  'pages.welcomeDashboard.features.templates.description': 'テンプレートを管理します',
  'pages.welcomeDashboard.features.quote.name': '見積',
  'pages.welcomeDashboard.features.quote.description': '見積書を作成します',
  'pages.welcomeDashboard.features.files.name': 'ファイル',
  'pages.welcomeDashboard.features.files.description': 'ファイルを管理します',
  'pages.welcomeDashboard.features.library.name': 'ライブラリ',
  'pages.welcomeDashboard.features.library.description': 'ライブラリにアクセスします',
  'pages.welcomeDashboard.features.sideBySide.name': '並べて比較',
  'pages.welcomeDashboard.features.sideBySide.description': '並べて比較します',
  'pages.welcomeDashboard.features.playbook.name': 'ワークスタジオ',
  'pages.welcomeDashboard.features.playbook.description':
    'ワークスタジオのセッションを作成・管理します',
  'pages.welcomeDashboard.features.fallback.description': '機能',
  'pages.welcomeDashboard.features.search.name': '検索',
  'pages.welcomeDashboard.greeting': 'こんにちは、{username} さん',
  'pages.welcomeDashboard.useCasesButton': '活用事例',
  'pages.welcomeDashboard.faqsButton': 'よくあるご質問',
  'pages.welcomeDashboard.publishingApprovalsButton': '公開の承認（{count}）',
  'pages.welcomeDashboard.jumpBackInTitle': '最近の項目',
  'pages.welcomeDashboard.untitledSession': '無題のセッション',
  'pages.welcomeDashboard.viewAllButton': 'すべて表示',
  'pages.welcomeDashboard.noRecentSessions': '最近のセッションはありません',
  'pages.welcomeDashboard.statsTitle': 'マイ統計',
  'pages.welcomeDashboard.usefulFeaturesTitle': '便利な機能',
  'pages.welcomeDashboard.sessionsCount': '{count, plural, other {# 件のセッション}}',
  'pages.welcomeDashboard.foundUsefulThisWeek': '今週 {count} 人のユーザーが役立つと評価しました',
  'pages.welcomeDashboard.noRecentActivity': '最近のアクティビティはありません',
  'pages.welcomeDashboard.publishingApprovalsModalTitle': '公開の承認',
  'pages.welcomeDashboard.approvalTag.template': 'テンプレート',
  'pages.welcomeDashboard.approvalTag.review': 'レビュー',
  'pages.welcomeDashboard.approvalTag.sideBySide': '並べて比較',
  'pages.welcomeDashboard.approvalTag.prompt': 'プロンプト',
  'pages.welcomeDashboard.approvalTag.multiStep': 'マルチステップ',
  'pages.welcomeDashboard.recentSessionsModalTitle': '{pageName} — 最近のセッション',
  'pages.welcomeDashboard.detail.publishTarget': '公開先',
  'pages.welcomeDashboard.detail.author': '作成者',
  'pages.welcomeDashboard.detail.unknown': '不明',
  'pages.welcomeDashboard.detail.category': 'カテゴリ',
  'pages.welcomeDashboard.detail.purpose': '目的',
  'pages.welcomeDashboard.detail.notes': 'メモ',
  'pages.welcomeDashboard.systemPromptLabel': 'システムプロンプト',
  'pages.welcomeDashboard.noSystemPromptProvided': 'システムプロンプトが指定されていません',
  'pages.welcomeDashboard.promptContentLabel': 'プロンプトの内容',
  'pages.welcomeDashboard.noPromptContentAvailable': 'プロンプトの内容がありません',
  'pages.welcomeDashboard.multiStepConfigFallback': 'マルチステップ設定',
  'pages.welcomeDashboard.detail.description': '説明',
  'pages.welcomeDashboard.stepsLabel': 'ステップ',
  'pages.welcomeDashboard.stepFallback': 'ステップ {number}',
  'pages.welcomeDashboard.templateFallback': 'テンプレート',
  'pages.welcomeDashboard.detail.target': '対象',
  'pages.welcomeDashboard.miscFallback': 'その他',
  'pages.welcomeDashboard.detail.type': '種類',
  'pages.welcomeDashboard.templateType.prose': '文章',
  'pages.welcomeDashboard.templateType.table': '表',
  'pages.welcomeDashboard.tableTypeLabel': '表の種類',
  'pages.welcomeDashboard.tableType.standard': '標準',
  'pages.welcomeDashboard.tableType.documentByDocument': 'ドキュメントごと',
  'pages.welcomeDashboard.tableType.clauseByClause': '条項ごと',
  'pages.welcomeDashboard.columnsLabel': '列',
  'pages.welcomeDashboard.sectionsLabel': 'セクション',
  'pages.welcomeDashboard.userDefinedTag': 'ユーザー定義',
  'pages.welcomeDashboard.noTemplateStructureAvailable': 'テンプレートの構成がありません',
  'pages.welcomeDashboard.questionListFallback': '質問リスト',
  'pages.welcomeDashboard.noQuestionsAvailable': '質問がありません',
};
